import {
  PC, SC, DAYS, DAY_IMG, DAY_GALLERY, DAY_INFO, SMAK, TOP10, TOP10_NOTE, BUCKET, PLACE_IMG, DAY_ROUTE_SEG, DEST_PHOTOS, DESTS, DAY_GUIDE, PACKING, CLIMATE, BUDGET_CATS,
  SOS, SAFETY, FLY_INFO, HOTEL_INFO, CHKLST, ACTION_LIST, QUICK_PROMPTS, SYSTEM_PROMPT,
  NAV, DEFAULT_SUB, FILTERS, destContent,
} from './data.js';
import { esc, irow, wbox, distKm, compressImage, haptic, withTransition, safeUrl, dataUrlToBlob } from './utils.js';
import { chip } from './ui.js';
import { renderAlertsCard, loadAlerts, reloadAlerts } from './alerts.js';
import { checkFlight, renderLiveFlight, nextFlightBanner } from './flights.js';
import {
  S, loadStorage, setSaveHook,
  saveActs, saveChk, savePackChk, saveBudget,
  saveDiary, saveComments, saveReactions,
} from './state.js';
import {
  SB_READY, MOODS, FAMILY, getSB, showToast,
  loadDiaryFromCloud, uploadPhoto,
  startRealtime,
  renderReactions, toggleReaction, loadReactionsFromCloud,
  enableFamilySync, disableFamilySync, syncAllToCloud,
  loadSharedState, updateSyncStatus, startSharedRealtime, renderSyncBanner,
} from './cloud.js';
import {
  docsInit, docsSignIn, docsSignUp, docsSignOut, docsSetAuthMode,
  docsUpload, docsView, docsDelete, renderDok, DOC_STATE, aiIndexAll,
  vaultUpload, vaultOpen, vaultRemove, vaultUnlock, vaultSavePin,
  vaultStartPin, vaultLock, vaultRemovePin, vaultCancelPin,
} from './docs.js';
import {
  renderAI, bindAI, chatKey, sendQuick, sendChat,
  destAiQuick, destAiSend,
} from './ai.js';
import { downloadICS } from './icsExport.js';
import { enqueue as syncEnqueue, pendingCount, onChange as onSyncChange, flush as syncFlush } from './syncQueue.js';
import { getErrors, clearErrors } from './errorLogger.js';
import { openQuickAsk, closeQuickAsk, toggleQuickAsk, bindQuickAskHotkey } from './quickAsk.js';
import { initPWA } from './pwa.js';
import { isVoiceSupported, startDictation } from './voice.js';
import { openVision } from './vision.js';
import { isLiveSharing, toggleLiveSharing, getPeersFresh, onPeersChange, maybeResumeLiveSharing } from './liveLocation.js';
import './styles/feltjournal.css';
import { renderBrief, bindBriefAsync } from './views/todayBrief.js';
import { renderTimeline } from './views/timeline.js';
import { initOffline, onOfflineChange, precacheTrip, refreshStatus, getOfflineState } from './offline.js';
import { refreshHearts, syncPublicFollow } from './follow.js';
import { openChangelog, closeChangelog, renderNewsPill, unseenCount } from './changelog.js';
import { renderFeltjournalMap, destroyFeltjournalMap, toggleGpsOnMap, setMapFilterFj, resizeMap as resizeMapFj } from './views/mapFeltjournal.js';
import { getRates, ageLabel as rateAgeLabel } from './rates.js';
import { renderPreflight } from './preflight.js';
import { draftReflection, summarizeDay, isEveningReflection } from './reflect.js';
import { generateForeword } from './reisebok.js';
import { shareMoment, facebookShareUrl, copyLink, PUBLIC_FOLG_URL } from './share.js';
import { makeQR } from './qr.js';
import { renderPasses, bindPasses } from './passes.js';
import { getTripMatrix, MATRIX_HOURS } from './weather.js';

let clockTimer=null;

/* ═══════════════════════ HELPERS ═══════════════════════ */
function totalChk(){return CHKLST.reduce((s,g)=>s+g.items.length,0);}
function doneChk(){return Object.values(S.chk).filter(Boolean).length;}
function totalPack(){return PACKING.reduce((s,g)=>s+g.items.length,0);}
function donePack(){return Object.values(S.packChk).filter(Boolean).length;}
function sjekkPct(){return Math.round(doneChk()/totalChk()*100);}
function cadToNok(cad){return cad*(liveRates?.["CAD-NOK"]||7.65);}

/* ═══════════════════════ NAV ═══════════════════════ */
export function renderNav(){
  const cnt=S.acts.length;
  // Sidebar — flat 5 primary
  let sb=`<div class="sb-section-label">Navigasjon</div>`;
  const authEmail=DOC_STATE.session?.user?.email||"";
  NAV.forEach(n=>{
    const badge=n.id==="reisen"&&cnt>0?`<span class="sb-badge">${cnt}</span>`:"";
    const pct=n.id==="klar"&&sjekkPct()>0?`<span style="font-size:9.5px;color:var(--t3);margin-left:2px">${sjekkPct()}%</span>`:"";
    // Grønn prikk på «Klar» (der Dokumenter bor) når man er innlogget.
    const authDot=n.id==="klar"&&authEmail?`<span title="Innlogget som ${esc(authEmail)}" style="width:8px;height:8px;border-radius:50%;background:var(--green);box-shadow:0 0 0 2px rgba(52,211,153,.25);flex-shrink:0"></span>`:"";
    sb+=`<button class="sb-item${S.tab===n.id?" active":""}" onclick="setTab('${n.id}')"><span class="sb-ic">${n.ic}</span><span style="flex:1">${n.lb}</span>${badge}${pct}${authDot}</button>`;
  });
  // Kontostatus nederst i sidemenyen — alltid synlig, viser HVEM som er innlogget.
  sb+=`<div class="sb-section-label" style="margin-top:16px">Konto</div>
    <button class="sb-item" onclick="setTab('klar','dok')" title="${authEmail?"Innlogget som "+esc(authEmail):"Ikke innlogget – trykk for å logge inn"}">
      <span class="sb-ic">${authEmail?"🔓":"🔒"}</span>
      <span style="flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px;color:${authEmail?"var(--green)":"var(--t3)"}">${authEmail?esc(authEmail):"Ikke innlogget"}</span>
      ${authEmail?`<span style="width:8px;height:8px;border-radius:50%;background:var(--green);flex-shrink:0"></span>`:""}
    </button>`;
  document.getElementById("sb-nav").innerHTML=sb;

  // Bottom nav — all 5 primary (no "Mer"). Grønn prikk på «Klar» ved innlogging.
  document.getElementById("bn-inner").innerHTML=NAV.map(n=>{
    const authDot=n.id==="klar"&&authEmail?`<span style="position:absolute;top:4px;right:calc(50% - 16px);width:7px;height:7px;border-radius:50%;background:var(--green);box-shadow:0 0 0 2px var(--bg2)"></span>`:"";
    return `<button class="bn-item${S.tab===n.id?" active":""}" onclick="setTab('${n.id}')" style="position:relative"><span class="bn-ic">${n.ic}</span><span>${n.lb}</span>${authDot}</button>`;
  }).join("");

  // Topbar title
  const cur=NAV.find(n=>n.id===S.tab);
  document.getElementById("topbar-title").textContent=cur?cur.ic+" "+cur.lb:"";
}

function setTab(id,sub){
  if(clockTimer){clearInterval(clockTimer);clockTimer=null;}
  S.tab=id;
  S.sub=sub||DEFAULT_SUB[id]||null;
  S.openDay=null;S.openAcc=null;S.destIdx=null;S.filter="Alle";
  try{ window.goatcounter?.count?.({path:"tab/"+id+(S.sub?"/"+S.sub:""),title:"Tab: "+id,event:true}); }catch{}
  S.destAiMsgs=[];S.destAiLoading=false;
  haptic('select');
  withTransition(()=>{renderNav();renderPage();});
}
function setSub(sub){S.sub=sub;if(clockTimer){clearInterval(clockTimer);clockTimer=null;}haptic('light');withTransition(()=>renderPage());}
function renderSubNav(){
  const n=NAV.find(x=>x.id===S.tab);
  if(!n||!n.subs.length) return "";
  return `<div class="sub-tabs">${n.subs.map(s=>`<button class="sub-tab${S.sub===s.id?" active":""}" onclick="setSub('${s.id}')">${s.lb}</button>`).join("")}</div>`;
}

/* ═══════════════════════ PAGE DISPATCH ═══════════════════════ */
export function renderPage(){
  const el=document.getElementById("page-content");
  el.classList.remove("fade-up");void el.offsetWidth;el.classList.add("fade-up");
  const sub=renderSubNav();
  let body="",after=null;
  if(S.tab==="idag"){
    if(S.sub==="vaer"){body=renderWeatherTab();after=()=>bindWeather();}
    else if(S.sub==="klokker"){body=renderClock();after=()=>bindClock();}
    else {body=renderIdag();after=()=>bindBriefAsync(getTripDay());}
  } else if(S.tab==="reisen"){
    switch(S.sub){
      case"kart":    body=renderKart();    after=()=>bindKart();break;
      case"topp":    body=renderBucket();break;
      case"dest":    body=renderDest();break;
      case"cruise":  body=renderCruise();break;
      case"mine":    body=renderMine();break;
      case"galleri": body=renderGalleri();break;
      case"flyt":    body=renderFlightStatus();break;
      default:       body=renderPlan();after=()=>{const cd=document.getElementById("current-day");if(cd)cd.scrollIntoView({behavior:"smooth",block:"center"});};
    }
  } else if(S.tab==="dagbok"){body=renderDagbok();after=()=>bindDagbok();}
  else if(S.tab==="klar"){
    switch(S.sub){
      case"pakk":     body=renderPakk();break;
      case"dok":      body=renderDok();break;
      case"pass":     body=renderPasses();after=()=>bindPasses();break;
      case"budsjett": body=renderBudsjett();break;
      case"valuta":   body=renderCurrency();break;
      case"tips":     body=renderTip();break;
      case"drivstoff":body=renderFuel();break;
      case"fraser":   body=renderFraser();break;
      case"sos":      body=renderSos();break;
      case"info":     body=renderInfo();break;
      default:        body=renderSjekk();
    }
  } else if(S.tab==="ai"){body=renderAI();after=()=>bindAI();}
  el.innerHTML=sub+body;
  if(after) setTimeout(after,50);
}

/* ═══════════════════════ CRUISE – Celebrity Solstice ═══════════════════════ */
function renderCruise(){
  const sections=[
    {id:"ports",title:"⚓ Havneguide — dag for dag",content:renderPortGuide()},
    {id:"overview",title:"🚢 Skipet",content:`
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:14px">
        ${[["Skipsnavn","Celebrity Solstice"],["Klasse","Solstice-class (2008)"],["Tonnasje","122 000 GT"],["Lengde","317 m"],["Passasjerer","2 852"],["Mannskap","1 271"],["Dekk","15 passasjerdekk"],["Registrert","Malta"]].map(([l,v])=>`<div style="background:var(--bg3);border-radius:var(--r3);padding:8px 10px"><div style="font-size:10px;color:var(--t3);text-transform:uppercase;font-weight:700;letter-spacing:.3px">${l}</div><div style="font-size:13px;font-weight:600;color:var(--text);margin-top:2px">${v}</div></div>`).join("")}
      </div>
      <div style="font-size:12.5px;color:var(--t1);line-height:1.7">Celebrity Solstice var det første cruiseskipet med en ekte gressbane til havs. Kjent for elegant design, prisbelønt spa og Corning Museum of Glass-samarbeid med live glassblåsing om bord.</div>
    `},
    {id:"aqua",title:"💎 Vår AquaClass-opplevelse",content:`
      <div style="background:linear-gradient(135deg,rgba(201,145,58,.12),rgba(201,145,58,.04));border:1px solid var(--gold);border-radius:var(--r2);padding:14px;margin-bottom:14px">
        <div style="font-size:14px;font-weight:700;color:var(--gold2);margin-bottom:6px">Lugar 1563 · Dekk 11 · AquaClass</div>
        <div style="font-size:12px;color:var(--t1);line-height:1.6">194 sq ft + 54 sq ft veranda · Queen-seng · Booking 6158158</div>
      </div>
      <div style="font-size:13px;font-weight:700;color:var(--text);margin-bottom:8px">Inkludert i AquaClass:</div>
      ${[
        ["🍽️","Blu restaurant","Eksklusiv restaurant kun for AquaClass – raffinert spa-inspirert meny. Frokost og middag daglig."],
        ["🧖","Persian Garden spa","Ubegrenset gratis tilgang til termalsuite: dampbad, urtebasert badstue, finsk sauna, terapeutiske dusjer og oppvarmede steinlounger med havutsikt."],
        ["⏩","Prioritet ombord","Prioritert innsjekking, embarkering og debarkering i hvert havnestopp."],
        ["🛎️","Spa-concierge","Personlig concierge for booking av spa-behandlinger med prioritet."],
        ["🛏️","Premium lugar","Exhale-sengeutstyr, putemeny, Frette badekåper og tøfler, massasjedusj."],
        ["🍳","Utvidet romservice","Eget AquaClass-menyutvalg levert til lugaren."]
      ].map(([ic,t,d])=>`<div class="day-guide-card" style="border-left:3px solid var(--gold);border:1px solid var(--border);border-left:3px solid var(--gold);border-radius:var(--r2);padding:11px 12px;margin-bottom:8px;background:var(--bg3)">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:4px"><span style="font-size:18px">${ic}</span><span style="font-size:13px;font-weight:700;color:var(--text)">${t}</span></div>
        <div style="font-size:12px;color:var(--t1);line-height:1.6">${d}</div>
      </div>`).join("")}
    `},
    {id:"dining",title:"🍽️ Restauranter",content:`
      <div style="font-size:12px;font-weight:700;color:var(--green);text-transform:uppercase;letter-spacing:.4px;margin-bottom:8px">Inkludert</div>
      ${[
        ["Blu","Dekk 5","AquaClass-eksklusiv · Spa-inspirert gourmet","var(--gold)"],
        ["Grand Epernay","Dekk 3–4","Hovedrestaurant · Flerkretters middag","var(--sky)"],
        ["Oceanview Cafe","Dekk 14","Buffet · Frokost, lunsj og middag","var(--sky)"],
        ["Mast Grill","Dekk 14","Poolside · Burgere, pizza, hotdogs","var(--sky)"]
      ].map(([n,d,desc,c])=>`<div class="day-guide-card" style="border-left:3px solid ${c};border:1px solid var(--border);border-left:3px solid ${c};border-radius:var(--r2);padding:10px 12px;margin-bottom:6px;background:var(--bg3)">
        <div style="display:flex;justify-content:space-between;align-items:center"><span style="font-size:13px;font-weight:700;color:var(--text)">${n}</span><span style="font-size:11px;color:var(--t3)">${d}</span></div>
        <div style="font-size:12px;color:var(--t1);margin-top:3px">${desc}</div>
      </div>`).join("")}
      <div style="font-size:12px;font-weight:700;color:var(--amber);text-transform:uppercase;letter-spacing:.4px;margin:14px 0 8px">Tillegg (ekstra kostnad)</div>
      ${[
        ["Murano","Dekk 5","Fransk fine dining · Tableside-tilberedning"],
        ["Tuscan Grille","Dekk 5","Italiensk steakhouse · Åpent kjøkken"],
        ["Le Petit Chef","Dekk 5","Interaktiv projeksjon-middagsopplevelse"],
        ["Sushi on Five","Dekk 5","Japansk · Sushi-bar"]
      ].map(([n,d,desc])=>`<div class="day-guide-card" style="border-left:3px solid var(--amber);border:1px solid var(--border);border-left:3px solid var(--amber);border-radius:var(--r2);padding:10px 12px;margin-bottom:6px;background:var(--bg3)">
        <div style="display:flex;justify-content:space-between;align-items:center"><span style="font-size:13px;font-weight:700;color:var(--text)">${n}</span><span style="font-size:11px;color:var(--t3)">${d}</span></div>
        <div style="font-size:12px;color:var(--t1);margin-top:3px">${desc}</div>
      </div>`).join("")}
    `},
    {id:"spa",title:"🧖 Spa & Wellness",content:`
      <div style="font-size:13px;font-weight:700;color:var(--text);margin-bottom:8px">Canyon Ranch SpaClub · Dekk 12</div>
      <div style="font-size:12px;color:var(--t1);line-height:1.7;margin-bottom:12px">Åpent 08:00–20:00. Massasje, ansiktsbehandling, kroppsskrubb, akupunktur. Salong med hår, negler og tannbleking. Treningssenter med havutsikt.</div>
      <div style="font-size:13px;font-weight:700;color:var(--text);margin-bottom:8px">Persian Garden (gratis for oss!)</div>
      ${[
        ["♨️","Aromatisk dampbad","Urteinfundert damp"],
        ["🌿","Urtebadstue","Aromatisk varmebehandling"],
        ["🔥","Finsk badstue","Klassisk tørr varme"],
        ["🚿","Terapeutiske dusjer","Tropisk regn og ulike innstillinger"],
        ["🛋️","Oppvarmede steinlounger","Havutsikt – perfekt for avslapning"]
      ].map(([ic,t,d])=>`<div style="display:flex;align-items:center;gap:10px;padding:6px 0;border-bottom:1px solid var(--border2)"><span style="font-size:16px">${ic}</span><div><span style="font-size:12.5px;font-weight:600;color:var(--text)">${t}</span><span style="font-size:11.5px;color:var(--t2);margin-left:6px">${d}</span></div></div>`).join("")}
      <div style="margin-top:14px;font-size:13px;font-weight:700;color:var(--text);margin-bottom:8px">Solarium · Dekk 12</div>
      <div style="font-size:12px;color:var(--t1);line-height:1.7">Kun for voksne – innendørs basseng med uttrekkbart glasstak. Rolig atmosfære, varmt vann, solsenger.</div>
    `},
    {id:"aktivitet",title:"🎭 Underholdning & Aktiviteter",content:`
      ${[
        ["🎭","Solstice Theater","Dekk 3–4","Broadway-produksjoner, komedie og live musikk"],
        ["🌿","The Lawn Club","Dekk 15","Ekte gressbane – bocce, krokett, putting, piknik"],
        ["🔥","Hot Glass Show","Dekk 15","Live glassblåsing med Corning Museum of Glass"],
        ["✋","Hot Glass Class","Dekk 15","Lag din egen glassfigur – ta med hjem som suvenir!"],
        ["🎬","Utendørs kino","Dekk 15","Film under stjernene på gressplenen"],
        ["🌅","Sky Observation Lounge","Dekk 14","Panoramautsikt om dagen, live musikk om kvelden"],
        ["🎰","Fortunes Casino","Dekk 4","Slots, bordspill og poker"],
        ["🎵","Quasar Nightclub","Dekk 4","DJ og dansegulv"]
      ].map(([ic,t,d,desc])=>`<div class="day-guide-card" style="border-left:3px solid var(--sky);border:1px solid var(--border);border-left:3px solid var(--sky);border-radius:var(--r2);padding:10px 12px;margin-bottom:6px;background:var(--bg3)">
        <div style="display:flex;justify-content:space-between;align-items:center"><div><span style="font-size:16px;margin-right:6px">${ic}</span><span style="font-size:13px;font-weight:700;color:var(--text)">${t}</span></div><span style="font-size:11px;color:var(--t3)">${d}</span></div>
        <div style="font-size:12px;color:var(--t1);margin-top:3px">${desc}</div>
      </div>`).join("")}
    `},
    {id:"barer",title:"🍸 Barer & Lounger",content:`
      ${[
        ["🍸","Martini Bar","Dekk 4","Is-toppet bar – klassiske og moderne martinis"],
        ["🥃","Crush","Dekk 4","100+ vodkasorter"],
        ["🍷","Cellar Masters","Dekk 4","Vinbar med smakinger"],
        ["🧪","Molecular Bar","Dekk 5","Molekylære cocktails – åpner kl 17:00"],
        ["🎹","Passport Bar","Dekk 3","Grand Foyer – live musikk"],
        ["🎷","Ensemble Lounge","Dekk 5","Pre-dinner drinks, live jazz"],
        ["☕","Cafe al Bacio","Dekk 4","Premium kaffe og bakverk"],
        ["🌅","Sunset Bar","Dekk 15","Alfresco – utsikt over skipets kjølvann"]
      ].map(([ic,t,d,desc])=>`<div style="display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid var(--border2)">
        <span style="font-size:18px">${ic}</span>
        <div style="flex:1"><div style="font-size:13px;font-weight:600;color:var(--text)">${t}</div><div style="font-size:11.5px;color:var(--t2)">${desc}</div></div>
        <span style="font-size:11px;color:var(--t3);white-space:nowrap">${d}</span>
      </div>`).join("")}
    `},
    {id:"dekk",title:"🗂️ Dekkguide",content:`
      ${[
        ["15","Lawn","Gressbane, Hot Glass, kino, Sunset Bar"],
        ["14","Lido","Oceanview Cafe, basseng, Sky Observation Lounge"],
        ["12","Resort","Canyon Ranch Spa, Persian Garden, Solarium, treningssenter"],
        ["11","Penthouse","Vår AquaClass-lugar 1563 💎"],
        ["5","Entertainment","Blu, Murano, Tuscan Grille, Sushi on Five"],
        ["4","Promenade","Martini Bar, Casino, Cafe al Bacio, butikker"],
        ["3","Plaza","Grand Epernay, Passport Bar, Solstice Theater"]
      ].map(([nr,n,desc])=>`<div style="display:flex;gap:10px;padding:9px 0;border-bottom:1px solid var(--border2);align-items:center">
        <div style="min-width:38px;height:38px;border-radius:var(--r3);background:${nr==="11"?"var(--gold)":"var(--bg3)"};display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:800;color:${nr==="11"?"#080f1a":"var(--text)"}">${nr}</div>
        <div><div style="font-size:13px;font-weight:700;color:var(--text)">${n}</div><div style="font-size:12px;color:var(--t1)">${desc}</div></div>
      </div>`).join("")}
    `}
  ];

  // Default-åpne 'ports' kun hvis brukeren aldri har interagert (undefined).
  // Eksplisitt null = brukeren kollapset, og skal forbli kollapset.
  if(S.cruiseSec===undefined) S.cruiseSec="ports";
  const openSec=S.cruiseSec;
  return`
  <div class="page-title" style="margin-bottom:2px">🚢 Celebrity Solstice</div>
  <div class="page-sub" style="margin-bottom:14px">AquaClass · Lugar 1563 · Dekk 11 · 19–26. juli 2026</div>
  ${sections.map(s=>`
    <div style="margin-bottom:6px">
      <button onclick="S.cruiseSec=S.cruiseSec==='${s.id}'?null:'${s.id}';renderPage()" class="acc-btn" aria-expanded="${openSec===s.id}" style="width:100%;display:flex;align-items:center;justify-content:space-between;padding:12px 14px;border-radius:var(--r2);border:1px solid var(--border);background:var(--card);cursor:pointer;font-family:var(--font);text-align:left">
        <span style="font-size:13.5px;font-weight:700;color:var(--text)">${s.title}</span>
        <span style="color:var(--t3);font-size:12px;transition:transform .2s;display:inline-block;transform:rotate(${openSec===s.id?'90':'0'}deg)">▶</span>
      </button>
      ${openSec===s.id?`<div style="padding:14px;background:var(--bg2);border:1px solid var(--border);border-top:none;border-radius:0 0 var(--r2) var(--r2)">${s.content}</div>`:""}
    </div>
  `).join("")}`;
}

/* ═══════════════════════ NÅ-WIDGET · FLY-STATUS · LOC-TIPS · VAULT · PORT GUIDE ═══════════════════════ */

const FLIGHT_SCHEDULE=[
  {date:"17 jul 2026",dep:"13:50",num:"FI319", al:"Icelandair",icao:"ICE",from:"OSL",to:"KEF",dur:"2t 55m"},
  {date:"17 jul 2026",dep:"17:10",num:"FI697", al:"Icelandair",icao:"ICE",from:"KEF",to:"YVR",dur:"7t 45m",term:"Terminal M"},
  {date:"02 aug 2026",dep:"12:40",num:"WS3756",al:"WestJet",   icao:"WJA",from:"YYC",to:"PDX",dur:"2t 10m"},
  {date:"02 aug 2026",dep:"19:05",num:"FI662", al:"Icelandair",icao:"ICE",from:"PDX",to:"KEF",dur:"7t 35m"},
  {date:"03 aug 2026",dep:"10:40",num:"FI322", al:"Icelandair",icao:"ICE",from:"KEF",to:"OSL",dur:"2t 45m"},
];
function flightTrackUrl(f){const n=f.num.replace(/^[A-Z]+/,"");return`https://www.flightaware.com/live/flight/${f.icao}${n}`;}

const PORT_DAYS=[
  {id:"icy",date:"21. juli",day:"Tirsdag",port:"Icy Strait Point",arr:"13:30",dep:"22:00",aboard:"21:30",em:"🐋",c:"#4ade80",
   tz:"AKDT (-8t vs Oslo)",dock:"Wilderness Landing Pier, Hoonah",
   info:"Tlingit-landsby ved Hoonah på Chichagof Island. Verdens lengste ZipRider (1,6 km, 90 km/t) og et av verdens tetteste humpback-områder nær land.",
   shuttle:"Kabelbane (SkyGlider) fra pier til Adventure Centre — inkludert. Gåavstand til landsbyen Hoonah: ~2,5 km. Gratis shuttle-buss ved behov.",
   dontmiss:["Whale watching Icy Strait Point Whale Tours — nær 100% humpback-sjanse","ZipRider fra Hoonah Mountain","Gratis: Duck Point Trail kyststi"]},
  {id:"skw",date:"22. juli",day:"Onsdag",port:"Skagway",arr:"07:00",dep:"20:00",aboard:"19:30",em:"🚂",c:"#a78bfa",
   tz:"AKDT (-8t vs Oslo)",dock:"Railroad Dock / Broadway Dock",
   info:"Historisk gullrussby fra 1898 – hele sentrum er bevart som Klondike Gold Rush National Historical Park.",
   shuttle:"Fra pier: 10 min gange til Broadway (hovedgata). SMART Bus ~$5 one-way. White Pass-toget går direkte fra cruise-kaia.",
   dontmiss:["White Pass & Yukon Route Railway — 'Summit Excursion' 3,5t","Klondike Gold Rush NHP ranger-tur (gratis)","Dewey Lakes Trail — utsikt over fjorden"]},
  {id:"jun",date:"23. juli",day:"Torsdag",port:"Juneau",arr:"13:30",dep:"20:30",aboard:"20:00",em:"🧊",c:"#22d3ee",
   tz:"AKDT (-8t vs Oslo)",dock:"Franklin Dock / AJ Dock",
   info:"Alaskas hovedstad — eneste statshovedstad i USA uten veiforbindelse. Ankomst etter morgenens cruise gjennom Endicott Arm & Dawes Glacier (05:30).",
   shuttle:"Mendenhall Glacier Blue Bus ~$45 t/r (~45 min enveis). Mount Roberts Tramway-stasjon er 5 min gange fra pier.",
   dontmiss:["Helikopter + isbrevandring på Juneau Icefield (~350 USD) — reisens topp","Mendenhall Glacier + Nugget Falls-sti","Mount Roberts Tramway for panorama"]},
  {id:"ktn",date:"24. juli",day:"Fredag",port:"Ketchikan",arr:"13:30",dep:"20:00",aboard:"19:30",em:"🐟",c:"#fbbf24",
   tz:"AKDT (-8t vs Oslo)",dock:"Berth 1-4 (pier 2-3 mest sannsynlig)",
   info:"Salmon Capital of the World. Kjent for Creek Street (hus på stylter over elva) og flest totempæler i verden.",
   shuttle:"Creek Street: 5 min gange fra pier. Totem Bight SP: taxi ~$15 eller bus #1 nord. Saxman Village: bus #1 sør.",
   dontmiss:["Misty Fjords floatplane (~350 USD, 2,5t) — Alaskas beste naturopplevelse","Creek Street + Totem Heritage Centre","King Salmon-fisketur"]},
];
function renderPortGuide(){
  return `<div style="margin-bottom:12px;font-size:12px;color:var(--t1);line-height:1.6">4 havnedager + 2 scenic cruising-dager. All-aboard er normalt 30 min før avgang — sjekk Celebrity-appen for oppdateringer.</div>
  ${PORT_DAYS.map(p=>`<div style="background:var(--card);border:1px solid var(--border);border-left:3px solid ${p.c};border-radius:var(--r2);padding:13px 14px;margin-bottom:10px">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;margin-bottom:8px">
      <div style="display:flex;align-items:center;gap:10px">
        <span style="font-size:24px">${p.em}</span>
        <div>
          <div style="font-size:14px;font-weight:800;color:var(--text)">${esc(p.port)}</div>
          <div style="font-size:11px;color:var(--t3);margin-top:1px">${p.day} ${p.date} · ${esc(p.tz)}</div>
        </div>
      </div>
    </div>
    <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:10px">
      <div style="background:var(--bg3);border-radius:var(--r3);padding:7px 8px;text-align:center">
        <div style="font-size:9px;color:var(--t3);text-transform:uppercase;font-weight:700">Ankomst</div>
        <div style="font-size:14px;font-weight:800;color:var(--green);margin-top:2px">${p.arr}</div>
      </div>
      <div style="background:var(--bg3);border-radius:var(--r3);padding:7px 8px;text-align:center">
        <div style="font-size:9px;color:var(--t3);text-transform:uppercase;font-weight:700">All-aboard</div>
        <div style="font-size:14px;font-weight:800;color:var(--amber);margin-top:2px">${p.aboard}</div>
      </div>
      <div style="background:var(--bg3);border-radius:var(--r3);padding:7px 8px;text-align:center">
        <div style="font-size:9px;color:var(--t3);text-transform:uppercase;font-weight:700">Avgang</div>
        <div style="font-size:14px;font-weight:800;color:var(--red);margin-top:2px">${p.dep}</div>
      </div>
    </div>
    <div style="font-size:11.5px;color:var(--t1);line-height:1.6;margin-bottom:8px">${esc(p.info)}</div>
    <div style="font-size:10.5px;color:var(--t3);margin-bottom:2px"><b>📍 Kai:</b> ${esc(p.dock)}</div>
    <div style="font-size:10.5px;color:var(--t2);line-height:1.6;margin-bottom:8px"><b>🚐 Transport:</b> ${esc(p.shuttle)}</div>
    <div style="background:rgba(201,145,58,.06);border-left:2px solid var(--gold);padding:8px 10px;border-radius:4px">
      <div style="font-size:10px;color:var(--gold);font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px">Ikke gå glipp av</div>
      ${p.dontmiss.map(d=>`<div style="font-size:11.5px;color:var(--t1);padding:2px 0">• ${esc(d)}</div>`).join("")}
    </div>
  </div>`).join("")}`;
}

/* ── Nå & Neste-widget ── */
function renderNowNext(){
  const now=new Date();
  const tripDay=getTripDay();
  if(tripDay<0 && now<DEPARTURE){
    const diffDays=Math.ceil((DEPARTURE-now)/86400000);
    let next="Tur bekreftet · alt booket";
    if(diffDays>14) next=`📋 Neste milepæl: 14 dager før avreise (om ${diffDays-14} dager)`;
    else if(diffDays>1) next=`✈️ Online check-in Icelandair åpner om ${diffDays-1} dager`;
    else if(diffDays===1) next="✈️ Online check-in åpner i dag · pakk kofferter";
    const pct=totalChk()?Math.round(doneChk()/totalChk()*100):0;
    return`<div style="background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:11px 13px;margin-bottom:9px">
      <div style="font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:var(--gold);margin-bottom:4px">⚡ Status nå</div>
      <div style="font-size:12.5px;color:var(--t1);line-height:1.55">${next}</div>
      <div style="font-size:11px;color:var(--t3);margin-top:5px">Sjekkliste ${pct}% · <span onclick="setTab('klar','sjekk')" style="color:var(--gold);cursor:pointer;text-decoration:underline">åpne</span> · <span onclick="setTab('klar','dok')" style="color:var(--gold);cursor:pointer;text-decoration:underline">dokumenter</span></div>
    </div>`;
  }
  if(tripDay>=0 && tripDay<DAYS.length){
    const today=DAYS[tripDay];
    const tzOff= tripDay<=2 || tripDay>=9 ? (tripDay>=9&&tripDay<=16?-6:-7) : -7;
    const nowLocal=new Date(now.getTime()+(tzOff*60+now.getTimezoneOffset())*60000);
    const curMin=nowLocal.getHours()*60+nowLocal.getMinutes();
    const timed=today.items.map(it=>{const m=it.t.match(/^(\d{1,2}):(\d{2})/);return m?{...it,min:+m[1]*60+ +m[2]}:null;}).filter(Boolean).sort((a,b)=>a.min-b.min);
    let current=null,next=null;
    for(const it of timed){ if(it.min<=curMin) current=it; else if(!next) next=it; }
    if(!next && tripDay+1<DAYS.length){
      const tom=DAYS[tripDay+1];
      const first=tom.items.find(it=>/^\d{1,2}:\d{2}/.test(it.t));
      if(first) next={...first,tomorrow:true,dayTitle:tom.title};
    }
    const hh=String(nowLocal.getHours()).padStart(2,"0"),mm=String(nowLocal.getMinutes()).padStart(2,"0");
    return`<div style="background:linear-gradient(135deg,rgba(52,211,153,.10),rgba(52,211,153,.02));border:1px solid rgba(52,211,153,.25);border-radius:var(--r);padding:12px 14px;margin-bottom:10px">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
        <span style="font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:var(--green)">🟢 Nå &amp; Neste</span>
        <span style="font-size:12px;font-weight:700;color:var(--t2);font-variant-numeric:tabular-nums">🕐 ${hh}:${mm} lokalt</span>
      </div>
      ${current?`<div style="margin-bottom:8px"><div style="font-size:10px;color:var(--t3);margin-bottom:2px">Pågår — siden ${current.t}</div><div style="font-size:13.5px;font-weight:700;color:var(--text)">${esc(current.v)}</div>${current.s?`<div style="font-size:11px;color:var(--t2);margin-top:2px">${esc(current.s)}</div>`:""}</div>`:`<div style="font-size:12px;color:var(--t3);margin-bottom:8px">Ingen pågående programpost akkurat nå</div>`}
      ${next?`<div style="padding-top:8px;border-top:1px solid var(--border2)"><div style="font-size:10px;color:var(--t3);margin-bottom:2px">Neste${next.tomorrow?` (i morgen — ${esc(next.dayTitle)})`:""} · ${next.t}</div><div style="font-size:13px;font-weight:600;color:var(--gold2)">${esc(next.v)}</div></div>`:""}
      <div style="margin-top:10px"><button onclick="requestLocationTip()" class="btn btn-xs btn-ghost" style="width:100%">📍 Hvor er jeg nå? (tips i nærheten)</button></div>
      <div id="loc-tip" style="margin-top:8px"></div>
    </div>`;
  }
  return "";
}

/* ── Location-aware tips ── */
function requestLocationTip(){
  const el=document.getElementById("loc-tip");if(!el)return;
  if(!navigator.geolocation){el.innerHTML='<div style="font-size:11px;color:var(--red);padding:6px">Posisjon støttes ikke av nettleseren</div>';return;}
  el.innerHTML='<div style="font-size:11px;color:var(--t3);padding:6px">📡 Henter posisjon…</div>';
  navigator.geolocation.getCurrentPosition(pos=>{
    const me={lat:pos.coords.latitude,lng:pos.coords.longitude};
    const stops=(typeof MAP_STOPS!=="undefined"?MAP_STOPS:[]).filter(s=>!s.id.startsWith("cr_")&&s.id!=="osl");
    if(!stops.length){el.innerHTML='<div style="font-size:11px;color:var(--t3);padding:6px">Kart ikke lastet ennå</div>';return;}
    const sorted=stops.map(s=>({...s,km:distKm(me,s)})).sort((a,b)=>a.km-b.km);
    const n=sorted[0];
    const dest=DESTS.find(d=>n.name.toLowerCase().includes(d.name.toLowerCase())||d.name.toLowerCase().includes(n.name.toLowerCase().split(" ")[0]));
    const acts=(dest?.acts||[]).slice(0,3);
    el.innerHTML=`<div style="background:var(--bg3);border:1px solid var(--border);border-radius:var(--r2);padding:10px 12px">
      <div style="font-size:10px;color:var(--t3);margin-bottom:4px">📍 Din posisjon · ${me.lat.toFixed(3)}, ${me.lng.toFixed(3)}</div>
      <div style="font-size:13px;font-weight:700;color:var(--gold2)">${n.em} Nærmeste stopp: ${esc(n.name)}</div>
      <div style="font-size:11px;color:var(--t2);margin-top:2px">${n.km<5?"🎯 Du er framme!":n.km.toFixed(0)+" km unna · "+esc(n.d||"")}</div>
      ${acts.length?`<div style="margin-top:8px;padding-top:8px;border-top:1px solid var(--border2)"><div style="font-size:10px;color:var(--t3);font-weight:700;margin-bottom:4px">TOPP TIPS HER</div>${acts.map(a=>`<div style="font-size:11.5px;color:var(--t1);padding:3px 0;line-height:1.5">• <b>${esc(a.n)}</b> — ${esc(a.p)} · ${esc(a.dur)}</div>`).join("")}</div>`:""}
    </div>`;
  },err=>{
    el.innerHTML=`<div style="font-size:11px;color:var(--red);padding:6px">Posisjon ikke tilgjengelig${err.message?": "+esc(err.message):""}</div>`;
  },{enableHighAccuracy:false,timeout:10000,maximumAge:60000});
}

/* ── Flystatus ── */
function renderFlightStatus(){
  return nextFlightBanner(FLIGHT_SCHEDULE)+`<div class="sec-lbl">✈️ Flyreiser — live-status</div>
    <div style="font-size:11px;color:var(--t3);margin-bottom:10px">Trykk «Live status» på avreisedagen for gate, forsinkelse og terminal — eller åpne FlightAware.</div>
    ${FLIGHT_SCHEDULE.map(f=>`<div style="background:var(--bg3);border:1px solid var(--border2);border-radius:var(--r2);padding:11px 13px;margin-bottom:8px">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">
        <span style="font-size:13.5px;font-weight:800;color:var(--gold2)">${f.num} · ${f.al}</span>
        <span style="font-size:10.5px;color:var(--t3)">${f.date}</span>
      </div>
      <div style="display:flex;align-items:center;gap:10px;font-size:13.5px;color:var(--text)">
        <span style="font-weight:800">${f.from}</span>
        <span style="color:var(--t3);font-size:16px">→</span>
        <span style="font-weight:800">${f.to}</span>
        <span style="color:var(--t2);margin-left:auto;font-size:11px">${f.dep} · ${f.dur}</span>
      </div>
      ${f.term?`<div style="font-size:10.5px;color:var(--t3);margin-top:3px">${esc(f.term)}</div>`:""}
      ${renderLiveFlight(f.num)}
      <div style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap">
        <button onclick="checkFlight('${f.num}')" style="display:inline-flex;align-items:center;gap:5px;padding:7px 12px;background:rgba(201,145,58,.12);border:1px solid rgba(201,145,58,.25);border-radius:var(--r3);color:var(--gold2);font-size:11.5px;font-weight:600;cursor:pointer;font-family:var(--font)">🔄 Live status</button>
        <a href="${flightTrackUrl(f)}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:5px;padding:7px 12px;background:rgba(56,189,248,.12);border:1px solid rgba(56,189,248,.25);border-radius:var(--r3);color:var(--sky);font-size:11.5px;font-weight:600;text-decoration:none;font-family:var(--font)">📡 FlightAware ↗</a>
      </div>
    </div>`).join("")}
    <div style="margin-top:14px;background:rgba(56,189,248,.08);border:1px solid rgba(56,189,248,.2);border-radius:var(--r2);padding:10px 13px">
      <div style="font-size:11px;color:var(--sky);font-weight:700;margin-bottom:4px">💡 Tips avreisedag</div>
      <div style="font-size:11.5px;color:var(--t1);line-height:1.6">Sjekk gate og forsinkelser 3 timer før avgang. <a href="https://www.icelandair.com" target="_blank" style="color:var(--gold2)">icelandair.com</a> · <a href="https://www.westjet.com" target="_blank" style="color:var(--gold2)">westjet.com</a> · <a href="https://www.avinor.no/en/airport/oslo-airport/" target="_blank" style="color:var(--gold2)">Avinor OSL</a>.</div>
    </div>`;
}


/* ═══════════════════════ DAGBOK ═══════════════════════ */
function renderDagbok(){
  if(!SB_READY) return renderDagbokSetup();
  const editing=S.diaryEdit;
  if(editing!==null) return renderDiaryEdit(editing);
  const entries=S.diary;
  const author=S.diaryAuthor||"";

  return`
  <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px">
    <div class="page-title" style="margin-bottom:0">📖 Reisedagbok</div>
    <div style="display:flex;gap:6px">
      ${entries.length>1?`<button class="btn btn-ghost btn-sm" id="reisebok-btn" onclick="makeReisebok()" title="Lag reisebok med AI-forord">📖 Reisebok</button>`:""}
      ${entries.length>0?`<button class="btn btn-ghost btn-sm" onclick="exportDiaryPDF()" title="Eksporter til PDF">📄 PDF</button>`:""}
      <button class="btn btn-gold btn-sm" onclick="newDiaryEntry()">+ Skriv</button>
    </div>
  </div>

  <!-- Author selector -->
  <div style="display:flex;gap:6px;overflow-x:auto;padding-bottom:8px;margin-bottom:12px;scrollbar-width:none;align-items:center;flex-wrap:wrap">
    <span style="font-size:11px;color:var(--t3);white-space:nowrap;flex-shrink:0">Du er:</span>
    ${FAMILY.map(f=>`<button onclick="S.diaryAuthor='${f}';try{localStorage.setItem('ca26author','${f}');}catch{}renderPage()" aria-pressed="${author===f}" style="padding:5px 13px;border-radius:20px;border:none;cursor:pointer;font-size:12px;font-weight:700;white-space:nowrap;font-family:var(--font);transition:all .15s;background:${author===f?"var(--gold)":"var(--bg3)"};color:${author===f?"var(--on-gold)":"var(--t2)"};flex-shrink:0">${author===f?"✓ ":""}${f}</button>`).join("")}
    <input id="diary-custom-name" type="text" placeholder="Eller skriv navn..." value="${!FAMILY.includes(author)&&author?esc(author):""}" onkeydown="if(event.key==='Enter'){const v=this.value.trim();if(v){S.diaryAuthor=v;try{localStorage.setItem('ca26author',v);}catch{}renderPage();}}" onblur="const v=this.value.trim();if(v){S.diaryAuthor=v;try{localStorage.setItem('ca26author',v);}catch{}renderPage();}" style="padding:5px 12px;border-radius:20px;border:1px solid ${!FAMILY.includes(author)&&author?"var(--gold)":"var(--bg4)"};background:${!FAMILY.includes(author)&&author?"var(--gold)":"transparent"};color:${!FAMILY.includes(author)&&author?"var(--on-gold)":"var(--t2)"};font-size:12px;font-weight:600;font-family:var(--font);outline:none;width:130px;flex-shrink:0">
  </div>

  <!-- Sync status -->
  <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:14px">
    <div style="font-size:11px;color:var(--t3)">${entries.length} innlegg · <span id="sync-status">${navigator.onLine?"synkronisert":"offline – viser lokal kopi"}</span></div>
    <button onclick="refreshDiary()" style="background:none;border:none;color:var(--gold);font-size:11px;cursor:pointer;font-family:var(--font);font-weight:600;padding:0" ${!navigator.onLine?"disabled":""}>↻ Oppdater</button>
  </div>

  ${renderEveningReflectionCard()}

  ${entries.length===0?`
  <div style="text-align:center;padding:50px 20px">
    <div style="font-size:52px;margin-bottom:14px">✍️</div>
    <div style="font-family:var(--serif);font-size:20px;color:var(--gold2);font-style:italic;margin-bottom:8px">Familiens reisedagbok</div>
    <div style="font-size:13px;color:var(--t2);line-height:1.7;max-width:280px;margin:0 auto">Alle i familien kan skrive, legge til bilder og lese hverandres innlegg.</div>
    <button class="btn btn-gold" style="margin-top:20px;padding:12px 28px;font-size:14px" onclick="newDiaryEntry()">✍️ Skriv første innlegg</button>
  </div>`:`
  ${entries.map(e=>renderDiaryCard(e)).join("")}
  `}`;
}

// Kveldsrefleksjon (N12): fra kl. 21 på en reisedag tilbyr vi å oppsummere
// dagen med Claude — basert på det vi faktisk skrev, brukte og fotograferte.
// Skjules etter at dagens refleksjon er laget (ca26reflectdone:<iso>).
function renderEveningReflectionCard(){
  const tripDay=getTripDay();
  if(tripDay<0||!isEveningReflection())return"";
  let done=false;
  try{done=localStorage.getItem("ca26reflectdone")===new Date().toISOString().slice(0,10);}catch{}
  if(done)return"";
  const day=DAYS[tripDay];
  const title=day?esc(day.title):"dagen";
  return`
  <div style="background:rgba(46,107,92,.08);border:1px solid rgba(46,107,92,.28);border-left:3px solid var(--aurora,#2E6B5C);border-radius:var(--r2);padding:13px 15px;margin-bottom:14px">
    <div style="display:flex;align-items:center;gap:8px;margin-bottom:5px">
      <span style="font-size:18px">🌙</span>
      <div style="font-size:13px;font-weight:800;color:var(--t1)">Kveldsrefleksjon</div>
    </div>
    <div style="font-size:12.5px;color:var(--t2);line-height:1.6;margin-bottom:11px">La Claude skrive en kladd som oppsummerer ${title} ut fra det dere noterte, brukte og fotograferte i dag. Rediger fritt etterpå.</div>
    <button class="btn btn-sm" id="evening-reflect-btn" onclick="eveningReflect()" style="background:var(--aurora,#2E6B5C);color:#fff;border:none;font-weight:700" ${!navigator.onLine?"disabled":""}>${navigator.onLine?"✨ Oppsummer dagen":"Krever nett"}</button>
  </div>`;
}

// Samler dagens faktiske data og ber Claude oppsummere → åpner et nytt
// dagbok-innlegg forhåndsfylt med kladden.
async function eveningReflect(){
  const tripDay=getTripDay();
  if(tripDay<0)return;
  if(!navigator.onLine){showToast("Kveldsrefleksjon krever nett");return;}
  if(!S.diaryAuthor){showToast("Velg hvem du er øverst på siden først");return;}
  const btn=document.getElementById("evening-reflect-btn");
  if(btn){btn.disabled=true;btn.textContent="✨ Skriver…";}
  haptic("medium");
  // Dagens dagbok-innlegg (for valgt dag) + budsjettposter ført i dag
  const todayIso=new Date().toISOString().slice(0,10);
  const diaryEntries=S.diary.filter(e=>e.dayIdx===tripDay);
  const budgetEntries=S.budgetEntries.filter(e=>e.date===todayIso);
  let text=null;
  try{ text=await summarizeDay(tripDay,{diaryEntries,budgetEntries}); }catch{}
  if(btn){btn.disabled=false;btn.textContent="✨ Oppsummer dagen";}
  if(!text){showToast("Kunne ikke hente refleksjon akkurat nå");return;}
  try{localStorage.setItem("ca26reflectdone",todayIso);}catch{}
  const info=DAY_INFO[tripDay];
  S.diaryEdit={id:"",dayIdx:tripDay,title:"",text,mood:"😊",photos:[],
    author:S.diaryAuthor,prompt:info?info.prompt:""};
  haptic("success");
  renderPage();
}

// Del et dagbok-innlegg til sosiale medier. På mobil åpnes telefonens
// delings-ark (Instagram/Snapchat/Facebook/Messenger …) — med bilde når
// innlegget har ett. På PC, der delings-arket mangler, åpnes Facebook-
// sharer og lenken kopieres (Instagram/Snapchat finnes ikke på web).
async function shareDiaryEntry(id){
  const e=S.diary.find(d=>d.id===id);
  if(!e)return;
  haptic("light");
  const day=e.dayIdx!=null?DAYS[e.dayIdx]:null;
  const title=e.title||(day?day.title:"Reisedagbok");
  const photoUrl=(e.photos||[]).map(p=>safeUrl(p)).find(u=>u&&!String(u).startsWith("data:"))||null;
  let res="fallback";
  try{ res=await shareMoment({title,text:e.text,photoUrl}); }catch{ res="fallback"; }
  if(res==="shared"){ haptic("success"); showToast("✓ Delt"); return; }
  if(res==="cancelled"){ return; }
  // PC-fallback: kopier lenke + åpne Facebook-deling
  const copied=await copyLink(PUBLIC_FOLG_URL);
  try{ window.open(facebookShareUrl(PUBLIC_FOLG_URL),"_blank","noopener,width=640,height=600"); }catch{}
  showToast(copied?"Facebook åpnet · lenke kopiert. Instagram/Snapchat deler du fra mobil 📱":"Facebook åpnet. Instagram/Snapchat deler du fra mobil 📱");
}

function renderDagbokSetup(){
  return`
  <div class="page-title">📖 Reisedagbok</div>
  <div class="page-sub">Krever Supabase-oppsett</div>
  <div class="card">
    <div style="font-size:13px;font-weight:700;color:var(--gold2);margin-bottom:10px">⚙️ Konfigurering nødvendig</div>
    <div style="font-size:13px;color:var(--t2);line-height:1.7;margin-bottom:14px">
      Åpne HTML-filen og lim inn dine Supabase-verdier øverst i JavaScript-seksjonen:
    </div>
    <div style="background:var(--bg3);border-radius:var(--r2);padding:12px;font-size:12px;font-family:monospace;color:var(--green);line-height:1.8">
      const SB_URL = "https://xxxx.supabase.co";<br>
      const SB_KEY = "din-anon-key-her";
    </div>
    <div style="font-size:12px;color:var(--t3);margin-top:12px;line-height:1.7">
      Finn verdiene i: <b style="color:var(--gold2)">Supabase → Project Settings → API</b>
    </div>
  </div>
  ${wbox("wblue","Se SQL-oppsettet i README-filen som følger med zip-pakken for å opprette tabeller og storage bucket.")}`;
}

function renderDiaryCard(e){
  const day=e.dayIdx!=null?DAYS[e.dayIdx]:null;
  const phc=day?PC[day.phase]||"#c9913a":"var(--gold)";
  const mood=MOODS.find(m=>m.e===e.mood);
  const isOpen=S["dopen_"+e.id];
  const photos=e.photos||[];
  const ts=e.ts?new Date(e.ts).toLocaleDateString("no-NO",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"}):"";
  const isOwn=e.author===S.diaryAuthor;
  const comments=S.comments[e.id]||[];

  return`<div class="diary-entry">
    <div class="diary-hdr" onclick="toggleDiaryOpen('${e.id}')">
      <div style="flex-shrink:0;width:42px;height:42px;background:${phc}22;border:1px solid ${phc}40;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px">${day?day.em:"📖"}</div>
      <div style="flex:1;min-width:0">
        <div style="font-weight:700;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(e.title||"Uten tittel")}</div>
        <div style="font-size:11px;color:var(--t3);margin-top:2px;display:flex;align-items:center;gap:7px;flex-wrap:wrap">
          ${e.author?`<span style="background:rgba(201,145,58,.15);color:var(--gold2);padding:1px 7px;border-radius:10px;font-weight:700">${esc(e.author)}</span>`:""}
          ${day?`<span style="color:${phc}">${day.d}</span>`:""}
          ${mood?`<span>${mood.e}</span>`:""}
          ${ts?`<span>${ts}</span>`:""}
          ${photos.length>0?`<span>📷 ${photos.length}</span>`:""}
          ${comments.length>0?`<span style="color:var(--sky)">💬 ${comments.length}</span>`:""}
        </div>
      </div>
      <div style="display:flex;align-items:center;gap:5px;flex-shrink:0">
        <button onclick="event.stopPropagation();shareDiaryEntry('${e.id}')" style="background:rgba(46,107,92,.14);border:none;border-radius:6px;padding:5px 8px;color:var(--gold2);cursor:pointer;font-size:12px" aria-label="Del innlegg" title="Del til Instagram, Facebook, Snapchat …">📤</button>
        ${isOwn?`<button onclick="event.stopPropagation();editDiaryEntry('${e.id}')" style="background:rgba(201,145,58,.12);border:none;border-radius:6px;padding:5px 8px;color:var(--gold);cursor:pointer;font-size:12px" aria-label="Rediger innlegg">✏️</button>
        <button onclick="event.stopPropagation();deleteDiaryEntry('${e.id}')" style="background:rgba(248,113,113,.1);border:none;border-radius:6px;padding:5px 8px;color:var(--red);cursor:pointer;font-size:12px" aria-label="Slett innlegg">🗑</button>`:""}
        <span style="color:var(--t3);font-size:11px">${isOpen?"▲":"▼"}</span>
      </div>
    </div>
    ${isOpen?`<div class="diary-body">
      ${photos.length>0?`<div class="diary-photos">${photos.map((p,pi)=>{const u=safeUrl(p);return u?`<img class="diary-photo" src="${esc(u)}" onclick="openLightbox('${e.id}',${pi})" loading="lazy">`:"";}).join("")}</div>`:""}
      ${e.text?`<div class="diary-text">${esc(e.text)}</div>`:"<div style='font-size:12px;color:var(--t3);font-style:italic;padding:4px 0'>Ingen tekst</div>"}

      <!-- REAKSJONER -->
      ${renderReactions(e.id)}

      <!-- KOMMENTARER -->
      <div style="margin-top:14px;padding-top:12px;border-top:1px solid var(--border2)">
        <div style="font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:var(--t3);margin-bottom:8px">
          💬 Kommentarer ${comments.length>0?`(${comments.length})`:""}
        </div>

        ${comments.length===0?`<div style="font-size:12px;color:var(--t3);font-style:italic;margin-bottom:10px">Ingen kommentarer ennå – vær den første!</div>`:""}

        ${comments.map(c=>{
          const initials=(c.author||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);
          const cTs=c.ts?new Date(c.ts).toLocaleDateString("no-NO",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"}):"";
          const canDelete=c.author===S.diaryAuthor||c.author===S.commentName;
          return`<div class="comment-row">
            <div class="comment-avatar">${initials}</div>
            <div style="flex:1;min-width:0">
              <div style="display:flex;align-items:baseline;gap:7px;margin-bottom:3px">
                <span style="font-size:12px;font-weight:700;color:var(--gold2)">${esc(c.author||"Anonym")}</span>
                <span style="font-size:10px;color:var(--t3)">${cTs}</span>
                ${canDelete?`<button onclick="deleteComment('${e.id}','${c.id}')" style="background:none;border:none;color:var(--t3);cursor:pointer;font-size:11px;padding:0;margin-left:auto;font-family:var(--font)" aria-label="Slett kommentar">✕</button>`:""}
              </div>
              <div style="font-size:13px;color:var(--t1);line-height:1.55">${esc(c.text)}</div>
            </div>
          </div>`;
        }).join("")}

        <!-- Skriv kommentar -->
        <div style="margin-top:10px">
          <input id="cname_${e.id}" class="fi" style="font-size:12.5px;margin-bottom:7px" placeholder="Ditt navn" value="${esc(S.commentName||"")}" oninput="S.commentName=this.value;try{localStorage.setItem('ca26cname',this.value)}catch{}">
          <div class="comment-input-row">
            <textarea id="ctxt_${e.id}" class="comment-input" placeholder="Skriv en kommentar..." rows="1" onkeydown="if(event.key==='Enter'&&!event.shiftKey){event.preventDefault();postComment('${e.id}')}"></textarea>
            <button class="comment-send" onclick="postComment('${e.id}')" title="Send" aria-label="Send kommentar">↑</button>
          </div>
        </div>
      </div>
    </div>`:""}
  </div>`;
}

function renderDiaryEdit(e){
  const isNew=!e.id;
  const author=S.diaryAuthor||"";
  // F06 — kontekstbanner med data appen allerede har, så dagboken er
  // halvferdig før brukeren setter seg ned.
  const dayIdx=typeof e.dayIdx==="number"?e.dayIdx:getTripDay();
  const ctx=dayIdx>=0&&dayIdx<DAYS.length?DAYS[dayIdx]:null;
  const today=new Date();
  const dateStr=ctx?`${ctx.wd} ${ctx.d}`:`${today.toLocaleDateString("no-NO",{weekday:"long",day:"numeric",month:"long"})}`;
  const ctxBanner=isNew&&ctx?`
    <div class="fj-diary-ctx" role="note">
      <div class="fj-diary-ctx-date">${esc(dateStr)} · Dag ${dayIdx+1} av ${DAYS.length}</div>
      <div class="fj-diary-ctx-title">${esc(ctx.title)}</div>
      <div class="fj-diary-ctx-meta">
        <span>${esc(ctx.tag||"")}</span>
        ${ctx.hotel?`<span>· ${esc(ctx.hotel)}</span>`:""}
        ${(e.photos||[]).length?`<span>· ${(e.photos||[]).length} bilder</span>`:""}
      </div>
    </div>`:"";
  return`
  <div style="display:flex;align-items:center;gap:10px;margin-bottom:16px">
    <button onclick="S.diaryEdit=null;renderPage()" style="background:none;border:none;color:var(--gold);font-size:13px;cursor:pointer;font-weight:600;font-family:var(--font);padding:0">← Tilbake</button>
    <div class="page-title" style="margin-bottom:0;flex:1">${isNew?"Nytt innlegg":"Rediger"}</div>
  </div>
  ${ctxBanner}

  ${!author?`${wbox("wred","Velg hvem du er øverst i dagboken før du skriver.")}<button class="btn btn-ghost btn-sm" style="margin-bottom:12px" onclick="S.diaryEdit=null;renderPage()">← Velg forfatter</button>`:""}

  <div class="fg"><label class="fl">Tittel</label>
    <input class="fi" id="de-title" value="${esc(e.title||"")}" placeholder="Hva skjedde?">
  </div>
  <div class="fg"><label class="fl">Dag på turen</label>
    <select class="fi" id="de-day">
      <option value="">Velg dag (valgfritt)</option>
      ${DAYS.map((d,i)=>`<option value="${i}"${e.dayIdx===i?" selected":""}>${d.d} · ${d.title}</option>`).join("")}
    </select>
  </div>
  <div class="fg"><label class="fl">Stemning</label>
    <div class="mood-row">${MOODS.map(m=>`<button class="mood-btn${e.mood===m.e?" sel":""}" onclick="setDiaryMood('${m.e}')" title="${m.l}">${m.e}</button>`).join("")}</div>
  </div>
  <div class="fg">
    <label class="fl">Bilder <span style="font-weight:400;color:var(--t3)">(lastes opp til sky)</span></label>
    <div class="diary-photos" id="de-photos-grid">
      ${(e.photos||[]).map((p,pi)=>`
        <div style="position:relative">
          <img src="${p}" loading="lazy" decoding="async" alt="" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:var(--r3)">
          <button onclick="removeDiaryPhoto(${pi})" style="position:absolute;top:4px;right:4px;background:rgba(0,0,0,.75);border:none;border-radius:50%;width:22px;height:22px;color:#fff;cursor:pointer;font-size:10px;display:flex;align-items:center;justify-content:center" aria-label="Fjern bilde">✕</button>
        </div>`).join("")}
      <label class="diary-photo-add" for="de-photo-input"><span>＋</span></label>
    </div>
    <input type="file" id="de-photo-input" accept="image/*" multiple style="display:none" onchange="addDiaryPhotos(this)">
    <input type="file" id="de-camera-input" accept="image/*" capture="environment" style="display:none" onchange="addDiaryPhotos(this)">
    <div style="display:flex;gap:8px;margin-top:8px">
      <label for="de-photo-input" style="display:inline-flex;align-items:center;gap:5px;padding:8px 14px;background:var(--bg3);border:1px solid var(--border);border-radius:var(--r3);color:var(--t1);font-size:12px;font-weight:600;cursor:pointer;font-family:var(--font)">🖼️ Velg bilder</label>
      <label for="de-camera-input" style="display:inline-flex;align-items:center;gap:5px;padding:8px 14px;background:rgba(201,145,58,.15);border:1px solid rgba(201,145,58,.3);border-radius:var(--r3);color:var(--gold2);font-size:12px;font-weight:700;cursor:pointer;font-family:var(--font)">📸 Ta bilde</label>
    </div>
    <div id="de-upload-bar" style="display:none;margin-top:8px;height:4px;background:var(--bg3);border-radius:4px;overflow:hidden"><div id="de-upload-fill" style="height:100%;width:0;background:var(--gold);transition:width .3s ease;border-radius:4px"></div></div>
    <div id="de-upload-status" style="font-size:11px;color:var(--t2);margin-top:6px"></div>
  </div>
  <div class="fg"><label class="fl" style="display:flex;justify-content:space-between;align-items:center;gap:8px"><span>Tekst / Reisenotat</span>
    <span style="display:flex;gap:6px">
    ${(e.dayIdx!=null||getTripDay()>=0)?`<button type="button" id="de-ai-btn" onclick="aiReflect()" class="mic-btn" aria-label="AI-refleksjon" title="La Claude skrive en kladd fra dagen">
      <span class="mic-ic">✨</span><span class="mic-lbl">AI-kladd</span>
    </button>`:''}
    ${isVoiceSupported()?`<button type="button" id="de-mic-btn" onclick="toggleDictation()" class="mic-btn" aria-label="Diktér" title="Diktér med stemmen (norsk)">
      <span class="mic-ic">🎙️</span><span class="mic-lbl">Diktér</span>
    </button>`:''}
    </span>
  </label>
    ${e.prompt?`<div style="background:rgba(167,139,250,.08);border:1px solid rgba(167,139,250,.25);border-left:3px solid var(--purple);border-radius:var(--r3);padding:8px 11px;margin-bottom:8px;font-size:12.5px;color:var(--t1);font-style:italic">✍️ ${esc(e.prompt)}</div>`:""}
    <textarea class="diary-edit-area" id="de-text" placeholder="${e.prompt?esc(e.prompt):'Tre punkter holder · ett bilde av dagen · én linje om det som overrasket dere'}">${esc(e.text||"")}</textarea>
    <div id="de-mic-status" class="mic-status" aria-live="polite"></div>
  </div>
  <label class="audience-toggle" for="de-public">
    <input type="checkbox" id="de-public" ${e.is_public?"checked":""}>
    <span class="audience-toggle-text">
      <strong>👁 Del dette innlegget på /folg</strong>
      <em>Avhuket = familien ser tekst og forsidebilde. Av = kun vi som reiser.</em>
    </span>
  </label>
  <button class="btn btn-gold" id="de-save-btn" style="width:100%;padding:14px;font-size:14px" onclick="saveDiaryEdit()">
    ${isNew?"📤 Lagre":"💾 Oppdater innlegg"}
  </button>`;
}

let _diaryLoading=false;
function bindDagbok(){
  if(SB_READY && navigator.onLine && S.tab==="dagbok" && !S.diaryEdit && !_diaryLoading){
    _diaryLoading=true;
    loadDiaryFromCloud().then(()=>{
      _diaryLoading=false;
      if(S.tab==="dagbok"&&!S.diaryEdit){
        const el=document.getElementById("page-content");
        el.innerHTML=renderDagbok();
      }
    }).catch(()=>{ _diaryLoading=false; });
  }
}

async function refreshDiary(){
  const el=document.getElementById("sync-status");
  if(el)el.textContent="laster...";
  await loadDiaryFromCloud();
  renderPage();
}

function newDiaryEntry(){
  if(!S.diaryAuthor){
    alert("Velg hvem du er øverst på siden først!");
    return;
  }
  S.diaryEdit={id:"",dayIdx:null,title:"",text:"",mood:"😊",photos:[],author:S.diaryAuthor};
  renderPage();
}

function editDiaryEntry(id){
  const e=S.diary.find(d=>d.id===id);
  if(e){S.diaryEdit={...e,photos:[...(e.photos||[])]};renderPage();}
}

// Åpner et nytt dagbok-innlegg for en bestemt dag, med dagens
// dagboks-spørsmål som ledetekst i skrivefeltet.
function writeDiaryForDay(dayIdx){
  const info=DAY_INFO[dayIdx];
  S.diaryEdit={id:"",dayIdx:dayIdx,title:"",text:"",mood:"😊",photos:[],
    author:S.diaryAuthor,prompt:info?info.prompt:""};
  setTab("dagbok","");
  renderPage();
}

function deleteDiaryEntry(id){
  if(!confirm("Slett dette innlegget for alle i familien?"))return;
  S.diary=S.diary.filter(d=>d.id!==id);
  saveDiary();renderPage();
  syncEnqueue({kind:"delete",table:"diary_entries",where:{id}});
}

function toggleDiaryOpen(id){
  S["dopen_"+id]=!S["dopen_"+id];
  renderPage();
}

async function postComment(entryId){
  const nameEl=document.getElementById("cname_"+entryId);
  const txtEl=document.getElementById("ctxt_"+entryId);
  const author=(nameEl?.value||S.commentName||"").trim();
  const text=(txtEl?.value||"").trim();
  if(!author){nameEl?.focus();nameEl?.setAttribute("style","border-color:var(--red);font-size:12.5px;margin-bottom:7px");return;}
  if(!text)  {txtEl?.focus();return;}

  // Save name for next time
  S.commentName=author;
  try{localStorage.setItem("ca26cname",author);}catch{}

  const comment={
    id:crypto.randomUUID?.()|| Date.now()+"",
    author,text,
    ts:Date.now()
  };

  // Optimistic update
  if(!S.comments[entryId])S.comments[entryId]=[];
  S.comments[entryId]=[...S.comments[entryId],comment];
  saveComments();
  renderPage();

  // Persist via offline-kø
  syncEnqueue({kind:"insert",table:"diary_comments",data:{
    id:comment.id,
    entry_id:entryId,
    author,
    text,
    created_at:new Date(comment.ts).toISOString()
  }});
}

function deleteComment(entryId,commentId){
  if(!confirm("Slett denne kommentaren?"))return;
  S.comments[entryId]=(S.comments[entryId]||[]).filter(c=>c.id!==commentId);
  saveComments();
  renderPage();
  syncEnqueue({kind:"delete",table:"diary_comments",where:{id:commentId}});
}

function setDiaryMood(m){
  if(!S.diaryEdit)return;
  S.diaryEdit.mood=m;
  document.querySelectorAll(".mood-btn").forEach(btn=>{
    btn.classList.toggle("sel",btn.textContent.trim()===m);
  });
}

async function addDiaryPhotos(input){
  const files=Array.from(input.files);
  if(!files.length)return;
  if(!S.diaryEdit)return;
  const status=document.getElementById("de-upload-status");
  const bar=document.getElementById("de-upload-bar");
  const fill=document.getElementById("de-upload-fill");
  if(bar)bar.style.display="block";
  // N5 — last inn foto-stempel-modul on-demand
  let stampPhotoForToday=null;
  try { ({ stampPhotoForToday } = await import('./photoStamp.js')); } catch {}
  const tripDay=getTripDay();
  const useStamp=S.diaryStamp!==false; // default på
  for(let idx=0;idx<files.length;idx++){
    if(status)status.textContent=`Forbereder ${idx+1}/${files.length}...`;
    if(fill)fill.style.width=Math.round(((idx+1)/files.length)*100)+"%";
    const preview=await compressImage(files[idx],800,0.75);
    let dataUrl=typeof preview==='string'?preview:preview?.dataUrl;
    if(useStamp && stampPhotoForToday && dataUrl){
      try { dataUrl = await stampPhotoForToday(dataUrl, tripDay); } catch(e){ console.warn('Stempel feilet', e); }
    }
    // compressImage returnerer alltid {dataUrl,mime,ext} — lagre KUN dataUrl-strengen.
    // Resten av flyten (img src, p.startsWith("data:"), opplasting) forventer strenger;
    // dyttet vi inn objektet ble forhåndsvisningen «[object Object]» og lagring kastet
    // TypeError på p.startsWith.
    if(dataUrl) S.diaryEdit.photos.push(dataUrl);
  }
  if(status)status.textContent=`${files.length} bilde(r) lagt til`;
  setTimeout(()=>{if(bar)bar.style.display="none";if(status)status.textContent="";},2000);
  renderPage();
  input.value="";
}

function removeDiaryPhoto(idx){
  if(!S.diaryEdit)return;
  S.diaryEdit.photos.splice(idx,1);
  renderPage();
}

async function saveDiaryEdit(){
  const title=(document.getElementById("de-title")?.value||"").trim();
  const text=document.getElementById("de-text")?.value||"";
  const dayVal=document.getElementById("de-day")?.value;
  const dayIdx=dayVal!==""&&dayVal!==null&&dayVal!==undefined?parseInt(dayVal):null;
  const e=S.diaryEdit;
  const author=S.diaryAuthor||"Ukjent";

  const btn=document.getElementById("de-save-btn");
  if(btn){btn.disabled=true;btn.textContent="⏳ Lagrer...";}

  const entryId=e.id||crypto.randomUUID?.()  || Date.now()+"";
  let photos=[...(e.photos||[])];

  // Upload any base64 photos that aren't already URLs
  const client=getSB();
  if(client&&navigator.onLine){
    const status=document.getElementById("de-upload-status");
    const toUpload=photos.map((p,i)=>({p,i,isBase64:p.startsWith("data:")})).filter(x=>x.isBase64);
    if(toUpload.length>0){
      const bar=document.getElementById("de-upload-bar");
      const fill=document.getElementById("de-upload-fill");
      if(bar)bar.style.display="block";
      for(let idx=0;idx<toUpload.length;idx++){
        const {p,i}=toUpload[idx];
        if(status)status.textContent=`📤 Laster opp ${idx+1}/${toUpload.length}...`;
        if(fill)fill.style.width=Math.round(((idx+1)/toUpload.length)*100)+"%";
        const blob=dataUrlToBlob(p); // ikke fetch(data:) — blokkeres av CSP connect-src
        const file=new File([blob],"photo.jpg",{type:blob.type||"image/jpeg"});
        const url=await uploadPhoto(file,entryId,i);
        if(url) photos[i]=url;
      }
      if(status)status.textContent="✅ Bilder lastet opp";
    }
  }

  const isPublic = !!document.getElementById("de-public")?.checked;

  const entry={
    id:entryId,
    day_idx:dayIdx,
    title:title||new Date().toLocaleDateString("no-NO",{day:"numeric",month:"long"}),
    text,mood:e.mood||"😊",author,
    photos,
    is_public:isPublic,
    created_at:e.ts?new Date(e.ts).toISOString():new Date().toISOString()
    // NB: ingen updated_at — kolonnen finnes ikke i diary_entries-skjemaet.
    // Sendte vi den, avviste PostgREST hele inserten, og syncQueue droppet
    // den stille → innlegget forsvant ved neste loadDiaryFromCloud.
  };

  // Persist via offline-kø
  syncEnqueue(e.id
    ? {kind:"update",table:"diary_entries",data:{...entry},where:{id:entryId}}
    : {kind:"insert",table:"diary_entries",data:{...entry}});

  // Update local state
  const local={...entry,dayIdx:entry.day_idx,ts:new Date(entry.created_at).getTime()};
  S.diary=e.id?S.diary.map(d=>d.id===entryId?local:d):[local,...S.diary];
  saveDiary();

  // N9 + P1 — auto-sync til /folg KUN hvis brukeren har huket av "Del på /folg"
  if(entry.is_public){
    const excerpt=(text||"").replace(/\s+/g," ").trim().slice(0,180);
    const photo=photos.find(p=>!p.startsWith("data:"))||null;
    syncPublicFollow({
      diary: excerpt || null,
      photo,
      stop: (dayIdx!=null && DAYS[dayIdx]) ? DAYS[dayIdx].title : undefined,
    }).catch(()=>{});
  }

  S.diaryEdit=null;
  renderPage();
}

function openLightbox(entryId,photoIdx){
  const e=S.diary.find(d=>d.id===entryId);
  if(!e||!e.photos||!e.photos[photoIdx])return;
  let cur=photoIdx;
  const lb=document.createElement("div");
  lb.className="lb-overlay";
  lb.onclick=ev=>{if(ev.target===lb)lb.remove();};
  const update=()=>{
    lb.innerHTML=`
      <div style="position:relative;display:flex;flex-direction:column;align-items:center;max-height:90vh;padding:16px;width:100%">
        <img class="lb-img" src="${esc(safeUrl(e.photos[cur]))}" style="max-width:100%;max-height:78vh;object-fit:contain;border-radius:10px">
        <div style="display:flex;justify-content:space-between;align-items:center;width:100%;margin-top:12px;max-width:400px">
          <button onclick="event.stopPropagation();cur=${cur>0?cur-1:e.photos.length-1};this.closest('.lb-overlay').children[0].querySelector('img').src=e_photos[cur]" style="background:rgba(255,255,255,.1);border:none;border-radius:50%;width:36px;height:36px;color:#fff;cursor:pointer;font-size:18px" ${e.photos.length<2?"disabled":""}>‹</button>
          <div style="display:flex;gap:8px">${e.photos.map((_,i)=>`<div style="width:8px;height:8px;border-radius:50%;background:${i===cur?"var(--gold)":"var(--t3)"};cursor:pointer" onclick="event.stopPropagation()"></div>`).join("")}</div>
          <button onclick="event.stopPropagation();cur=${cur<e.photos.length-1?cur+1:0};this.closest('.lb-overlay').children[0].querySelector('img').src=e_photos[cur]" style="background:rgba(255,255,255,.1);border:none;border-radius:50%;width:36px;height:36px;color:#fff;cursor:pointer;font-size:18px" ${e.photos.length<2?"disabled":""}>›</button>
        </div>
        <button onclick="event.stopPropagation();this.closest('.lb-overlay').remove()" style="position:absolute;top:4px;right:4px;background:rgba(0,0,0,.7);border:none;border-radius:50%;width:32px;height:32px;color:#fff;cursor:pointer;font-size:18px;display:flex;align-items:center;justify-content:center;z-index:1" aria-label="Lukk">✕</button>
      </div>`;
  };
  // Inline array reference for onclick handlers
  window._lbPhotos=e.photos;
  lb.innerHTML=`
    <div style="position:relative;display:flex;flex-direction:column;align-items:center;max-height:90vh;padding:16px;width:100%">
      <img class="lb-img" id="lb-img-main" src="${esc(safeUrl(e.photos[cur]))}" style="max-width:100%;max-height:78vh;object-fit:contain;border-radius:10px">
      <div style="display:flex;justify-content:space-between;align-items:center;width:100%;margin-top:12px;max-width:400px">
        <button id="lb-prev" style="background:rgba(255,255,255,.1);border:none;border-radius:50%;width:36px;height:36px;color:#fff;cursor:pointer;font-size:22px;line-height:1" onclick="event.stopPropagation();lbNav(-1,'${entryId}')">‹</button>
        <div id="lb-dots" style="display:flex;gap:8px">${e.photos.map((_,i)=>`<div style="width:8px;height:8px;border-radius:50%;background:${i===cur?"var(--gold)":"rgba(255,255,255,.3)"}"></div>`).join("")}</div>
        <button id="lb-next" style="background:rgba(255,255,255,.1);border:none;border-radius:50%;width:36px;height:36px;color:#fff;cursor:pointer;font-size:22px;line-height:1" onclick="event.stopPropagation();lbNav(1,'${entryId}')">›</button>
      </div>
      <button onclick="event.stopPropagation();document.querySelector('.lb-overlay').remove()" style="position:absolute;top:4px;right:4px;background:rgba(0,0,0,.7);border:none;border-radius:50%;width:32px;height:32px;color:#fff;cursor:pointer;font-size:18px;display:flex;align-items:center;justify-content:center">✕</button>
    </div>`;
  lb.dataset.cur=cur;
  lb.dataset.eid=entryId;
  document.body.appendChild(lb);
}

function lbNav(dir,entryId){
  const lb=document.querySelector(".lb-overlay");
  if(!lb)return;
  const e=S.diary.find(d=>d.id===entryId);
  if(!e||!e.photos)return;
  let cur=(parseInt(lb.dataset.cur||0)+dir+e.photos.length)%e.photos.length;
  lb.dataset.cur=cur;
  const img=document.getElementById("lb-img-main");
  if(img)img.src=e.photos[cur];
  const dots=document.getElementById("lb-dots");
  if(dots)dots.innerHTML=e.photos.map((_,i)=>`<div style="width:8px;height:8px;border-radius:50%;background:${i===cur?"var(--gold)":"rgba(255,255,255,.3)"}"></div>`).join("");
}

/* Galleri-lightbox — full versjon av utsiktsbildene i «Et glimt av dagen».
   Bla med pilene, piltastene eller ved å sveipe; lukk med ✕, Esc eller klikk utenfor. */
let _galLb = null;
function openGalleryLb(dayIdx, idx){
  const items = DAY_GALLERY[dayIdx];
  if(!items || !items[idx]) return;
  if(_galLb) closeGalleryLb();   // aldri stable to overlay oppå hverandre
  const lb = document.createElement("div");
  lb.className = "lb-overlay";
  lb.onclick = ev => { if(ev.target === lb) closeGalleryLb(); };
  _galLb = { items, cur: idx, el: lb, onKey: null };
  document.body.appendChild(lb);
  renderGalleryLb();
  _galLb.onKey = (e) => {
    if(e.key === "Escape") closeGalleryLb();
    else if(e.key === "ArrowRight") galLbNav(1);
    else if(e.key === "ArrowLeft") galLbNav(-1);
  };
  document.addEventListener("keydown", _galLb.onKey);
}
function renderGalleryLb(){
  if(!_galLb) return;
  const { items, cur } = _galLb;
  const [img, name] = items[cur];
  const many = items.length > 1;
  _galLb.el.innerHTML = `
    <div style="position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;max-height:92vh;width:100%;padding:16px">
      <img class="lb-img" src="${img}" alt="${esc(name)}" style="max-width:100%;max-height:80vh;object-fit:contain;border-radius:10px;box-shadow:0 12px 40px rgba(0,0,0,.5)">
      <div style="margin-top:14px;color:#fff;font-family:var(--serif);font-style:italic;font-size:16px;text-align:center;text-shadow:0 1px 6px rgba(0,0,0,.6)">${esc(name)}</div>
      ${many ? `<div style="margin-top:4px;color:rgba(255,255,255,.55);font-size:12px;font-weight:600">${cur+1} / ${items.length}</div>` : ""}
      ${many ? `
        <button onclick="event.stopPropagation();galLbNav(-1)" aria-label="Forrige bilde" style="position:absolute;left:8px;top:50%;transform:translateY(-50%);background:rgba(0,0,0,.55);border:none;border-radius:50%;width:46px;height:46px;color:#fff;cursor:pointer;font-size:26px;line-height:1;display:flex;align-items:center;justify-content:center">‹</button>
        <button onclick="event.stopPropagation();galLbNav(1)" aria-label="Neste bilde" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);background:rgba(0,0,0,.55);border:none;border-radius:50%;width:46px;height:46px;color:#fff;cursor:pointer;font-size:26px;line-height:1;display:flex;align-items:center;justify-content:center">›</button>` : ""}
      <button onclick="event.stopPropagation();closeGalleryLb()" aria-label="Lukk" style="position:absolute;top:8px;right:8px;background:rgba(0,0,0,.7);border:none;border-radius:50%;width:36px;height:36px;color:#fff;cursor:pointer;font-size:20px;line-height:1;display:flex;align-items:center;justify-content:center">✕</button>
    </div>`;
}
function galLbNav(dir){
  if(!_galLb) return;
  const n = _galLb.items.length;
  _galLb.cur = (_galLb.cur + dir + n) % n;
  renderGalleryLb();
}
function closeGalleryLb(){
  if(!_galLb) return;
  if(_galLb.onKey) document.removeEventListener("keydown", _galLb.onKey);
  _galLb.el.remove();
  _galLb = null;
}

/* ═══════════════════════ PLAN ═══════════════════════ */
function renderFamilyWidget(){
  const on = isLiveSharing();
  const peers = getPeersFresh();
  if (!on && peers.length === 0) {
    // Kompakt opt-in
    return `<div class="family-widget family-off" onclick="toggleFamilyShare()" role="button" tabindex="0" aria-label="Aktiver posisjonsdeling">
      <div class="fw-ic">📍</div>
      <div class="fw-tx">
        <div class="fw-h">Del posisjon med familien</div>
        <div class="fw-s">Se hvor Margita / Robert er — i sanntid på reisen</div>
      </div>
      <div class="fw-go">Aktiver →</div>
    </div>`;
  }
  // Aktiv eller har peers
  const peerRows = peers.map(p => {
    const battery = p.battery != null ? ` · 🔋 ${p.battery}%` : '';
    const accuracy = p.accuracy ? ` · ±${p.accuracy} m` : '';
    const ageTxt = p.stale ? `<span class="fw-stale">utdatert</span>`
                : p.ageMin < 1 ? 'akkurat nå'
                : p.ageMin < 60 ? `${p.ageMin} min siden`
                : `${Math.round(p.ageMin/60)}t siden`;
    const dot = p.stale ? 'fw-dot-stale' : 'fw-dot-fresh';
    const gmap = `https://www.google.com/maps?q=${p.lat},${p.lng}`;
    return `<a class="fw-peer" href="${gmap}" target="_blank" rel="noopener" onclick="event.stopPropagation()">
      <span class="fw-dot ${dot}"></span>
      <div class="fw-peer-tx">
        <div class="fw-peer-name">${esc(p.name)}</div>
        <div class="fw-peer-meta">${ageTxt}${accuracy}${battery}</div>
      </div>
      <span class="fw-arrow">↗</span>
    </a>`;
  }).join('');
  const meRow = on
    ? `<div class="fw-me"><span class="fw-dot fw-dot-fresh"></span> Du deler posisjon</div>`
    : '';
  return `<div class="family-widget family-on">
    <div class="fw-head">
      <div class="fw-h">📍 Familien nå</div>
      <button class="fw-toggle" onclick="toggleFamilyShare()" aria-label="${on?'Stopp':'Start'} deling">
        ${on?'Stopp':'Start'}
      </button>
    </div>
    ${meRow}
    ${peerRows || '<div class="fw-empty">Ingen andre deler posisjon enda.</div>'}
  </div>`;
}

function toggleFamilyShare(){
  toggleLiveSharing();
  // Oppdater UI etter en kort tid (Promise oppløses ved første GPS-fix)
  setTimeout(() => renderPage(), 200);
}

function renderIdag(){
  const quick=[
    {ic:"🗓",lb:"Dag for dag",t:"reisen",s:"plan"},
    {ic:"🗺️",lb:"Kart",t:"reisen",s:"kart"},
    {ic:"🚢",lb:"Cruise",t:"reisen",s:"cruise"},
    {ic:"✈️",lb:"Flystatus",t:"reisen",s:"flyt"},
    {ic:"☑️",lb:"Sjekkliste",t:"klar",s:"sjekk"},
    {ic:"🔐",lb:"Dokumenter",t:"klar",s:"dok"},
    {ic:"📖",lb:"Dagbok",t:"dagbok",s:""},
    {ic:"✨",lb:"Spør AI",t:"ai",s:""},
  ];

  // Feltjournal er nå default — brief + tidslinje er hovedinngangen
  const tripDay = getTripDay();
  return renderBrief(tripDay) + renderAlertsCard() + renderOfflineReadiness() + renderTimeline(tripDay) + renderFamilyWidget();

  // Gammel hjem-vy (beholdt for fallback hvis brukeren bytter til mørk/lys tema)
  // eslint-disable-next-line no-unreachable
  return renderTimelineHero()+renderNowNext()+renderNotifBanner()+renderFamilyWidget()+
    `<div class="sec-lbl" style="margin-top:8px">Hurtig</div>
     <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:7px;margin-bottom:16px">
      ${quick.map(q=>`<button onclick="setTab('${q.t}'${q.s?`,'${q.s}'`:""})" style="background:var(--bg3);border:1px solid var(--border2);border-radius:var(--r2);padding:12px 4px;cursor:pointer;text-align:center;font-family:var(--font);color:var(--t1);transition:all .15s">
        <div style="font-size:20px;margin-bottom:4px">${q.ic}</div>
        <div style="font-size:10.5px;font-weight:600;line-height:1.25">${q.lb}</div>
      </button>`).join("")}
     </div>`;
}

function renderTimelineHero(){
  const now=new Date();
  const tripDay=getTripDay();
  const totalDays=DAYS.length;
  if(now>RETURN){
    return`<div style="background:linear-gradient(135deg,rgba(201,145,58,.12),rgba(201,145,58,.04));border:1px solid rgba(201,145,58,.25);border-radius:var(--r);padding:16px;margin-bottom:14px;text-align:center">
      <div style="font-size:28px;margin-bottom:6px">🍁</div>
      <div style="font-size:15px;font-weight:700;color:var(--gold2)">Turen er over!</div>
      <div style="font-size:12px;color:var(--t2);margin-top:4px">${totalDays} dager · 9 destinasjoner · Vancouver → Calgary</div>
    </div>`;
  }
  if(tripDay>=0){
    const today=DAYS[tripDay];
    const tomorrow=DAYS[tripDay+1];
    const phc=PC[today.phase]||"#c9913a";
    const pct=Math.round(((tripDay+1)/totalDays)*100);
    return`<div style="background:linear-gradient(135deg,${phc}18,${phc}08);border:1px solid ${phc}35;border-radius:var(--r);padding:16px;margin-bottom:14px">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
        <span style="font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:var(--green)">🟢 På tur!</span>
        <span style="font-size:11px;font-weight:700;color:var(--t2)">Dag ${tripDay+1} av ${totalDays}</span>
      </div>
      <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">
        <span style="font-size:28px">${today.em}</span>
        <div>
          <div style="font-size:16px;font-weight:800;color:var(--text)">${esc(today.title)}</div>
          <div style="font-size:12px;color:var(--t2);margin-top:2px">${today.wd} ${today.d}${today.hotel?" · "+esc(today.hotel):""}</div>
        </div>
      </div>
      <div class="prog" style="margin-bottom:6px"><div class="prog-fill" style="width:${pct}%;background:${phc}"></div></div>
      ${tomorrow?`<div style="font-size:11px;color:var(--t3)">Neste: ${tomorrow.em} ${esc(tomorrow.title)} — ${tomorrow.wd} ${tomorrow.d}</div>`:`<div style="font-size:11px;color:var(--gold)">🎉 Siste dag på turen!</div>`}
    </div>`;
  }
  const diff=DEPARTURE-now;
  const days=Math.floor(diff/86400000);
  const hrs=Math.floor((diff%86400000)/3600000);
  const pct=Math.max(0,Math.min(100,Math.round((1-diff/(90*86400000))*100)));
  return`<div style="background:linear-gradient(135deg,rgba(201,145,58,.12),rgba(201,145,58,.04));border:1px solid rgba(201,145,58,.25);border-radius:var(--r);padding:16px;margin-bottom:14px;text-align:center">
    <div style="font-size:28px;margin-bottom:6px">✈️</div>
    <div style="font-size:22px;font-weight:800;color:var(--gold2)">${days} dager</div>
    <div style="font-size:12px;color:var(--t2);margin-top:2px">og ${hrs} timer til avreise</div>
    <div class="prog" style="margin-top:10px"><div class="prog-fill" style="width:${pct}%;background:var(--gold)"></div></div>
    <div style="font-size:10.5px;color:var(--t3);margin-top:6px">17. juli · Oslo → Vancouver med Icelandair</div>
  </div>`;
}

// Utsiktsbilde for et sted langs ruten — første regel som matcher navnet vinner.
function placeImg(name){
  if(!name)return"";
  for(const [re,src] of PLACE_IMG){ if(re.test(name)) return src; }
  return"";
}

// Galleri-stripe: minst 5 utsiktsbilder for dagen, fra DAY_GALLERY.
// Biltur-/naturdager får overskriften «Severdigheter langs ruten».
function renderDayGallery(dayIdx){
  const items=DAY_GALLERY[dayIdx];
  if(!items||items.length<2)return"";
  const hdr=DAY_ROUTE_SEG[dayIdx]?"Severdigheter langs ruten":"Et glimt av dagen";
  return`<div style="margin:2px 0 12px">
    <div style="font-size:9.5px;font-weight:800;color:var(--gold);text-transform:uppercase;letter-spacing:1px;margin-bottom:7px">📸 ${hdr}</div>
    <div style="display:flex;gap:9px;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding-bottom:2px">
      ${items.map(([img,name],gi)=>`<div style="flex-shrink:0;width:150px">
        <div onclick="event.stopPropagation();openGalleryLb(${dayIdx},${gi})" role="button" tabindex="0" aria-label="Vis ${esc(name)} i full størrelse" onkeydown="if(event.key==='Enter'||event.key===' '){event.stopPropagation();event.preventDefault();openGalleryLb(${dayIdx},${gi})}" style="position:relative;height:96px;border-radius:10px;overflow:hidden;cursor:pointer">
          <img src="${img}" alt="${esc(name)}" loading="lazy" style="width:100%;height:100%;object-fit:cover">
          <div style="position:absolute;inset:0;background:linear-gradient(180deg,transparent 40%,rgba(0,0,0,.7) 100%)"></div>
          <div style="position:absolute;top:6px;right:6px;background:rgba(0,0,0,.45);border-radius:6px;padding:2px 5px;font-size:11px;line-height:1">🔍</div>
          <div style="position:absolute;left:8px;right:8px;bottom:6px;color:#fff;font-size:11px;font-weight:700;line-height:1.25;text-shadow:0 1px 4px rgba(0,0,0,.7)">${esc(name)}</div>
        </div>
      </div>`).join("")}
    </div>
  </div>`;
}

// Høydepunkter — avkrysningsliste over «øyeblikk dere ikke må gå glipp av».
function renderBucket(){
  const done=BUCKET.filter((_,i)=>S.chk["bkt_"+i]).length;
  const pct=Math.round(done/BUCKET.length*100);
  return`<div class="page-title">Høydepunkter</div><div class="page-sub">${BUCKET.length} øyeblikk å oppleve · kryss av underveis</div>
  <div style="background:linear-gradient(135deg,rgba(201,145,58,.12),rgba(201,145,58,.04));border:1px solid rgba(201,145,58,.25);border-radius:var(--r);padding:14px 16px;margin-bottom:14px">
    <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:8px">
      <span style="font-size:13px;font-weight:700;color:var(--gold2)">${done} av ${BUCKET.length} opplevd</span>
      <span style="font-size:22px;font-weight:800;color:var(--gold)">${pct}%</span>
    </div>
    <div class="prog"><div class="prog-fill" style="width:${pct}%;background:var(--gold)"></div></div>
  </div>
  ${BUCKET.map((b,i)=>{const on=!!S.chk["bkt_"+i];const day=DAYS[b.day];const dayMeta=day?`Dag ${b.day+1} · ${day.wd} ${day.d} · ${day.title}`:`Dag ${b.day+1}`;return`<div onclick="toggleChk('bkt_${i}')" style="display:flex;align-items:flex-start;gap:11px;padding:12px 13px;margin-bottom:7px;background:${on?"rgba(52,211,153,.08)":"var(--bg2)"};border:1px solid ${on?"rgba(52,211,153,.3)":"var(--border)"};border-radius:var(--r2);cursor:pointer;transition:all .15s">
    <div style="width:24px;height:24px;border-radius:7px;flex-shrink:0;display:flex;align-items:center;justify-content:center;background:${on?"var(--green)":"transparent"};border:2px solid ${on?"var(--green)":"var(--border2)"};margin-top:1px">${on?'<span style="color:#04130c;font-size:13px;font-weight:900">✓</span>':""}</div>
    <span style="font-size:19px;flex-shrink:0;line-height:1.2;${on?"":"filter:grayscale(.3)"}">${b.em}</span>
    <div style="flex:1;min-width:0">
      <div style="font-size:13.5px;line-height:1.4;color:${on?"var(--t3)":"var(--t1)"};text-decoration:${on?"line-through":"none"}">${esc(b.t)}</div>
      <button onclick="event.stopPropagation();setTab('reisen','plan');S.openDay=${b.day};renderPage()" title="Gå til ${esc(day?day.title:'dagen')} i planen" style="display:inline-flex;align-items:center;gap:4px;margin-top:5px;padding:0;background:none;border:none;color:var(--gold2);font-size:11px;font-weight:600;cursor:pointer;font-family:var(--font);text-align:left;line-height:1.3">${esc(dayMeta)} <span style="opacity:.7">→</span></button>
    </div>
  </div>`;}).join("")}`;
}

// Per-dag innholdskort: fototips, «Visste du at?» og dagboks-spørsmål.
function renderDayInfo(dayIdx){
  const info=DAY_INFO[dayIdx];
  if(!info)return"";
  const card=(ic,lbl,txt,col)=>`<div style="flex:1;min-width:180px;background:var(--bg2);border:1px solid ${col}33;border-left:3px solid ${col};border-radius:var(--r2);padding:10px 12px">
    <div style="font-size:9.5px;font-weight:800;color:${col};text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px">${ic} ${lbl}</div>
    <div style="font-size:12px;color:var(--t1);line-height:1.55">${esc(txt)}</div></div>`;
  return`<div style="display:flex;flex-wrap:wrap;gap:8px;margin:2px 0 12px">
    ${info.foto?card("📷","Fototips",info.foto,"#38bdf8"):""}
    ${info.fact?card("💡","Visste du at?",info.fact,"#c9913a"):""}
    ${info.prompt?`<div style="flex:1;min-width:180px;background:rgba(167,139,250,.07);border:1px solid rgba(167,139,250,.25);border-left:3px solid var(--purple);border-radius:var(--r2);padding:10px 12px">
      <div style="font-size:9.5px;font-weight:800;color:var(--purple);text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px">✍️ Dagboks-spørsmål</div>
      <div style="font-size:12px;color:var(--t1);line-height:1.55;font-style:italic;margin-bottom:7px">${esc(info.prompt)}</div>
      <button onclick="event.stopPropagation();writeDiaryForDay(${dayIdx})" style="background:var(--purple);color:#fff;border:none;border-radius:var(--r3);padding:6px 11px;font-size:11px;font-weight:700;cursor:pointer;font-family:var(--font)">✍️ Skriv i dagboken</button>
    </div>`:""}
  </div>`;
}

function renderPlan(){
  const tripDay=getTripDay();
  return `<div class="page-title">Dag for dag</div><div class="page-sub">18 dager · 9 destinasjoner · trykk for å utvide</div>`+
  DAYS.map((day,i)=>{
    const o=S.openDay===i,phc=PC[day.phase]||"#c9913a";
    const isCurrent=tripDay===i;
    const phase=day.phase||"city";
    const hotelChip=day.hotel?`<span class="chip chip-hotel" title="${esc(day.hotel)}">🏨 ${esc(day.hotel.length>22?day.hotel.slice(0,22)+"…":day.hotel)}</span>`:"";
    const heroImg=DAY_IMG[i]||"";
    return`<div class="day-card${o?" open":""}${isCurrent?" day-current":""}" onclick="toggleDay(${i})" role="button" tabindex="0" ${isCurrent?'id="current-day"':''} aria-expanded="${o}">
      <div class="day-hero phase-${phase}${heroImg?" has-img":""}">
        ${heroImg?`<img class="day-hero-img" src="${heroImg}" alt="" loading="lazy">`:""}
        <span class="day-hero-em" aria-hidden="true">${day.em}</span>
        <div class="day-hero-meta">
          <span class="day-hero-date">Dag ${i+1} · ${day.wd} ${day.d}</span>
          <span class="day-hero-title">${esc(day.title)}</span>
        </div>
      </div>
      <div class="day-body">
        <div class="day-chips">
          <span class="chip chip-phase" style="background:${phc}1f;color:${phc};border-color:${phc}40">${esc(day.tag)}</span>
          ${isCurrent?'<span class="chip chip-current">● I dag</span>':''}
          ${hotelChip}
        </div>
        <span class="day-toggle" aria-hidden="true">▼</span>
      </div>
    </div>
    ${o?`<div class="day-exp" style="border-color:${phc}28">
      ${day.items.map(it=>{
        // F09 — fargede ankere: fly=maple, cruise=navy, hotell=gold, default=phase
        const lc=(it.v+" "+(it.s||"")).toLowerCase();
        const anchor=
          /\bfly|icelandair|air canada|avgang.*lhr|ankomst.*yvr|terminal|gate|bekreftelses/i.test(lc)?'fly':
          /cruise|embarker|debarker|celebrity|solstice|seapass|inside passage|lugar|pier|cruising/i.test(lc)?'cruise':
          /check-in|check-out|hotel|hotell|king|suite|natt|overnatting/i.test(lc)?'hotel':
          /utflukt|tour|guidet|booket|excursion/i.test(lc)?'tour':'default';
        const ac={fly:'#B84A2E',cruise:'#0E2238',hotel:'#C99A3B',tour:'#2E6B5C',default:phc}[anchor];
        return`<div class="fj-anchor-item" data-anchor="${anchor}" style="display:flex;gap:11px;margin-bottom:9px;align-items:flex-start;padding-left:10px;border-left:2px solid ${ac}">
          <div style="width:50px;font-size:10px;color:${ac};font-weight:700;flex-shrink:0;padding-top:2px">${esc(it.t)}</div>
          <div><div style="font-size:13px;font-weight:500;color:var(--t1)">${esc(it.v)}</div>${it.s?`<div style="font-size:11px;color:var(--t3);margin-top:2px;line-height:1.5">${esc(it.s)}</div>`:""}</div>
        </div>`;
      }).join("")}
      ${day.split?`<div style="margin-top:10px;padding:11px 13px;background:rgba(167,139,250,.08);border-radius:10px;border:1px solid rgba(167,139,250,.28)">
        <div style="font-size:9.5px;color:var(--purple);font-weight:800;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px">👤 ${esc(day.split.title)}</div>
        ${day.split.lines.map(l=>`<div style="font-size:12px;color:var(--t1);line-height:1.6;margin-bottom:3px">${esc(l)}</div>`).join("")}
        ${day.split.foot?`<div style="font-size:11px;color:var(--t3);margin-top:7px;padding-top:6px;border-top:1px solid var(--border);line-height:1.5">${esc(day.split.foot)}</div>`:""}
      </div>`:""}
      ${day.hotel?`<div style="margin-top:10px;padding:11px 13px;background:rgba(201,145,58,.07);border-radius:10px;border:1px solid rgba(201,145,58,.22)">
        <div style="font-size:9.5px;color:var(--gold);font-weight:800;text-transform:uppercase;letter-spacing:1px;margin-bottom:5px">🏨 Overnatting</div>
        <a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent((day.hadr?day.hadr+", ":"")+day.hotel)}" target="_blank" rel="noopener" title="Åpne ${esc(day.hotel)} i kart" style="display:inline-flex;align-items:center;gap:5px;font-size:13.5px;font-weight:700;color:var(--gold2);text-decoration:none;border-bottom:1px solid rgba(201,145,58,.45)">${esc(day.hotel)} <span style="font-size:10px;opacity:.7">↗</span></a>
        ${day.hci?`<div style="font-size:11px;color:var(--t2);margin-top:3px">${esc(day.hci)}</div>`:""}
        ${day.href?`<div style="font-size:10.5px;color:var(--t3);margin-top:2px">Ref: ${esc(day.href)}</div>`:""}
        ${day.hadr?`<div style="font-size:10.5px;color:var(--t3)">${esc(day.hadr)}</div>`:""}
        ${day.htel?`<div style="font-size:12px;color:var(--sky);margin-top:4px;font-weight:600">📞 ${esc(day.htel)}</div>`:""}
        <div style="display:flex;gap:6px;margin-top:8px;flex-wrap:wrap">
          ${day.htel?`<a href="tel:${day.htel.replace(/\s/g,"")}" style="display:inline-flex;align-items:center;gap:5px;padding:7px 12px;background:rgba(56,189,248,.12);border:1px solid rgba(56,189,248,.25);border-radius:var(--r3);color:var(--sky);font-size:11.5px;font-weight:600;text-decoration:none;font-family:var(--font)">📞 Ring</a>`:""}
          ${day.hadr?`<a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(day.hadr+(day.hotel?", "+day.hotel:""))}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:5px;padding:7px 12px;background:rgba(52,211,153,.12);border:1px solid rgba(52,211,153,.25);border-radius:var(--r3);color:var(--green);font-size:11.5px;font-weight:600;text-decoration:none;font-family:var(--font)">🗺️ Navigér</a>`:""}
          ${(HOTEL_INFO.find(h=>h.n===day.hotel)?.web)?`<a href="${HOTEL_INFO.find(h=>h.n===day.hotel).web}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:5px;padding:7px 12px;background:rgba(201,145,58,.12);border:1px solid rgba(201,145,58,.25);border-radius:var(--r3);color:var(--gold2);font-size:11.5px;font-weight:600;text-decoration:none;font-family:var(--font)">🌐 Hotellside</a>`:""}
          ${(day.hadr||HOTEL_INFO.some(h=>h.n===day.hotel))?`<a href="${taLink(day.hotel,day.hadr||(HOTEL_INFO.find(h=>h.n===day.hotel)?.adr)||"")}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:5px;padding:7px 12px;background:rgba(52,211,153,.1);border:1px solid rgba(52,211,153,.28);border-radius:var(--r3);color:var(--green);font-size:11.5px;font-weight:600;text-decoration:none;font-family:var(--font)">🦉 TripAdvisor</a>`:""}
          <button onclick="shareDayPlan(${i})" style="display:inline-flex;align-items:center;gap:5px;padding:7px 12px;background:rgba(167,139,250,.12);border:1px solid rgba(167,139,250,.25);border-radius:var(--r3);color:var(--purple);font-size:11.5px;font-weight:600;cursor:pointer;font-family:var(--font)">📤 Del</button>
        </div>
      </div>`:""}
      ${renderDayGallery(i)}
      ${renderDayInfo(i)}
      ${DAY_GUIDE[i]?renderDayGuide(i):""}
    </div>`:""}`;
  }).join("");
}

// TripAdvisor-søkelenke bygget av navn + by (fra adressen) — alltid gyldig,
// ingen skjøre side-ID-er å gjette på.
function taLink(name,adr){
  const city=(adr||"").split(",").pop().trim();
  const q=encodeURIComponent([name,city].filter(Boolean).join(" "));
  return "https://www.tripadvisor.com/Search?q="+q;
}
// By-kontekst per guide-dag — brukes for TripAdvisor-søk på aktiviteter/severdigheter
// som ikke har egen adresse.
const GUIDE_CITY={1:"Vancouver",2:"Vancouver",4:"Icy Strait Point Alaska",5:"Skagway Alaska",6:"Juneau Alaska",7:"Ketchikan Alaska",9:"Kamloops BC",10:"Jasper",11:"Jasper",12:"Icefields Parkway",13:"Banff",14:"Calgary",15:"Calgary"};
// TripAdvisor-knapp (grønn) — gjenbrukes for restaurant/aktivitet/severdighet.
const taBtn=(name,loc)=>`<a href="${taLink(name,loc)}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:4px;background:rgba(52,211,153,.1);border:1px solid rgba(52,211,153,.28);border-radius:6px;padding:5px 10px;color:var(--green);font-size:11.5px;font-weight:600;text-decoration:none">🦉 TripAdvisor</a>`;

function renderDayGuide(dayIdx){
  const g=DAY_GUIDE[dayIdx];
  if(!g)return"";
  const c=g.c||"#c9913a";
  const gcity=GUIDE_CITY[dayIdx]||"";
  const tabKey="dgt_"+dayIdx;
  const cur=S["dgt"+dayIdx]||"acts";
  const tabs=[
    g.acts?.length  ? {id:"acts",ic:"✨",lb:"Aktiviteter"} : null,
    g.eat?.length   ? {id:"eat", ic:"🍽️",lb:"Mat & drikke"} : null,
    g.see?.length   ? {id:"see", ic:"📷",lb:"Se & opplev"} : null,
  ].filter(Boolean);
  if(!tabs.length)return"";
  return`<div class="day-guide-wrap" style="margin-top:13px;background:var(--bg2);border:1px solid ${c}28;border-radius:var(--r);overflow:hidden">
    <div style="display:flex;border-bottom:1px solid ${c}22">
      ${tabs.map(t=>`<button onclick="S['dgt${dayIdx}']='${t.id}';renderPage();S.openDay=${dayIdx}" style="flex:1;padding:9px 4px;border:none;cursor:pointer;font-size:10.5px;font-weight:700;font-family:var(--font);transition:all .15s;background:${cur===t.id?"rgba(201,145,58,.12)":"transparent"};color:${cur===t.id?c:"var(--t3)"};border-bottom:${cur===t.id?`2px solid ${c}`:"2px solid transparent"}">${t.ic} ${t.lb}</button>`).join("")}
    </div>
    <div style="padding:12px">
      ${cur==="acts"&&g.acts?g.acts.map(a=>`
        <div style="border:1px solid ${c}30;border-left:3px solid ${c};border-radius:var(--r2);overflow:hidden;margin-bottom:8px;background:var(--bg3)" class="day-guide-card">
          ${placeImg(a.n)?`<img src="${placeImg(a.n)}" alt="${esc(a.n)}" loading="lazy" style="width:100%;height:120px;object-fit:cover;display:block">`:""}
          <div style="padding:11px 12px">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;margin-bottom:5px">
            <span style="font-size:10px;font-weight:800;color:${c};text-transform:uppercase;letter-spacing:.4px">${esc(a.rank)}</span>
            <span style="font-size:12px;font-weight:700;color:var(--gold);white-space:nowrap">${esc(a.p)}</span>
          </div>
          <div style="font-size:13.5px;font-weight:700;color:var(--text);margin-bottom:2px">${esc(a.n)}</div>
          <div style="font-size:11.5px;color:var(--t2);margin-bottom:6px;font-style:italic">${esc(a.op)}</div>
          <div style="font-size:12px;color:var(--t1);line-height:1.6;margin-bottom:9px">${esc(a.tip)}</div>
          <div style="display:flex;flex-wrap:wrap;gap:6px">
            ${taBtn(a.n,gcity)}
            ${a.ph?`<a href="tel:${a.ph}" style="display:inline-flex;align-items:center;gap:4px;background:rgba(56,189,248,.1);border:1px solid rgba(56,189,248,.25);border-radius:6px;padding:5px 10px;color:var(--sky);font-size:11.5px;font-weight:600;text-decoration:none;-webkit-user-select:none">📞 ${esc(a.ph)}</a>`:""}
            ${a.web?`<a href="${a.web}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:4px;background:rgba(201,145,58,.1);border:1px solid rgba(201,145,58,.25);border-radius:6px;padding:5px 10px;color:var(--gold2);font-size:11.5px;font-weight:600;text-decoration:none">🌐 Nettside</a>`:""}
          </div>
          </div>
        </div>`).join(""):""}
      ${cur==="eat"&&g.eat?g.eat.map(r=>`
        <div style="border:1px solid ${c}30;border-left:3px solid ${c};border-radius:var(--r2);padding:11px 12px;margin-bottom:8px;background:var(--bg3)" class="day-guide-card">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;margin-bottom:4px">
            <div>
              <span style="font-size:16px;margin-right:6px">${r.ic||"🍽️"}</span>
              <span style="font-size:13.5px;font-weight:700;color:var(--text)">${esc(r.n)}</span>
            </div>
            <span style="font-size:11.5px;font-weight:600;color:var(--gold);white-space:nowrap">${esc(r.p)}</span>
          </div>
          <div style="font-size:10px;font-weight:800;color:${c};text-transform:uppercase;letter-spacing:.5px;margin-bottom:5px">${esc(r.type)}</div>
          <div style="font-size:12px;color:var(--t1);line-height:1.6;margin-bottom:8px">${esc(r.tip)}</div>
          <div style="display:flex;flex-wrap:wrap;gap:6px">
            ${r.adr?`<span style="font-size:11px;color:var(--t3);display:inline-flex;align-items:center;gap:3px">📍 ${esc(r.adr)}</span>`:""}
          </div>
          <div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:${r.adr?"6px":"0"}">
            ${taBtn(r.n,r.adr)}
            ${r.ph?`<a href="tel:${r.ph}" style="display:inline-flex;align-items:center;gap:4px;background:rgba(56,189,248,.1);border:1px solid rgba(56,189,248,.25);border-radius:6px;padding:5px 10px;color:var(--sky);font-size:11.5px;font-weight:600;text-decoration:none">📞 ${esc(r.ph)}</a>`:""}
            ${r.web?`<a href="${r.web}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:4px;background:rgba(201,145,58,.1);border:1px solid rgba(201,145,58,.25);border-radius:6px;padding:5px 10px;color:var(--gold2);font-size:11.5px;font-weight:600;text-decoration:none">🌐 Nettside</a>`:""}
          </div>
        </div>`).join(""):""}
      ${cur==="see"&&g.see?g.see.map(v=>`
        <div style="border:1px solid ${c}30;border-left:3px solid ${c};border-radius:var(--r2);overflow:hidden;margin-bottom:8px;background:var(--bg3)" class="day-guide-card">
          ${placeImg(v.n)?`<img src="${placeImg(v.n)}" alt="${esc(v.n)}" loading="lazy" style="width:100%;height:120px;object-fit:cover;display:block">`:""}
          <div style="padding:11px 12px">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">
            <span style="font-size:18px">${v.ic||"📷"}</span>
            <div>
              <div style="font-size:13.5px;font-weight:700;color:var(--text)">${esc(v.n)}</div>
              <div style="font-size:10px;font-weight:800;color:${c};text-transform:uppercase;letter-spacing:.5px;margin-top:1px">${esc(v.type)}</div>
            </div>
          </div>
          <div style="font-size:12px;color:var(--t1);line-height:1.6;margin-bottom:6px">${esc(v.tip)}</div>
          ${v.dist?`<div style="font-size:11px;color:var(--t3);display:inline-flex;align-items:center;gap:3px">🗺️ ${esc(v.dist)}</div>`:""}
          <div style="margin-top:8px">${taBtn(v.n,gcity)}</div>
          </div>
        </div>`).join(""):""}
    </div>
  </div>`;
}

// Kuratert «Topp N» for en destinasjon — rangert redaksjonell liste.
const TOP10_CAT_COL={Se:"#38bdf8",Gjøre:"#34d399",Spise:"#B84A2E",Oppleve:"#a78bfa"};
// Progressiv avsløring: lange lister vises delvis til man trykker «Vis alle».
function toggleTop(id){ if(!S.topOpen)S.topOpen={}; S.topOpen[id]=!S.topOpen[id]; haptic('light'); renderPage(); }
function renderTop10(dest){
  const list=dest.top;
  if(!list||!list.length)return"";
  const note=dest.note;
  const open=!!(S.topOpen&&S.topOpen[dest.id]);
  const collapsible=list.length>6;                 // korte lister (≤6) vises alltid helt
  const shown=(collapsible&&!open)?list.slice(0,5):list;
  return`<div style="background:linear-gradient(135deg,rgba(201,145,58,.12),rgba(201,145,58,.04));border:1px solid rgba(201,145,58,.3);border-radius:var(--r);padding:14px 15px;margin-bottom:16px">
    <div style="display:flex;align-items:baseline;justify-content:space-between;margin-bottom:3px">
      <span style="font-size:14px;font-weight:800;color:var(--gold2)">🏆 Topp ${list.length} i ${esc(dest.name)}</span>
      <span style="font-size:10px;color:var(--t3);font-weight:600">se · gjøre · spise</span>
    </div>
    <div style="font-size:11.5px;color:var(--t3);margin-bottom:12px">Det dere ikke må gå glipp av her</div>
    ${note?`<div class="top-note">
      <div class="top-note-h">${note.ic} ${esc(note.tit)}</div>
      <div class="top-note-b">${esc(note.txt)}</div>
      ${note.verified?`<div class="top-note-v">🕓 Priser og transport sist sjekket ${esc(note.verified)}</div>`:""}
    </div>`:""}
    ${shown.map(x=>{const col=TOP10_CAT_COL[x.cat]||"#c9913a";return`<div class="top-row">
      <div class="top-rank">${x.r}</div>
      <div class="top-body">
        <div class="top-head">
          <span class="top-em">${x.em}</span>
          <span class="top-title">${esc(x.t)}</span>
          ${chip(x.cat,col)}
        </div>
        <div class="top-desc">${esc(x.d)}</div>
        ${x.access?`<div class="top-access"><span>📍</span><span>${esc(x.access)}</span></div>`:""}
      </div>
    </div>`;}).join("")}
    ${collapsible?`<button class="top-more" onclick="toggleTop('${dest.id}')">${open?"Vis færre ▲":`Vis alle ${list.length} høydepunkter ▼`}</button>`:""}
  </div>`;
}

/* ═══════════════════════ DEST ═══════════════════════ */
function renderDest(){
  if(S.destIdx!==null){
    const dest=destContent(DESTS[S.destIdx]);
    const filtered=S.filter==="Alle"?dest.acts:dest.acts.filter(a=>a.t===S.filter);
    const photos=dest.photos;
    const prevDest=S.destIdx>0?DESTS[S.destIdx-1]:null;
    const nextDest=S.destIdx<DESTS.length-1?DESTS[S.destIdx+1]:null;
    return`
    ${photos.length?`
    <div style="position:relative;border-radius:var(--r);overflow:hidden;margin-bottom:14px;height:220px">
      <!-- Destinasjonsknapper over bildet -->
      <div style="position:absolute;top:0;left:0;right:0;z-index:2;display:flex;overflow-x:auto;scrollbar-width:none;gap:0;background:linear-gradient(180deg,rgba(0,0,0,.6) 0%,transparent 100%);padding:8px 8px 16px">
        ${DESTS.map(function(d,di){
          const active=di===S.destIdx;
          return '<button onclick="S.destIdx='+di+';S.filter=\'Alle\';S.destAiMsgs=[];S.destAiLoading=false;renderPage();document.getElementById(\'page-content\').scrollTop=0" style="flex-shrink:0;padding:4px 10px;border-radius:16px;border:none;cursor:pointer;font-family:var(--font);font-size:10.5px;font-weight:'+(active?'700':'500')+';white-space:nowrap;transition:all .15s;background:'+(active?'rgba(255,255,255,.95)':'rgba(255,255,255,.15)')+';color:'+(active?'#0f172a':'rgba(255,255,255,.85)')+';backdrop-filter:blur(4px)">'+d.em+' '+d.name+'</button>';
        }).join('')}
      </div>
      <div id="dest-carousel" style="display:flex;overflow-x:auto;scroll-snap-type:x mandatory;height:100%;scrollbar-width:none;-webkit-overflow-scrolling:touch" onscroll="updateCarousel(this,${photos.length})">
        ${photos.map(p=>`<img src="${p.url}" alt="${esc(p.alt)}" loading="lazy" style="min-width:100%;height:100%;object-fit:cover;scroll-snap-align:start">`).join("")}
      </div>
      ${photos.length>1?`
      <button onclick="carouselNav(-1)" style="position:absolute;left:8px;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;border:none;background:rgba(0,0,0,.55);color:#fff;font-size:18px;cursor:pointer;backdrop-filter:blur(4px)">‹</button>
      <button onclick="carouselNav(1)" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;border:none;background:rgba(0,0,0,.55);color:#fff;font-size:18px;cursor:pointer;backdrop-filter:blur(4px)">›</button>
      <div id="carousel-dots" style="position:absolute;bottom:10px;left:50%;transform:translateX(-50%);display:flex;gap:7px">
        ${photos.map(function(_,i){return'<div class="c-dot" style="width:9px;height:9px;border-radius:50%;background:rgba(255,255,255,'+(i===0?'1':'0.35')+');box-shadow:0 1px 4px rgba(0,0,0,.5);transition:all .2s"></div>';}).join("")}
      </div>
      <div id="carousel-counter" style="position:absolute;top:10px;right:10px;background:rgba(0,0,0,.55);color:#fff;font-size:11px;font-weight:600;padding:4px 10px;border-radius:12px;backdrop-filter:blur(4px)">1 / ${photos.length}</div>`:""}
      <div style="position:absolute;bottom:10px;right:10px;font-size:9px;color:rgba(255,255,255,.45);background:rgba(0,0,0,.3);padding:2px 6px;border-radius:4px">Foto: Unsplash / Wikimedia</div>
    </div>`:`
    <!-- Destinasjonsknapper uten bilde -->
    <div style="display:flex;overflow-x:auto;scrollbar-width:none;gap:4px;margin-bottom:14px;padding-bottom:4px">
      ${DESTS.map(function(d,di){
        const active=di===S.destIdx;
        return '<button onclick="S.destIdx='+di+';S.filter=\'Alle\';S.destAiMsgs=[];S.destAiLoading=false;renderPage()" style="flex-shrink:0;padding:5px 12px;border-radius:20px;border:1px solid '+(active?'var(--gold)':'var(--border)')+';cursor:pointer;font-family:var(--font);font-size:11px;font-weight:'+(active?'700':'500')+';white-space:nowrap;background:'+(active?'var(--gold)':'var(--bg2)')+';color:'+(active?'#080f1a':'var(--t2)')+'">'+d.em+' '+d.name+'</button>';
      }).join('')}
    </div>`}
    <div style="display:flex;align-items:center;gap:13px;margin-bottom:10px">
      <span style="font-size:36px">${dest.em}</span>
      <div><div class="page-title" style="margin-bottom:1px">${esc(dest.name)}</div><div style="font-size:11.5px;color:var(--t2)">${esc(dest.country)} · ${esc(dest.dates)}</div></div>
    </div>
    <p style="font-size:13px;color:var(--t2);margin-bottom:14px;line-height:1.7">${esc(dest.desc)}</p>
    ${renderTop10(dest)}
    ${(dest.smak&&dest.smak.length)?`<div style="background:rgba(184,74,46,.06);border:1px solid rgba(184,74,46,.22);border-left:3px solid #B84A2E;border-radius:var(--r2);padding:11px 13px;margin-bottom:16px">
      <div style="font-size:10px;font-weight:800;color:#B84A2E;text-transform:uppercase;letter-spacing:.8px;margin-bottom:7px">🍽️ Lokale smaker</div>
      <div style="display:flex;flex-direction:column;gap:5px">${dest.smak.map(s=>`<div style="font-size:12.5px;color:var(--t1);line-height:1.45">${esc(s)}</div>`).join("")}</div>
    </div>`:""}

    <!-- AI Activity Finder -->
    <div style="background:linear-gradient(135deg,rgba(201,145,58,.08),rgba(201,145,58,.03));border:1px solid var(--gold);border-radius:var(--r);padding:13px 14px;margin-bottom:16px">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
        <div style="font-size:11px;font-weight:800;color:var(--gold);text-transform:uppercase;letter-spacing:1px">✨ AI-søk: Finn aktiviteter</div>
        <div class="conn"><span class="conn-dot ${navigator.onLine?"conn-on":"conn-off"}"></span><span style="color:${navigator.onLine?"var(--green)":"var(--t3)"};font-size:10px">${navigator.onLine?"Online":"Offline"}</span></div>
      </div>
      <div style="display:flex;gap:7px;margin-bottom:10px;flex-wrap:wrap">
        ${(()=>{
          const qs=["Restaurant i "+dest.name,"Vandring i "+dest.name,"Barnevennlig i "+dest.name,"Gratis i "+dest.name,"Naturopplevelser "+dest.name,"Shopping "+dest.name];
          return qs.map((_,qi)=>"<button onclick=\"destAiQuick("+S.destIdx+","+qi+")\" style=\"background:var(--bg3);border:1px solid var(--border);border-radius:20px;padding:5px 11px;font-size:11px;font-weight:600;color:var(--t2);cursor:pointer;font-family:var(--font);white-space:nowrap;transition:all .15s\""+((!navigator.onLine)?" disabled":"")+">"+esc(qs[qi])+"</button>").join("");
        })()}
      </div>
      <div style="display:flex;gap:7px">
        <input id="dest-ai-input" class="fi" style="flex:1;font-size:13px" placeholder="Spør om ${esc(dest.name)}... f.eks «beste solnedgangspunkt»" onkeydown="if(event.key==='Enter')destAiSend(${S.destIdx})" ${!navigator.onLine?"disabled":""}>
        <button onclick="destAiSend(${S.destIdx})" class="chat-send" style="flex-shrink:0" ${!navigator.onLine?"disabled":""}>${S.destAiLoading?"⏳":"↑"}</button>
      </div>
      <div id="dest-ai-msgs" style="margin-top:${(S.destAiMsgs&&S.destAiMsgs.length)?'10px':'0'}">
        ${(S.destAiMsgs||[]).map(m=>`<div style="padding:10px 13px;border-radius:12px;font-size:13px;line-height:1.65;margin-bottom:7px;${m.role==="user"?"background:var(--gold);color:#080f1a;font-weight:500;align-self:flex-end":"background:var(--bg3);border:1px solid var(--border);color:var(--t1)"}">${m.role==="ai"?fmtAI(m.content):esc(m.content)}</div>`).join("")}
        ${S.destAiLoading?`<div style="padding:12px;border-radius:12px;background:var(--bg3);border:1px solid var(--border)"><span class="dot"></span> <span class="dot"></span> <span class="dot"></span></div>`:""}
      </div>
    </div>

    <div style="display:flex;gap:6px;overflow-x:auto;padding-bottom:10px;margin-bottom:13px;scrollbar-width:none">
      ${FILTERS.map(f=>`<button onclick="S.filter='${f}';renderPage()" style="padding:5px 13px;border-radius:20px;border:none;cursor:pointer;font-size:11.5px;font-weight:700;white-space:nowrap;font-family:var(--font);background:${S.filter===f?dest.c:"rgba(255,255,255,.06)"};color:${S.filter===f?"#080f1a":"var(--t2)"}">${f}</button>`).join("")}
    </div>
    ${filtered.map((act,i)=>{
      const added=S.acts.some(a=>a.name===act.n);
      const thumb=placeImg(act.n);
      return`<div class="act-row" style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px">
        ${thumb?`<img src="${thumb}" alt="${esc(act.n)}" loading="lazy" style="width:62px;height:62px;border-radius:9px;object-fit:cover;flex-shrink:0">`:""}
        <div style="flex:1"><div style="font-weight:700;font-size:13.5px">${esc(act.n)}</div>
          <div style="font-size:12px;color:var(--t2);margin-top:3px;line-height:1.55">${esc(act.d)}</div>
          <div style="display:flex;gap:8px;margin-top:7px;flex-wrap:wrap;align-items:center">
            <span style="font-size:11.5px;color:var(--gold);font-weight:600">💰 ${esc(act.p)}</span>
            <span style="font-size:11px;color:var(--t3)">⏱ ${esc(act.dur)}</span>
            <span style="font-size:10px;padding:2px 9px;border-radius:10px;background:${dest.c}22;color:${dest.c};font-weight:700">${act.t}</span>
            ${act.web?`<a href="${esc(act.web)}" target="_blank" rel="noopener" onclick="event.stopPropagation()" style="font-size:11px;color:var(--gold);text-decoration:none;font-weight:600;padding:2px 8px;border:1px solid var(--gold);border-radius:10px">↗ nettside</a>`:""}
            ${act.bookAhead?`<span style="font-size:10.5px;padding:2px 8px;border-radius:10px;background:rgba(184,74,46,.12);color:#B84A2E;font-weight:700;border:1px solid rgba(184,74,46,.35)" title="${esc(act.bookWhen||'Bestill på forhånd')}">🔖 Bestill ${esc(act.bookWhen||'')}</span>`:""}
          </div>
        </div>
        <button onclick='addFromSuggestion(${S.destIdx},${i})' style="background:${added?"rgba(52,211,153,.18)":dest.c};color:${added?"#34d339":"#080f1a"};border:none;border-radius:10px;padding:10px 14px;font-size:14px;font-weight:800;cursor:pointer;flex-shrink:0">${added?"✓":"+"}</button>
      </div>`;
    }).join("")}
    ${filtered.length===0?`<div style="text-align:center;padding:40px;color:var(--t3)">Ingen forslag i denne kategorien</div>`:""}

    <!-- Bunn-navigasjon mellom destinasjoner -->
    <div style="display:flex;justify-content:space-between;align-items:center;margin-top:20px;padding-top:16px;border-top:1px solid var(--border)">
      ${prevDest?`<button onclick="S.destIdx=${S.destIdx-1};S.filter='Alle';S.destAiMsgs=[];S.destAiLoading=false;renderPage();document.getElementById('page-content').scrollTop=0" style="display:flex;align-items:center;gap:6px;background:var(--bg2);border:1px solid var(--border);border-radius:var(--r2);padding:10px 14px;cursor:pointer;font-family:var(--font);text-align:left">
        <span style="font-size:18px">‹</span>
        <div><div style="font-size:10px;color:var(--t3);font-weight:600">FORRIGE</div><div style="font-size:13px;font-weight:700;color:var(--text)">${prevDest.em} ${esc(prevDest.name)}</div></div>
      </button>`:`<div></div>`}
      ${nextDest?`<button onclick="S.destIdx=${S.destIdx+1};S.filter='Alle';S.destAiMsgs=[];S.destAiLoading=false;renderPage();document.getElementById('page-content').scrollTop=0" style="display:flex;align-items:center;gap:6px;background:var(--bg2);border:1px solid var(--border);border-radius:var(--r2);padding:10px 14px;cursor:pointer;font-family:var(--font);text-align:right">
        <div><div style="font-size:10px;color:var(--t3);font-weight:600">NESTE</div><div style="font-size:13px;font-weight:700;color:var(--text)">${esc(nextDest.name)} ${nextDest.em}</div></div>
        <span style="font-size:18px">›</span>
      </button>`:`<div></div>`}
    </div>`;
  }
  // Booking-oppsummering — alle bookAhead-items på tvers av destinasjoner
  const bookings=[];
  DESTS.forEach((d,di)=>{
    d.acts.forEach((a,ai)=>{
      if(a.bookAhead){
        bookings.push({dest:d,destIdx:di,act:a,actIdx:ai});
      }
    });
  });
  const bookingsOpen = S.bookingsOpen;
  const bookingsHtml = bookings.length ? `
    <div class="dest-card" style="border-left:3px solid #B84A2E;background:rgba(184,74,46,.05);flex-direction:column;align-items:stretch;gap:0;padding:0;margin-bottom:14px">
      <button onclick="S.bookingsOpen=!S.bookingsOpen;renderPage()" style="display:flex;width:100%;align-items:center;gap:10px;background:none;border:none;padding:14px;cursor:pointer;font-family:var(--font);text-align:left;color:inherit">
        <span style="font-size:22px">🔖</span>
        <div style="flex:1">
          <div style="font-weight:700;font-size:14px;color:#B84A2E">Bestilles før reisen</div>
          <div style="font-size:11px;color:var(--t2);margin-top:2px">${bookings.length} ting trenger forhåndsbooking</div>
        </div>
        <span style="color:var(--t3);font-size:17px;transition:transform .2s;${bookingsOpen?'transform:rotate(90deg)':''}">›</span>
      </button>
      ${bookingsOpen ? `
      <div style="border-top:1px solid rgba(184,74,46,.2);padding:4px 0">
        ${bookings.map(({dest,destIdx,act})=>`
          <div style="display:flex;gap:10px;padding:10px 14px;border-bottom:1px solid rgba(184,74,46,.08);align-items:flex-start">
            <span style="font-size:18px;line-height:1.3">${dest.em}</span>
            <div style="flex:1;min-width:0">
              <div style="font-weight:600;font-size:13px;line-height:1.3">${esc(act.n)}</div>
              <div style="font-size:11px;color:var(--t2);margin-top:2px">${esc(dest.name)} · ${esc(dest.dates.split(' ·')[0])}${act.bookWhen?` · <strong style="color:#B84A2E">${esc(act.bookWhen)}</strong>`:''}</div>
            </div>
            ${act.web?`<a href="${esc(act.web)}" target="_blank" rel="noopener" style="flex-shrink:0;background:#B84A2E;color:#fff;text-decoration:none;font-size:11px;font-weight:700;padding:6px 11px;border-radius:8px;white-space:nowrap">Bestill ↗</a>`:`<button onclick="S.destIdx=${destIdx};S.filter='Alle';renderPage()" style="flex-shrink:0;background:transparent;border:1px solid #B84A2E;color:#B84A2E;font-size:11px;font-weight:700;padding:5px 11px;border-radius:8px;cursor:pointer">Åpne</button>`}
          </div>
        `).join('')}
      </div>` : ''}
    </div>
  ` : '';

  return`<div class="page-title">Aktiviteter</div><div class="page-sub">Velg destinasjon for forslag – legg til i Mine</div>`+
  bookingsHtml+
  DESTS.map((dest,i)=>{const ph=(destContent(dest).photos||[])[0];const nBook=dest.acts.filter(a=>a.bookAhead).length;return`<button class="dest-card" style="border-left:3px solid ${dest.c};overflow:hidden;position:relative" onclick="S.destIdx=${i};S.filter='Alle';renderPage()">
    ${ph?`<img src="${ph.url}" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:.15;pointer-events:none">`:""}
    <span style="font-size:25px;position:relative">${dest.em}</span>
    <div style="flex:1;position:relative"><div style="font-weight:700;font-size:14px">${esc(dest.name)}</div><div style="font-size:11px;color:var(--t2);margin-top:2px">${esc(dest.dates)}</div><div style="font-size:10.5px;color:var(--t3);margin-top:2px">${dest.acts.length} forslag${nBook?` · <span style="color:#B84A2E;font-weight:600">🔖 ${nBook} bestilles</span>`:''}</div></div>
    <span style="color:var(--t3);font-size:17px;position:relative">›</span>
  </button>`}).join("");
}

/* ── Carousel helpers ── */
function carouselNav(dir){
  const el=document.getElementById("dest-carousel");
  if(el)el.scrollBy({left:dir*el.offsetWidth,behavior:"smooth"});
}
function updateCarousel(el,total){
  const idx=Math.round(el.scrollLeft/el.offsetWidth);
  const counter=document.getElementById("carousel-counter");
  if(counter)counter.textContent=(idx+1)+" / "+total;
  const dots=document.querySelectorAll("#carousel-dots .c-dot");
  dots.forEach(function(d,i){d.style.background="rgba(255,255,255,"+(i===idx?"1":"0.35")+")";});
}

/* ═══════════════════════ MINE ═══════════════════════ */
function renderMine(){
  const totCad=S.acts.reduce((s,a)=>s+(parseFloat(a.priceCad)||0),0);
  const totNok=S.acts.reduce((s,a)=>s+(parseFloat(a.priceNok)||0),0);
  const byS=st=>S.acts.filter(a=>a.status===st);
  return renderSyncBanner()+`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px">
    <div class="page-title" style="margin-bottom:0">Mine aktiviteter</div>
    <button class="btn btn-gold btn-sm" onclick="openAddModal()">+ Legg til</button>
  </div>
  <div class="page-sub">${S.acts.length} registrert</div>
  ${S.acts.length>0?`<div class="stats">
    <div class="stat"><div style="font-size:9px;color:var(--t3);text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px">Total CAD</div><div style="font-size:14px;font-weight:700;color:var(--gold)">${totCad.toFixed(0)} CAD</div></div>
    <div class="stat"><div style="font-size:9px;color:var(--t3);text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px">Total NOK</div><div style="font-size:14px;font-weight:700;color:var(--gold)">${totNok>0?"~"+totNok.toFixed(0)+" kr":"—"}</div></div>
    <div class="stat"><div style="font-size:9px;color:var(--t3);text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px">Booket</div><div style="font-size:14px;font-weight:700;color:var(--gold)">${byS("booked").length}/${S.acts.length}</div></div>
  </div>`:""}
  ${S.acts.length===0?`<div style="text-align:center;padding:50px 20px;color:var(--t3)"><div style="font-size:48px;margin-bottom:14px">🗺️</div><div style="font-size:14px;font-weight:600;color:var(--t2)">Ingen aktiviteter ennå</div><div style="font-size:12.5px;margin-top:8px;line-height:1.7">Gå til Aktiviteter og legg til forslag,<br>eller trykk + ovenfor</div></div>`:""}
  ${["booked","planned","idea"].map(st=>{
    const list=byS(st);if(!list.length)return"";
    const cfg=SC[st];
    return`<div style="margin-bottom:20px"><div style="font-size:11px;font-weight:800;color:${cfg.c};text-transform:uppercase;letter-spacing:1.1px;margin-bottom:8px">${cfg.l} · ${list.length}</div>${list.map(act=>renderActCard(act)).join("")}</div>`;
  }).join("")}`;
}

function renderActCard(act){
  const cfg=SC[act.status]||SC.idea;
  const dest=DESTS.find(d=>d.id===act.destination);
  const extras=[["Bookingreferanse",act.bookingRef],["Møtepunkt",act.meetingPoint],["Kontakt",act.contact],["Notater",act.notes]].filter(([,v])=>v);
  const expId="exp_"+act.id;
  return`<div class="act-row">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px">
      <div style="flex:1;cursor:pointer" onclick="${extras.length?`toggleExp('${expId}')`:""}" >
        <div style="font-weight:700;font-size:13.5px">${esc(act.name)}</div>
        <div style="display:flex;gap:6px;margin-top:5px;flex-wrap:wrap;align-items:center">
          <span style="font-size:10px;padding:2px 9px;border-radius:12px;background:${cfg.bg};color:${cfg.c};font-weight:700">${cfg.l}</span>
          ${dest?`<span style="font-size:11px;color:var(--t2)">${dest.em} ${esc(dest.name)}</span>`:""}
          ${act.date?`<span style="font-size:11px;color:var(--t3)">📅 ${esc(act.date)}</span>`:""}
        </div>
        ${act.priceCad||act.priceNok?`<div style="font-size:12.5px;color:var(--gold);margin-top:6px;font-weight:600">${act.priceCad?act.priceCad+" CAD":""}${act.priceCad&&act.priceNok?" · ":""}${act.priceNok?"~"+act.priceNok+" kr":""}</div>`:""}
        ${extras.length?`<div style="font-size:10px;color:var(--t3);margin-top:5px" id="${expId}_lbl">▼ Vis detaljer</div>`:""}
      </div>
      <div style="display:flex;gap:5px;flex-shrink:0">
        <button onclick="editAct('${act.id}')" style="background:rgba(201,145,58,.12);border:none;border-radius:7px;padding:6px 9px;color:var(--gold);cursor:pointer;font-size:13px" aria-label="Rediger aktivitet">✏️</button>
        <button onclick="deleteAct('${act.id}')" style="background:rgba(248,113,113,.12);border:none;border-radius:7px;padding:6px 9px;color:var(--red);cursor:pointer;font-size:13px" aria-label="Slett aktivitet">🗑</button>
      </div>
    </div>
    <div id="${expId}" style="display:none;margin-top:11px;padding-top:11px;border-top:1px solid var(--border2)">
      ${extras.map(([l,v])=>`<div style="margin-bottom:8px"><div style="font-size:9.5px;color:var(--t3);text-transform:uppercase;letter-spacing:.7px;font-weight:800">${esc(l)}</div><div style="font-size:12.5px;color:var(--t2);margin-top:2px;line-height:1.55">${esc(v)}</div></div>`).join("")}
    </div>
  </div>`;
}

/* ═══════════════════════ BUDSJETT ═══════════════════════ */
function renderBudsjett(){
  const entries=S.budgetEntries;
  const totalCad=entries.reduce((s,e)=>s+e.amtCad,0);
  const pct=Math.min(100,Math.round(totalCad/S.budgetTarget*100));
  const byCat=BUDGET_CATS.map(c=>({...c,total:entries.filter(e=>e.cat===c.id).reduce((s,e)=>s+e.amtCad,0)}));

  // Oppgjør Robert/Margita: kun personlige betalinger splittes — Felles er allerede 50/50
  const rPaid=entries.filter(e=>e.payer==="Robert").reduce((s,e)=>s+e.amtCad,0);
  const mPaid=entries.filter(e=>e.payer==="Margita").reduce((s,e)=>s+e.amtCad,0);
  const fellesPaid=entries.filter(e=>!e.payer||e.payer==="Felles").reduce((s,e)=>s+e.amtCad,0);
  const robertNet=(rPaid-mPaid)/2;  // > 0 = Margita skylder Robert
  const settlementHtml=(rPaid>0||mPaid>0)?`
  <div class="card" style="margin-bottom:14px">
    <div class="sec-lbl" style="margin-top:0">⚖️ Oppgjør Robert / Margita</div>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:10px">
      <div style="background:var(--bg3);border-radius:var(--r3);padding:9px 11px">
        <div style="font-size:10px;color:var(--t3);text-transform:uppercase;font-weight:700">Robert betalt</div>
        <div style="font-size:15px;font-weight:800;color:var(--gold2);margin-top:2px">${rPaid.toFixed(0)} CAD</div>
      </div>
      <div style="background:var(--bg3);border-radius:var(--r3);padding:9px 11px">
        <div style="font-size:10px;color:var(--t3);text-transform:uppercase;font-weight:700">Margita betalt</div>
        <div style="font-size:15px;font-weight:800;color:var(--gold2);margin-top:2px">${mPaid.toFixed(0)} CAD</div>
      </div>
    </div>
    ${Math.abs(robertNet)<0.5
      ? `<div style="font-size:13px;color:var(--green);font-weight:700;text-align:center;padding:6px 0">✅ Helt jevnt — ingen skylder noe</div>`
      : robertNet>0
        ? `<div style="font-size:13px;color:var(--text);text-align:center;padding:6px 0"><b style="color:var(--gold)">Margita skylder Robert</b> ${Math.abs(robertNet).toFixed(0)} CAD <span style="color:var(--t3)">(≈ ${cadToNok(Math.abs(robertNet)).toFixed(0)} kr)</span></div>`
        : `<div style="font-size:13px;color:var(--text);text-align:center;padding:6px 0"><b style="color:var(--gold)">Robert skylder Margita</b> ${Math.abs(robertNet).toFixed(0)} CAD <span style="color:var(--t3)">(≈ ${cadToNok(Math.abs(robertNet)).toFixed(0)} kr)</span></div>`}
    ${fellesPaid>0?`<div style="font-size:10.5px;color:var(--t3);text-align:center;margin-top:4px">+ ${fellesPaid.toFixed(0)} CAD på felleskonto (allerede delt)</div>`:""}
  </div>`:"";

  return renderSyncBanner()+`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px">
    <div class="page-title" style="margin-bottom:0">Budsjett</div>
    <button class="btn btn-gold btn-sm" onclick="openBudgetModal()">+ Utgift</button>
  </div>
  <div class="page-sub">Ekstra utgifter utover det som er betalt hjemme</div>

  <div class="card" style="margin-bottom:14px">
    <div style="display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:10px">
      <div>
        <div style="font-size:10px;color:var(--t3);text-transform:uppercase;letter-spacing:.8px;margin-bottom:3px">Brukt</div>
        <div style="font-size:26px;font-weight:700;color:${pct>85?"var(--red)":pct>60?"var(--amber)":"var(--gold2)"}">
          ${totalCad.toFixed(0)} <span style="font-size:14px;color:var(--t2)">CAD</span>
        </div>
        <div style="font-size:11px;color:var(--t3);margin-top:1px">≈ ${cadToNok(totalCad).toFixed(0)} kr</div>
      </div>
      <div style="text-align:right">
        <div style="font-size:10px;color:var(--t3);text-transform:uppercase;letter-spacing:.8px;margin-bottom:3px">Budsjett</div>
        <div style="font-size:18px;font-weight:700;color:var(--t2)">${S.budgetTarget} <span style="font-size:12px">CAD</span></div>
        <button onclick="editBudgetTarget()" style="background:none;border:none;color:var(--gold);font-size:11px;cursor:pointer;padding:0;font-family:var(--font);text-decoration:underline;margin-top:2px">Endre</button>
      </div>
    </div>
    <div class="prog"><div class="prog-fill" style="width:${pct}%;background:${pct>85?"var(--red)":pct>60?"var(--amber)":"var(--green)"}"></div></div>
    <div style="font-size:10.5px;color:var(--t3);margin-top:6px;text-align:right">${pct}% brukt · ${(S.budgetTarget-totalCad).toFixed(0)} CAD gjenstår</div>
  </div>

  ${settlementHtml}

  ${renderBudgetProjection(entries,totalCad)}

  <div style="margin-bottom:16px">
    <div class="sec-lbl">Per kategori</div>
    ${byCat.filter(c=>c.total>0).map(c=>`
    <div class="budget-cat-bar">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:7px">
        <div style="font-size:13px;font-weight:600">${c.ic} ${c.name}</div>
        <div style="text-align:right"><span style="font-size:13px;font-weight:700;color:var(--gold)">${c.total.toFixed(0)} CAD</span><span style="font-size:11px;color:var(--t3);margin-left:5px">≈ ${cadToNok(c.total).toFixed(0)} kr</span></div>
      </div>
      <div class="prog" style="height:4px"><div class="prog-fill" style="width:${Math.min(100,(c.total/Math.max(totalCad,1))*100).toFixed(0)}%;background:var(--gold)"></div></div>
    </div>`).join("")}
    ${byCat.every(c=>c.total===0)?`<div style="color:var(--t3);font-size:12.5px;padding:10px 0">Ingen utgifter registrert ennå</div>`:""}
  </div>

  ${entries.length>0?`<div class="sec-lbl">Siste utgifter</div>`:""}
  ${[...entries].reverse().slice(0,20).map(e=>{
    const cat=BUDGET_CATS.find(c=>c.id===e.cat);
    const payer=e.payer||"Felles";
    const payerStyle=payer==="Robert"?"background:rgba(96,165,250,.18);color:#60a5fa":payer==="Margita"?"background:rgba(244,114,182,.18);color:#f472b6":"background:rgba(167,139,250,.15);color:var(--purple)";
    return`<div class="budget-entry">
      <div style="flex:1;min-width:0">
        <div style="font-weight:600;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(e.desc)}</div>
        <div style="font-size:11px;color:var(--t3);margin-top:2px;display:flex;align-items:center;gap:5px;flex-wrap:wrap">${cat?cat.ic+" "+cat.name:""}${e.date?` · ${esc(e.date)}`:""} <span style="font-size:9.5px;font-weight:700;padding:1px 6px;border-radius:8px;${payerStyle}">${payer}</span></div>
      </div>
      <div style="text-align:right;flex-shrink:0">
        <div style="font-size:13px;font-weight:700;color:var(--gold)">${e.amtCad.toFixed(0)} CAD</div>
        <div style="font-size:10.5px;color:var(--t3)">≈ ${cadToNok(e.amtCad).toFixed(0)} kr</div>
      </div>
      <button onclick="deleteBudgetEntry('${e.id}')" style="background:rgba(248,113,113,.1);border:none;border-radius:6px;padding:5px 8px;color:var(--red);cursor:pointer;font-size:12px;flex-shrink:0;margin-left:6px" aria-label="Slett utgift">🗑</button>
    </div>`;
  }).join("")}`;
}

/* ═══════════════════════ PAKKLISTE ═══════════════════════ */
// Sammenleggbar oversikt over typiske værforhold per region i reiseperioden.
// Bygger på CLIMATE (klimanormaler) — ikke live varsel, som bare rekker 7 dager.
function renderClimateOverview(){
  const open = S.climateOpen !== false; // default åpen
  const rows = CLIMATE.map(c=>`
    <div class="pack-clim-row">
      <div class="pack-clim-head">
        <span class="pack-clim-region">${c.ic} ${esc(c.region)}</span>
        <span class="pack-clim-days">${esc(c.days)}</span>
      </div>
      <div class="pack-clim-meta">
        <span class="pack-clim-temp">🌡 ${c.hi}° / ${c.lo}°</span>
        <span class="pack-clim-rain">${c.rainIc} ${esc(c.rain)}</span>
      </div>
      <div class="pack-clim-sum">${esc(c.sum)}</div>
      <div class="pack-clim-pack"><span>🧳</span> ${esc(c.pack)}</div>
    </div>`).join("");
  return `<div class="pack-clim" role="note">
    <button class="pack-clim-toggle" onclick="toggleClimate()" aria-expanded="${open}">
      <span class="pack-clim-lbl">🌦 Typisk vær i reiseperioden</span>
      <span class="pack-clim-chev">${open?"▲":"▼"}</span>
    </button>
    ${open?`<div class="pack-clim-body">
      ${rows}
      <div class="pack-clim-foot">Klimanormaler for juli–august, ikke live varsel. Live prognose (7 dager) finnes i Verktøy → Vær.</div>
    </div>`:""}
  </div>`;
}

function renderPakk(){
  const done=donePack(),total=totalPack(),pct=Math.round(done/total*100);
  const tipBox=renderClimateOverview();
  return renderSyncBanner()+`<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;margin-bottom:3px">
    <div class="page-title" style="margin-bottom:0">Pakkeliste</div>
    <div style="display:flex;gap:6px;flex-shrink:0">
      <button onclick="exportPackPDF()" class="btn btn-ghost btn-sm" title="Skriv ut hele pakkelisten">🖨️ Skriv ut</button>
      <button onclick="resetPacking()" class="btn btn-ghost btn-sm">↺ Nullstill</button>
    </div>
  </div>
  <div class="page-sub">${done} av ${total} pakket</div>
  ${tipBox}
  <div class="prog" style="margin-bottom:20px"><div class="prog-fill" style="width:${pct}%;background:${pct===100?"var(--green)":"var(--gold)"}"></div></div>
  ${PACKING.map(group=>{
    const gDone=group.items.filter(it=>S.packChk[it.id]).length;
    const o=S.openAcc===group.id;
    return`<button class="acc-btn${o?" open":""}" onclick="toggleAcc('${group.id}')">
      <span>${esc(group.cat)} <span style="font-size:11px;color:var(--t3);font-weight:400;margin-left:6px">${gDone}/${group.items.length}</span></span>
      <span style="color:var(--t3);font-size:11px">${o?"▲":"▼"}</span>
    </button>
    ${o?`<div class="acc-body">
      ${group.items.map(item=>`<div class="chk-row" onclick="togglePackChk('${item.id}')">
        <div class="chk-box${S.packChk[item.id]?" on":""}">
          ${S.packChk[item.id]?`<span style="color:#080f1a;font-size:11px;font-weight:900">✓</span>`:""}
        </div>
        <span style="font-size:13px;line-height:1.6;color:${S.packChk[item.id]?"var(--t3)":"var(--t1)"};text-decoration:${S.packChk[item.id]?"line-through":"none"}">${esc(item.t)}</span>
      </div>`).join("")}
    </div>`:""}`;
  }).join("")}
  ${pct===100?`<div style="text-align:center;padding:28px 20px;border-radius:var(--r);background:rgba(52,211,153,.06);border:1px solid rgba(52,211,153,.2);margin-top:12px">
    <div style="font-size:44px;margin-bottom:10px">🧳</div>
    <div class="serif" style="font-size:20px;color:var(--green);font-style:italic">Alt er pakket!</div>
    <div style="font-size:12.5px;color:var(--t2);margin-top:6px">God tur, Robert, Margita &amp; Nicholas! 🍁</div>
  </div>`:""}`;
}

/* ═══════════════════════ VERKTØY ═══════════════════════ */
function renderVerktoy(){
  const tabs=["weather","clock","currency","fuel","flyt"];
  const tabLabels={weather:"🌤️ Vær",clock:"🕐 Tidsoner",currency:"💱 Valuta",fuel:"⛽ Drivstoff",flyt:"✈️ Flystatus"};
  if(!S.toolTab||S.toolTab==="clock")S.toolTab="weather";
  return`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px">
    <div class="page-title" style="margin-bottom:0">Verktøy</div>
    <button onclick="exportPlanPDF()" class="btn btn-ghost btn-sm" title="Eksporter reiseplan">📄 PDF reiseplan</button>
  </div>
  <div class="tool-tabs">
    ${tabs.map(t=>`<button class="tool-tab${S.toolTab===t?" active":""}" onclick="S.toolTab='${t}';renderPage()">${tabLabels[t]}</button>`).join("")}
  </div>
  ${S.toolTab==="weather"?renderWeatherTab():""}
  ${S.toolTab==="clock"?renderClock():""}
  ${S.toolTab==="currency"?renderCurrency():""}
  ${S.toolTab==="fuel"?renderFuel():""}
  ${S.toolTab==="flyt"?renderFlightStatus():""}`;
}
function renderWeatherTab(){
  return renderWeatherWidget()
    +`<div style="font-size:11px;color:var(--t3);margin-top:8px;text-align:center">Data fra Open-Meteo · Oppdateres hver time</div>`
    +renderWeatherMatrixShell();
}

/* ── Time-for-time-tabell langs reiseruten ──
   Rader: dato + sted per reisedag. Kolonner: klokkeslett (lokal tid på stedet).
   Data hentes per unike koordinat via getTripMatrix() og fornyes automatisk
   hvert 30. minutt så lenge fanen står åpen. */
function renderWeatherMatrixShell(){
  return`
  <div style="margin-top:26px">
    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
      <div style="font-size:14px;font-weight:700;color:var(--text)">🗓️ Vær langs ruten — time for time</div>
      <button class="btn btn-ghost btn-sm" onclick="refreshWeatherMatrix()" title="Hent fersk prognose nå">↻ Oppdater</button>
    </div>
    <div id="wx-matrix"><div style="font-size:12px;color:var(--t3);padding:12px 0">Laster prognose for alle reisemål…</div></div>
    <div id="wx-matrix-upd" style="font-size:11px;color:var(--t3);margin-top:8px;text-align:center"></div>
  </div>`;
}

function wxCodeEmoji(code){
  if(code==null)return"🌡️";
  if(code===0)return"☀️";
  if(code===1)return"🌤️";
  if(code===2)return"⛅";
  if(code===3)return"☁️";
  if(code<=48)return"🌫️";
  if(code<=57)return"🌦️";
  if(code<=67)return"🌧️";
  if(code<=77)return"🌨️";
  if(code<=82)return"🌧️";
  if(code<=86)return"🌨️";
  return"⛈️";
}

async function loadWeatherMatrix(force){
  const el=document.getElementById("wx-matrix");
  if(!el)return;
  const m=await getTripMatrix(force);
  // Fanen kan ha blitt byttet mens vi ventet
  const el2=document.getElementById("wx-matrix");
  if(!el2)return;
  if(!m||!m.rows.some(r=>r.cells.some(Boolean))){
    el2.innerHTML=`<div style="font-size:12px;color:var(--t3);padding:12px 0">Fikk ikke hentet prognosen nå — prøver igjen automatisk.</div>`;
    return;
  }
  const now=new Date();
  const todayIso=`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-${String(now.getDate()).padStart(2,"0")}`;
  const rowsHtml=m.rows.map(r=>{
    const d=new Date(r.iso+"T12:00:00Z");
    const label=d.toLocaleDateString("no",{weekday:"short",day:"numeric",month:"short"});
    const isToday=r.iso===todayIso;
    const hasData=r.cells.some(Boolean);
    const cells=r.cells.map(c=>c
      ?`<td style="text-align:center;padding:7px 4px;border-top:1px solid var(--border2)">
          <div style="font-size:17px;line-height:1.2">${wxCodeEmoji(c.code)}</div>
          <div style="font-size:11.5px;font-weight:700;color:var(--text)">${c.temp}°</div>
        </td>`
      :`<td style="text-align:center;padding:7px 4px;border-top:1px solid var(--border2);color:var(--t3);font-size:12px">–</td>`
    ).join("");
    return`<tr style="${isToday?"background:rgba(201,145,58,.10)":""}">
      <td style="padding:7px 10px;border-top:1px solid var(--border2);white-space:nowrap">
        <div style="font-size:12px;font-weight:700;color:${isToday?"var(--gold2)":"var(--text)"}">${label}${isToday?" · i dag":""}</div>
        <div style="font-size:11px;color:${hasData?"var(--t2)":"var(--t3)"}">${esc(r.loc)}</div>
      </td>${cells}</tr>`;
  }).join("");
  el2.innerHTML=`
  <div style="overflow-x:auto;border:1px solid var(--border);border-radius:var(--r2);background:var(--bg2)">
    <table style="border-collapse:collapse;width:100%;min-width:520px">
      <thead><tr>
        <th style="text-align:left;padding:8px 10px;font-size:10.5px;color:var(--t3);text-transform:uppercase;letter-spacing:.4px;font-weight:700">Dag · sted</th>
        ${MATRIX_HOURS.map(h=>`<th style="text-align:center;padding:8px 4px;font-size:10.5px;color:var(--t3);font-weight:700">kl ${String(h).padStart(2,"0")}</th>`).join("")}
      </tr></thead>
      <tbody>${rowsHtml}</tbody>
    </table>
  </div>`;
  const upd=document.getElementById("wx-matrix-upd");
  if(upd){
    const t=new Date(m.updatedAt).toLocaleTimeString("no",{hour:"2-digit",minute:"2-digit"});
    upd.innerHTML=`Sist oppdatert ${t}${m.stale?" · <span style='color:var(--gold2)'>offline — viser siste kjente</span>":""} · fornyes automatisk hvert 30. min · klokkeslett er lokal tid på stedet · dager uten tall ligger utenfor 16-dagersprognosen`;
  }
}

let wxMatrixTimer=null;
function bindWeather(){
  loadAndShowWeather();
  loadWeatherMatrix();
  if(wxMatrixTimer)clearInterval(wxMatrixTimer);
  wxMatrixTimer=setInterval(()=>{
    // Selvryddende: stopp når brukeren har forlatt Vær-fanen
    if(!document.getElementById("wx-matrix")){clearInterval(wxMatrixTimer);wxMatrixTimer=null;return;}
    loadWeatherMatrix(true);
  },30*60*1000);
}
function refreshWeatherMatrix(){
  const el=document.getElementById("wx-matrix");
  if(el)el.innerHTML=`<div style="font-size:12px;color:var(--t3);padding:12px 0">Henter fersk prognose…</div>`;
  loadWeatherMatrix(true);
  haptic('light');
}


function renderClock(){
  return`<div class="clock-grid" id="clock-grid">
    ${[{city:"Oslo",tz:"Europe/Oslo",flag:"🇳🇴"},{city:"Vancouver",tz:"America/Vancouver",flag:"🇨🇦"},{city:"Jasper / Banff / Calgary",tz:"America/Edmonton",flag:"🇨🇦"}].map(c=>`
    <div class="clock-face">
      <div class="clock-city">${c.flag} ${c.city}</div>
      <div class="clock-time" id="ct_${c.tz.replace(/\//g,"_")}">--:--</div>
      <div class="clock-date" id="cd_${c.tz.replace(/\//g,"_")}">---</div>
    </div>`).join("")}
  </div>
  ${wbox("wgold","🌍 Tidsforskjell til Norge i sommerhalvåret (CEST):<br>Vancouver (PDT) = <b>-9 timer</b> · Calgary / Jasper / Banff (MDT) = <b>-8 timer</b>")}
  <div style="margin-top:16px">
    <div class="sec-lbl">Eksempel tidskonvertering</div>
    <div class="card-sm">
      <div style="font-size:12.5px;color:var(--t2);line-height:2">
        Hvis det er <b style="color:var(--gold2)">12:00 middag i Oslo</b> er det:<br>
        🕒 <b style="color:var(--gold2)">03:00</b> om natten i Vancouver<br>
        🕓 <b style="color:var(--gold2)">04:00</b> om morgenen i Calgary/Jasper/Banff<br><br>
        <span style="color:var(--t3);font-size:11.5px">USA Tours åpner kl. 10–16 norsk tid = 01–07 i Vancouver, 02–08 i Calgary</span>
      </div>
    </div>
  </div>`;
}

function bindClock(){
  if(clockTimer)clearInterval(clockTimer);
  updateClock();
  clockTimer=setInterval(updateClock,1000);
}

function updateClock(){
  const zones=[{tz:"Europe/Oslo",flag:""},{tz:"America/Vancouver",flag:""},{tz:"America/Edmonton",flag:""}];
  zones.forEach(z=>{
    const k=z.tz.replace(/\//g,"_");
    const te=document.getElementById("ct_"+k);
    const de=document.getElementById("cd_"+k);
    if(!te)return;
    const now=new Date();
    te.textContent=now.toLocaleTimeString("no-NO",{timeZone:z.tz,hour:"2-digit",minute:"2-digit",second:"2-digit"});
    de.textContent=now.toLocaleDateString("no-NO",{timeZone:z.tz,weekday:"short",day:"numeric",month:"short"});
  });
}

function renderCurrency(){
  return`<div>
    <div class="sec-lbl">Valutakalkulator</div>
    <div style="display:grid;grid-template-columns:1fr auto 1fr;gap:10px;align-items:end;margin-bottom:14px">
      <div class="fg" style="margin:0">
        <label class="fl">Beløp</label>
        <input class="fi" type="number" id="curr-amt" value="100" min="0" oninput="calcCurrency()">
      </div>
      <div style="text-align:center;margin-bottom:9px;color:var(--t3);font-size:20px">→</div>
      <div class="fg" style="margin:0">
        <label class="fl">Fra → Til</label>
        <select class="fi" id="curr-pair" onchange="calcCurrency()">
          <option value="CAD-NOK">CAD → NOK</option>
          <option value="NOK-CAD">NOK → CAD</option>
          <option value="USD-NOK">USD → NOK</option>
          <option value="USD-CAD">USD → CAD</option>
          <option value="NOK-USD">NOK → USD</option>
          <option value="CAD-USD">CAD → USD</option>
        </select>
      </div>
    </div>
    <div class="curr-result">
      <div class="curr-num" id="curr-result">765</div>
      <div class="curr-label" id="curr-label">NOK</div>
    </div>
    <div class="sec-lbl">Hurtigkalkulator – vanlige beløp</div>
    <div class="curr-quick" id="curr-quick"></div>
    ${wbox("wgold","Omtrentlige kurser (juli 2026): 1 CAD ≈ 7,65 NOK · 1 USD ≈ 10,75 NOK · 1 USD ≈ 1,41 CAD")}
  </div>`;
}

let liveRates=null;
async function loadLiveRates(){
  const { rates, stale, ageMs } = await getRates();
  liveRates = rates;
  const el=document.getElementById("rate-status");
  if(el) el.textContent = stale
    ? "Kurs: sist oppdatert " + rateAgeLabel(ageMs) + " (offline)"
    : "Kurs oppdatert: " + (rates.updated || "nå");
}
loadLiveRates();
function calcCurrency(){
  const amt=parseFloat(document.getElementById("curr-amt")?.value)||0;
  const pair=document.getElementById("curr-pair")?.value||"CAD-NOK";
  const base=liveRates||{"CAD-NOK":7.65,"CAD-USD":0.71,"USD-NOK":10.75,"USD-CAD":1.41};
  const rates={"CAD-NOK":base["CAD-NOK"],"NOK-CAD":1/base["CAD-NOK"],"USD-NOK":base["USD-NOK"],"NOK-USD":1/base["USD-NOK"],"USD-CAD":base["USD-CAD"],"CAD-USD":1/base["USD-CAD"],"NOK-NOK":1,"CAD-CAD":1,"USD-USD":1};
  const rate=rates[pair]||1;
  const result=(amt*rate);
  const to=pair.split("-")[1];
  const el=document.getElementById("curr-result");
  const lb=document.getElementById("curr-label");
  if(el)el.textContent=result>=1?result.toFixed(2):result.toFixed(4);
  if(lb)lb.textContent=to;
  // Quick
  const quick=document.getElementById("curr-quick");
  if(quick){
    const amounts=pair.startsWith("NOK")?[100,200,500,1000]:[50,100,200,500];
    quick.innerHTML=amounts.map(a=>`<div class="curr-qitem">
      <div style="font-size:11px;color:var(--t3)">${a} ${pair.split("-")[0]}</div>
      <div style="font-size:15px;font-weight:700;color:var(--gold2);margin-top:2px">${(a*rate).toFixed(to==="NOK"||to==="USD"?0:2)} ${to}</div>
    </div>`).join("");
  }
}

function renderFuel(){
  return`<div>
    <div class="sec-lbl">Drivstoffkalkulator</div>
    <div class="fg"><label class="fl">Avstand (km)</label><input class="fi" type="number" id="fuel-km" value="800" min="0" oninput="calcFuel()"></div>
    <div class="frow">
      <div class="fg"><label class="fl">Forbruk (L/100km)</label><input class="fi" type="number" id="fuel-l100" value="9.5" min="1" step="0.5" oninput="calcFuel()"></div>
      <div class="fg"><label class="fl">Pris per liter (CAD)</label><input class="fi" type="number" id="fuel-price" value="1.78" min="0" step="0.01" oninput="calcFuel()"></div>
    </div>
    <div class="fuel-result" id="fuel-result">
      <div style="font-size:11px;color:var(--t2);margin-bottom:8px;text-transform:uppercase;letter-spacing:.8px">Estimat</div>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px">
        <div><div style="font-size:10px;color:var(--t3);margin-bottom:3px">Liter</div><div style="font-size:20px;font-weight:700;color:var(--gold2)" id="f-liters">76</div></div>
        <div><div style="font-size:10px;color:var(--t3);margin-bottom:3px">Kostnad CAD</div><div style="font-size:20px;font-weight:700;color:var(--gold2)" id="f-cad">135</div></div>
        <div><div style="font-size:10px;color:var(--t3);margin-bottom:3px">Kostnad NOK</div><div style="font-size:20px;font-weight:700;color:var(--gold2)" id="f-nok">1 033</div></div>
      </div>
    </div>
    ${wbox("wblue","🚗 Ruten din er ca. <b>810 km</b> totalt: Vancouver→Kamloops (350 km) · Kamloops→Jasper (430 km) · Jasper→Banff (285 km) · Banff→Calgary (130 km) = inkl. dagsutflukter ~1 100 km total.")}
    ${wbox("wgold","⛽ Husk: Returner bilen med full tank <b>innen 5 km</b> fra Calgary Airport. Ta vare på kvitteringen!")}
  </div>`;
}

function calcFuel(){
  const km=parseFloat(document.getElementById("fuel-km")?.value)||0;
  const l100=parseFloat(document.getElementById("fuel-l100")?.value)||9.5;
  const price=parseFloat(document.getElementById("fuel-price")?.value)||1.78;
  const liters=km*l100/100;
  const cad=liters*price;
  const nok=cadToNok(cad);
  const set=(id,v)=>{const el=document.getElementById(id);if(el)el.textContent=v;};
  set("f-liters",liters.toFixed(1));
  set("f-cad",cad.toFixed(0));
  set("f-nok",nok.toFixed(0));
}

/* ═══════════════════════ TIPPING-KALKULATOR ═══════════════════════ */
function renderTip(){
  if(!S.tipPct) S.tipPct=18;
  if(!S.tipPeople) S.tipPeople=2;
  return `<div class="page-title">🍽️ Tipping-kalkulator</div>
  <div class="page-sub">Standard i Canada/USA: 15–20% på restaurant. 10–15% taxi. 1–2 USD pr drink.</div>
  <div class="card" style="margin-bottom:14px">
    <div class="fg"><label class="fl">Regningens beløp (CAD eller USD)</label>
      <input id="tip-bill" class="fi" type="number" inputmode="decimal" placeholder="0" oninput="calcTip()" autofocus></div>
    <div class="fg"><label class="fl">Tips %</label>
      <div style="display:flex;gap:6px">
        ${[15,18,20,25].map(p=>`<button onclick="S.tipPct=${p};calcTip();renderPage()" style="flex:1;padding:10px 4px;border-radius:9px;cursor:pointer;border:none;font-size:13px;font-weight:700;font-family:var(--font);background:${S.tipPct===p?"var(--gold)":"rgba(255,255,255,.04)"};color:${S.tipPct===p?"#080f1a":"var(--t2)"}">${p}%</button>`).join("")}
        <input type="number" min="0" max="50" value="${S.tipPct}" oninput="S.tipPct=parseInt(this.value)||0;calcTip()" style="width:60px;background:var(--bg2);border:1px solid var(--bg4);border-radius:9px;padding:10px 4px;color:var(--text);font-size:13px;font-weight:700;font-family:var(--font);text-align:center" aria-label="Egendefinert prosent">
      </div>
    </div>
    <div class="fg"><label class="fl">Antall personer (for splitt)</label>
      <div style="display:flex;gap:6px">
        ${[1,2,3,4,5,6].map(n=>`<button onclick="S.tipPeople=${n};calcTip();renderPage()" style="flex:1;padding:10px 4px;border-radius:9px;cursor:pointer;border:none;font-size:13px;font-weight:700;font-family:var(--font);background:${S.tipPeople===n?"var(--gold)":"rgba(255,255,255,.04)"};color:${S.tipPeople===n?"#080f1a":"var(--t2)"}">${n}</button>`).join("")}
      </div>
    </div>
  </div>
  <div class="card" id="tip-result" style="text-align:center">
    <div style="font-size:11px;color:var(--t3);text-transform:uppercase;letter-spacing:.8px;margin-bottom:6px">Trykk inn beløp</div>
    <div style="font-size:14px;color:var(--t2)">Tips og total beregnes automatisk</div>
  </div>
  <div style="font-size:11px;color:var(--t3);line-height:1.7;margin-top:14px;padding:10px 13px;background:var(--bg3);border-radius:var(--r2)">
    💡 Sjekk regningen for "gratuity included" — ikke legg til ekstra hvis service charge alt er med.
  </div>`;
}
function calcTip(){
  const bill=parseFloat(document.getElementById("tip-bill")?.value)||0;
  const pct=S.tipPct||18;
  const people=Math.max(1,S.tipPeople||1);
  const tip=bill*pct/100;
  const total=bill+tip;
  const perPerson=total/people;
  const el=document.getElementById("tip-result");
  if(!el) return;
  if(bill<=0){
    el.innerHTML=`<div style="font-size:11px;color:var(--t3);text-transform:uppercase;letter-spacing:.8px;margin-bottom:6px">Trykk inn beløp</div><div style="font-size:14px;color:var(--t2)">Tips og total beregnes automatisk</div>`;
    return;
  }
  el.innerHTML=`<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">
    <div style="background:var(--bg3);border-radius:var(--r3);padding:10px">
      <div style="font-size:10px;color:var(--t3);text-transform:uppercase;font-weight:700">Tips ${pct}%</div>
      <div style="font-size:18px;font-weight:800;color:var(--gold2);margin-top:2px">${tip.toFixed(2)}</div>
    </div>
    <div style="background:var(--bg3);border-radius:var(--r3);padding:10px">
      <div style="font-size:10px;color:var(--t3);text-transform:uppercase;font-weight:700">Total</div>
      <div style="font-size:18px;font-weight:800;color:var(--text);margin-top:2px">${total.toFixed(2)}</div>
    </div>
  </div>
  ${people>1?`<div style="font-size:13px;font-weight:700;color:var(--gold);padding:10px;background:rgba(201,145,58,.1);border-radius:var(--r2)">Pr person (${people}): <span style="font-size:18px;font-weight:800">${perPerson.toFixed(2)}</span></div>`:""}
  <div style="font-size:11px;color:var(--t3);margin-top:10px">≈ ${cadToNok(total).toFixed(0)} NOK (CAD-kurs)</div>`;
}

/* ═══════════════════════ SOS-SKJERM ═══════════════════════ */
function renderSos(){
  // Klassifiser nødnumre etter prefiks/innhold
  const local=SOS.filter(s=>s.v.includes("911")||s.v.startsWith("+1"));
  const norway=SOS.filter(s=>s.v.startsWith("+47"));
  const other=SOS.filter(s=>!local.includes(s)&&!norway.includes(s));
  const big=(s)=>{
    if(!s.ph){
      // Ikke ringbart (f.eks. e-post) — vis uten tel:-lenke
      return `<div style="display:flex;align-items:center;gap:12px;background:var(--card);border:1px solid var(--border);border-left:3px solid var(--t3);border-radius:var(--r2);padding:14px 16px;margin-bottom:8px">
        <div style="font-size:24px">✉️</div>
        <div style="flex:1;min-width:0">
          <div style="font-size:13px;font-weight:700;color:var(--text)">${esc(s.l)}</div>
          <div style="font-size:14px;font-weight:600;color:var(--gold2);margin-top:3px">${esc(s.v)}</div>
        </div>
      </div>`;
    }
    const tel=`tel:${s.v.replace(/[\s-]/g,"")}`;
    return `<a href="${tel}" style="display:flex;align-items:center;gap:12px;background:var(--card);border:1px solid var(--border);border-left:3px solid var(--red);border-radius:var(--r2);padding:14px 16px;margin-bottom:8px;text-decoration:none;color:inherit">
      <div style="font-size:24px">📞</div>
      <div style="flex:1;min-width:0">
        <div style="font-size:13px;font-weight:700;color:var(--text)">${esc(s.l)}</div>
        <div style="font-size:18px;font-weight:800;color:var(--gold2);margin-top:3px;font-variant-numeric:tabular-nums">${esc(s.v)}</div>
      </div>
      <div style="font-size:11px;color:var(--t3);text-transform:uppercase;font-weight:700">Ring</div>
    </a>`;
  };
  return `<div class="page-title">🆘 Nødhjelp</div>
  <div class="page-sub">Trykk for å ringe direkte. 911 fungerer i hele Canada og USA.</div>
  <div style="background:rgba(248,113,113,.1);border:1px solid var(--red);border-radius:var(--r2);padding:14px 16px;margin-bottom:14px;text-align:center">
    <div style="font-size:11px;color:var(--red);text-transform:uppercase;font-weight:800;letter-spacing:.5px;margin-bottom:6px">Akutt nødhjelp i Canada/USA</div>
    <a href="tel:911" style="display:inline-block;background:var(--red);color:#fff;border:none;border-radius:12px;padding:16px 40px;font-size:32px;font-weight:900;text-decoration:none;font-variant-numeric:tabular-nums">911</a>
    <div style="font-size:11.5px;color:var(--t2);margin-top:8px">Politi · brann · ambulanse</div>
  </div>
  ${local.length?`<div class="sec-lbl">📍 Lokalt</div>${local.map(big).join("")}`:""}
  ${norway.length?`<div class="sec-lbl" style="margin-top:14px">🇳🇴 Norge</div>${norway.map(big).join("")}`:""}
  ${other.length?`<div class="sec-lbl" style="margin-top:14px">Andre</div>${other.map(big).join("")}`:""}
  <div style="background:rgba(56,189,248,.08);border:1px solid rgba(56,189,248,.2);border-radius:var(--r2);padding:12px 14px;margin-top:14px">
    <div style="font-size:11px;color:var(--sky);font-weight:700;margin-bottom:6px">💡 Praktisk</div>
    <div style="font-size:12px;color:var(--t1);line-height:1.7">
      • Ved mindre helseproblemer: tlf til reiseforsikring først<br>
      • Norske ambassader: <b>Ottawa</b> (Canada) +1 613-238-6571 · <b>Washington</b> (USA) +1 202-333-6000<br>
      • Tap av pass: ring norsk ambassade og lokalt politi
    </div>
  </div>
  ${renderSafety()}`;
}

// #8 — Trygghet & helse: nærmeste sykehus pr. stopp, bjørnesikkerhet, scenarier. Offline.
function renderSafety(){
  const tel=p=>p.replace(/[\s-]/g,"");
  return `<div class="sec-lbl" style="margin-top:18px">🏥 Nærmeste sykehus på ruten</div>
    <div class="card" style="margin-bottom:14px">
      ${SAFETY.hospitals.map(h=>`<div style="display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid var(--border)">
        <div style="flex:1;min-width:0">
          <div style="font-size:12.5px;font-weight:700;color:var(--t1)">${esc(h.area)} · <span style="font-weight:600;color:var(--t2)">${esc(h.n)}</span></div>
          <div style="font-size:10.5px;color:var(--t3)">${esc(h.adr)}</div>
        </div>
        <a href="tel:${tel(h.ph)}" style="flex-shrink:0;display:inline-flex;align-items:center;gap:4px;padding:6px 11px;background:rgba(56,189,248,.12);border:1px solid rgba(56,189,248,.25);border-radius:var(--r3);color:var(--sky);font-size:11.5px;font-weight:700;text-decoration:none">📞 Ring</a>
        <a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(h.adr)}" target="_blank" rel="noopener" style="flex-shrink:0;display:inline-flex;align-items:center;gap:4px;padding:6px 10px;background:rgba(52,211,153,.12);border:1px solid rgba(52,211,153,.25);border-radius:var(--r3);color:var(--green);font-size:11.5px;font-weight:700;text-decoration:none">🗺️</a>
      </div>`).join("")}
      <div style="font-size:10px;color:var(--t3);margin-top:8px">Ved akutt fare: ring alltid 911 først. Verifiser numre lokalt.</div>
    </div>
    <div class="sec-lbl">🐻 Bjørnesikkerhet</div>
    <div class="card" style="margin-bottom:14px">
      ${SAFETY.bears.map(b=>`<div style="display:flex;gap:8px;font-size:12px;color:var(--t1);line-height:1.55;padding:4px 0"><span style="color:var(--gold)">•</span><span>${esc(b)}</span></div>`).join("")}
    </div>
    <div class="sec-lbl">🆘 Hva gjør jeg hvis…</div>
    <div class="card">
      ${SAFETY.scenarios.map(s=>`<div style="padding:8px 0;border-bottom:1px solid var(--border)">
        <div style="font-size:12.5px;font-weight:700;color:var(--t1)">${esc(s.q)}</div>
        <div style="font-size:11.5px;color:var(--t2);line-height:1.55;margin-top:2px">${esc(s.a)}</div>
      </div>`).join("")}
    </div>`;
}
function callNumber(num){ window.location.href="tel:"+num.replace(/\s/g,""); }

/* ═══════════════════════ INFO ═══════════════════════ */
function renderInfo(){
  const acc=(id,em,title,content)=>`
    <button class="acc-btn${S.openAcc===id?" open":""}" onclick="toggleAcc('${id}')">
      <span>${em} ${esc(title)}</span>
      <span style="color:var(--t3);font-size:11px">${S.openAcc===id?"▲":"▼"}</span>
    </button>
    ${S.openAcc===id?`<div class="acc-body">${content}</div>`:""}`;
  const errs = getErrors();
  return`<div class="page-title">Viktig info</div><div class="page-sub">Alle referanser, nødnumre og booking-detaljer</div>
  <div class="card" style="display:flex;align-items:center;gap:12px;margin-bottom:14px">
    <div style="font-size:24px">📅</div>
    <div style="flex:1;min-width:0">
      <div style="font-size:13px;font-weight:700;color:var(--text)">Legg hele turen i kalenderen</div>
      <div style="font-size:11.5px;color:var(--t2);margin-top:2px;line-height:1.5">Alle fly, hotell og cruise — importer i Apple/Google Calendar med 2t påminnelser</div>
    </div>
    <button class="btn btn-gold btn-sm" onclick="downloadICS()" style="flex-shrink:0">Last ned .ics</button>
  </div>
  ${errs.length>0?`<div class="card" style="display:flex;align-items:center;gap:12px;margin-bottom:14px;border-left:3px solid var(--red)">
    <div style="font-size:24px">⚠️</div>
    <div style="flex:1;min-width:0">
      <div style="font-size:13px;font-weight:700;color:var(--red)">${errs.length} feil registrert</div>
      <div style="font-size:11.5px;color:var(--t2);margin-top:2px;line-height:1.5">Trykk for å se hva som skjedde — nyttig hvis appen oppfører seg rart</div>
    </div>
    <button class="btn btn-ghost btn-sm" onclick="showDiagnostics()" style="flex-shrink:0">Diagnostikk</button>
  </div>`:""}
  ${acc("sos","🆘","Nødkontakter",SOS.map(s=>irow(s.l,s.v,s.ph)).join("")+wbox("wblue","<b>Hverdager 10–16 (norsk tid):</b> Ring Elin Gran +47 21 95 01 49<br><b>Utenom/helger/helligdager:</b> Nødtelefon +45 25 99 80 60"))}
  ${acc("fly","✈️","Flyinformasjon",FLY_INFO.map(f=>irow(f.l,f.v)).join("")+wbox("wgold","💡 USA Tours ref FZJQ4P ≠ flyselskapets ref. Bruk Z2IIVW (Icelandair) og KMXQYA (WestJet) ved online check-in."))}
  ${acc("cruise","🚢","Cruise – Celebrity Solstice",[["Booking","6158158"],["Lugar","1563, Dekk 11"],["Datoer","19–26. juli"],["Embarkering","Vancouver · 19. jul kl 16:00"],["Debarkering","Vancouver · 26. jul kl 06:00"],["Inkludert","AquaClass: Helpensjon · Servicecharge · Persian Garden spa · Blu restaurant"]].map(([l,v])=>irow(l,v)).join("")+wbox("wred","⚠️ Sjekk inn online på celebritycruises.com – minst 72 timer FØR avgang 19. juli!"))}
  ${acc("car","🚗","Leiebil – AVIS Ford Escape",[["Flexible Autos ref","4H985592"],["AVIS supplier ref","07314376GB6"],["Sjåfør","Robert Andrzej Kolakowski"],["Henting","26. jul 09:00 · 757 Hornby Street, Vancouver"],["Hent-tlf","+1 604-606-2868",true],["Innlevering","02. aug 10:00 · Calgary International Airport"],["Lev-tlf","+1 403-221-1700",true],["Enveisgebyr","336,00 CAD (betales lokalt + skatt)"],["Depositum","300 CAD reserveres på kredittkort"],["Selvrisiko","500 CAD på CDW og Theft"],["Drivstoff","Full tank ved henting – RETURNER FULL (fyll innen 5 km, ta kvittering!)"],["Inkludert","Fri km · Kaskoforsikring · Ansvarsforsikring · Tyveriforsikring · 1 ekstra sjåfør"]].map(([l,v,ph])=>irow(l,v,ph)).join("")+wbox("wred","⚠️ KRITISK: Kun kredittkort aksepteres. Debetkort AVVISES. Kortet MÅ stå i Roberts navn."))}
  ${acc("hotels","🏨","Hoteller",HOTEL_INFO.map((h,i)=>`<div style="${i<HOTEL_INFO.length-1?"margin-bottom:13px;padding-bottom:13px;border-bottom:1px solid var(--border2)":""}"><div style="font-weight:800;font-size:13.5px;color:var(--gold2);margin-bottom:6px">${esc(h.n)}</div>${irow("Booking",h.ref)}${irow("Datoer",h.d)}${irow("Rom",h.r)}${irow("Adresse",h.adr)}${irow("Telefon",h.tel,true)}</div>`).join(""))}
  ${acc("meta","👤","USA Tours & Betingelser",[["Reisekonsulent","Elin Gran"],["E-post","egr@usatours.no"],["Telefon","+47 21 95 01 49",true],["Tilbudsnr","NO13752"],["Total pris","155 700 kr"]].map(([l,v,ph])=>irow(l,v,ph)).join("")+wbox("wgold","USA Tours · Vesterbrogade 149 · 1620 København V · CVR: 26179653<br>Teknisk arrangør: Top Tours ApS · Rejsegarantifonden nr. 1478<br><b>Avbestilling etter forfallsdato = mister full pris.</b>"))}`;
}

function showDiagnostics(){
  const errs=getErrors();
  const box=document.getElementById("modal-box");
  document.getElementById("modal").classList.add("open");
  box.innerHTML=`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px">
    <div class="serif" style="font-size:18px;color:var(--gold2);font-style:italic">⚠️ Diagnostikk · ${errs.length} feil</div>
    <button onclick="closeModal()" style="background:none;border:none;color:var(--t3);font-size:22px;cursor:pointer;padding:4px;line-height:1" aria-label="Lukk">✕</button>
  </div>
  <div style="font-size:11.5px;color:var(--t2);margin-bottom:10px;line-height:1.55">Kopier teksten under og send til Robert hvis noe oppfører seg rart.</div>
  ${errs.length===0?`<div style="font-size:13px;color:var(--green);text-align:center;padding:20px">✅ Ingen feil registrert</div>`
    :`<textarea readonly style="width:100%;height:240px;background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:10px;color:var(--t1);font-family:monospace;font-size:11px;line-height:1.5;resize:none">${esc(JSON.stringify(errs,null,2))}</textarea>
      <button class="btn btn-ghost btn-sm" style="margin-top:10px;width:100%" onclick="clearDiagnostics()">🗑 Tøm logg</button>`}`;
}

function clearDiagnostics(){
  if(!confirm("Slett alle registrerte feil?")) return;
  clearErrors();
  closeModal();
  if(S.tab==="klar"&&S.sub==="info") renderPage();
}

/* ═══════════════════════ HANDLINGSLISTE (book & forbered) ═══════════════════════ */
function renderActionList(){
  const ids=ACTION_LIST.flatMap(g=>g.items.map(i=>i.id));
  const done=ids.filter(id=>S.chk[id]).length,total=ids.length;
  const pct=total?Math.round(100*done/total):0;
  return `<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px">
    <div class="page-title" style="margin-bottom:0">📋 Handlingsliste før avreise</div>
    <span style="font-size:14px;font-weight:700;color:${pct===100?"var(--green)":"var(--gold)"}">${done}/${total}</span>
  </div>
  <div class="page-sub">Book og forbered — hva, hvorfor, hvordan og ca. pris. Priser bør verifiseres på lenkene.</div>
  <div class="prog" style="margin-bottom:16px"><div class="prog-fill" style="width:${pct}%;background:${pct===100?"var(--green)":"var(--gold)"}"></div></div>
  ${ACTION_LIST.map(group=>`<div style="margin-bottom:14px">
    <div class="sec-lbl" style="margin-top:0">${group.g}</div>
    ${group.items.map(it=>{
      const on=!!S.chk[it.id];
      return `<div class="card" style="margin-bottom:8px;padding:12px 13px;${on?"opacity:.62":""}">
        <div style="display:flex;gap:11px;align-items:flex-start">
          <div class="chk-box${on?" on":""}" onclick="toggleChk('${it.id}')" style="cursor:pointer;flex-shrink:0;margin-top:1px">${on?`<span style="color:#080f1a;font-size:11px;font-weight:900">✓</span>`:""}</div>
          <div style="flex:1;min-width:0">
            <div style="display:flex;justify-content:space-between;gap:8px;align-items:baseline">
              <div style="font-size:13.5px;font-weight:700;color:var(--t1);${on?"text-decoration:line-through":""}">${esc(it.what)}</div>
              ${it.price?`<div style="font-size:11px;font-weight:700;color:var(--gold2);white-space:nowrap;flex-shrink:0">${esc(it.price)}</div>`:""}
            </div>
            ${it.why?`<div style="font-size:11.5px;color:var(--t2);line-height:1.5;margin-top:4px"><strong style="color:var(--t1)">Hvorfor:</strong> ${esc(it.why)}</div>`:""}
            ${it.how?`<div style="font-size:11.5px;color:var(--t3);line-height:1.5;margin-top:2px"><strong style="color:var(--t2)">Hvordan:</strong> ${esc(it.how)}</div>`:""}
            ${it.url?`<a href="${safeUrl(it.url)}" target="_blank" rel="noopener" style="display:inline-block;margin-top:6px;font-size:11.5px;color:var(--sky);font-weight:600;text-decoration:none">Åpne lenke ↗</a>`:""}
          </div>
        </div>
      </div>`;
    }).join("")}
  </div>`).join("")}
  <div style="height:8px"></div>`;
}

/* ═══════════════════════ SJEKKLISTE ═══════════════════════ */
function renderSjekk(){
  const done=doneChk(),total=totalChk(),pct=sjekkPct();
  return renderPreflight()+renderActionList()+`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px;margin-top:6px">
    <div class="page-title" style="margin-bottom:0">Sjekkliste</div>
    <span style="font-size:14px;font-weight:700;color:${pct===100?"var(--green)":"var(--gold)"}">${done}/${total}</span>
  </div>
  <div class="page-sub">${pct}% fullført</div>
  <div class="prog" style="margin-bottom:20px"><div class="prog-fill" style="width:${pct}%;background:${pct===100?"var(--green)":"var(--gold)"}"></div></div>
  ${CHKLST.map(group=>`<div style="margin-bottom:18px">
    <div class="sec-lbl">${group.g}</div>
    ${group.items.map(item=>`<div class="chk-row" onclick="toggleChk('${item.id}')">
      <div class="chk-box${S.chk[item.id]?" on":""}">
        ${S.chk[item.id]?`<span style="color:#080f1a;font-size:11px;font-weight:900">✓</span>`:""}
      </div>
      <span style="font-size:13px;line-height:1.6;color:${S.chk[item.id]?"var(--t3)":"var(--t1)"};text-decoration:${S.chk[item.id]?"line-through":"none"}">${esc(item.t)}</span>
    </div>`).join("")}
  </div>`).join("")}
  ${pct===100?`<div style="text-align:center;padding:28px 20px;border-radius:var(--r);background:rgba(52,211,153,.06);border:1px solid rgba(52,211,153,.2)"><div style="font-size:44px;margin-bottom:10px">🎉</div><div class="serif" style="font-size:20px;color:var(--green);font-style:italic">Alt er i orden!</div><div style="font-size:13px;color:var(--t2);margin-top:6px">God reise, Robert, Margita &amp; Nicholas! 🍁</div></div>`:""}`;
}


/* ═══════════════════════ SEARCH ═══════════════════════ */
// F10 — foreslåtte spørsmål for naturlig språk-søk
const SEARCH_SUGGESTIONS=[
  "Når lander vi i Vancouver?",
  "Hvilken dag er Margitas bursdag?",
  "Hvor er det Wi-Fi på cruiset?",
  "Hvor mye bagasje får vi ta med?",
  "Når må vi være på cruiseterminalen?",
  "Hvilken pier i Skagway?",
];
function searchEmptyHTML(){
  const isFj=document.body.classList.contains("feltjournal");
  if(!isFj){
    return `<div style="text-align:center;padding:40px 20px;color:var(--t3)"><div style="font-size:36px;margin-bottom:10px">🔍</div><div style="font-size:13px">Søk på dager, destinasjoner,<br>hoteller og referansenumre</div></div>`;
  }
  return `<div class="fj-search-empty">
    <div class="fj-search-hint">Spør om hva som helst på reisen</div>
    <div class="fj-search-lbl">Foreslåtte spørsmål</div>
    ${SEARCH_SUGGESTIONS.map(q=>`<button class="fj-search-suggest" onclick="document.getElementById('search-input').value='${esc(q)}';doSearch('${esc(q)}')">${esc(q)}</button>`).join("")}
  </div>`;
}
function openSearch(){document.getElementById("search-overlay").classList.add("open");document.getElementById("search-results").innerHTML=searchEmptyHTML();setTimeout(()=>document.getElementById("search-input")?.focus(),100);}
function closeSearch(){document.getElementById("search-overlay").classList.remove("open");document.getElementById("search-input").value="";document.getElementById("search-results").innerHTML=searchEmptyHTML();}

function doSearch(q){
  const el=document.getElementById("search-results");
  if(!q.trim()){el.innerHTML=searchEmptyHTML();return;}
  const lq=q.toLowerCase();
  const results=[];
  DAYS.forEach((d,i)=>{
    if([d.title,d.d,d.wd,d.tag,d.hotel,d.href,...d.items.map(it=>it.v+it.s)].join(" ").toLowerCase().includes(lq))
      results.push({type:"📅 Dag",title:d.title,sub:d.wd+" "+d.d,action:`setTab('reisen','plan');S.openDay=${i};renderPage();closeSearch()`});
  });
  DESTS.forEach((dest,di)=>{
    if((dest.name+" "+dest.dates+" "+dest.desc).toLowerCase().includes(lq))
      results.push({type:"🌍 Destinasjon",title:dest.name,sub:dest.dates+" · "+dest.acts.length+" aktiviteter",action:`setTab('reisen','dest');S.destIdx=${di};renderPage();closeSearch()`});
    dest.acts.filter(a=>(a.n+" "+a.d).toLowerCase().includes(lq)).forEach(a=>
      results.push({type:"🎯 Aktivitet",title:a.n,sub:dest.name+" · "+a.p,action:`setTab('reisen','dest');S.destIdx=${di};S.filter='Alle';renderPage();closeSearch()`}));
  });
  S.acts.filter(a=>(a.name+" "+a.bookingRef+" "+a.notes+" "+a.meetingPoint).toLowerCase().includes(lq)).forEach(a=>
    results.push({type:"📌 Min aktivitet",title:a.name,sub:SC[a.status]?.l||"",action:`setTab('reisen','mine');renderPage();closeSearch()`}));
  HOTEL_INFO.filter(h=>(h.n+" "+h.ref+" "+h.adr).toLowerCase().includes(lq)).forEach(h=>
    results.push({type:"🏨 Hotell",title:h.n,sub:"Ref: "+h.ref+" · "+h.d,action:`setTab('klar','info');S.openAcc='hotels';renderPage();closeSearch()`}));
  FLY_INFO.filter(f=>(f.l+" "+f.v).toLowerCase().includes(lq)).forEach(f=>
    results.push({type:"✈️ Flyinfo",title:f.l,sub:f.v,action:`setTab('klar','info');S.openAcc='fly';renderPage();closeSearch()`}));
  SOS.filter(s=>(s.l+" "+s.v).toLowerCase().includes(lq)).forEach(s=>
    results.push({type:"🆘 Nødkontakt",title:s.l,sub:s.v,action:`setTab('klar','info');S.openAcc='sos';renderPage();closeSearch()`}));
  // Search curated day guide
  Object.entries(DAY_GUIDE).forEach(([dayIdx,guide])=>{
    const day=DAYS[parseInt(dayIdx)];
    const dayLabel=day?day.d+" · ":"";
    guide.acts?.filter(a=>(a.n+" "+a.op+" "+a.tip).toLowerCase().includes(lq)).forEach(a=>
      results.push({type:"✨ Aktivitet",title:a.n,sub:dayLabel+a.op+" · "+a.p,action:`setTab('reisen','plan');S.openDay=${dayIdx};S['dgt${dayIdx}']='acts';renderPage();closeSearch()`}));
    guide.eat?.filter(r=>(r.n+" "+r.tip+" "+(r.adr||"")).toLowerCase().includes(lq)).forEach(r=>
      results.push({type:"🍽️ Restaurant",title:r.n,sub:dayLabel+r.type+" · "+r.p,action:`setTab('reisen','plan');S.openDay=${dayIdx};S['dgt${dayIdx}']='eat';renderPage();closeSearch()`}));
    guide.see?.filter(v=>(v.n+" "+v.tip).toLowerCase().includes(lq)).forEach(v=>
      results.push({type:"📷 Se & opplev",title:v.n,sub:dayLabel+v.type,action:`setTab('reisen','plan');S.openDay=${dayIdx};S['dgt${dayIdx}']='see';renderPage();closeSearch()`}));
  });

  el.innerHTML=results.length===0
    ?`<div style="text-align:center;padding:40px 20px;color:var(--t3)"><div style="font-size:32px;margin-bottom:10px">😕</div><div style="font-size:13px">Ingen resultater for «${esc(q)}»</div></div>`
    :results.map(r=>`<div class="s-result" onclick="${r.action}">
      <div style="font-size:9.5px;color:var(--gold);font-weight:800;text-transform:uppercase;letter-spacing:.8px;margin-bottom:4px">${r.type}</div>
      <div style="font-weight:600;font-size:13.5px">${esc(r.title)}</div>
      <div style="font-size:11.5px;color:var(--t3);margin-top:3px">${esc(r.sub)}</div>
    </div>`).join("");
}

/* ═══════════════════════ MER DRAWER ═══════════════════════ */
function openMer(){document.getElementById("mer-overlay").classList.add("open");document.getElementById("mer-drawer").classList.add("open");}
function closeMer(){document.getElementById("mer-overlay").classList.remove("open");document.getElementById("mer-drawer").classList.remove("open");}

/* ═══════════════════════ MODALS ═══════════════════════ */
function openAddModal(){S.form={name:"",destination:"",date:"",status:"idea",priceCad:"",priceNok:"",bookingRef:"",meetingPoint:"",contact:"",notes:""};S.editId=null;S.editType="act";renderModal();}
function editAct(id){const a=S.acts.find(x=>x.id===id);if(a){S.form={...a};S.editId=id;S.editType="act";renderModal();}}
function addFromSuggestion(di,ai){const dest=DESTS[di],act=dest.acts[ai];S.form={name:act.n,destination:dest.id,status:"idea",priceCad:"",priceNok:"",bookingRef:"",meetingPoint:"",contact:"",notes:`${act.d} · Pris: ${act.p} · Varighet: ${act.dur}`,date:""};S.editId=null;S.editType="act";renderModal();}

function openBudgetModal(){S.form={desc:"",cat:BUDGET_CATS[0].id,amtCad:"",amtNok:"",date:new Date().toISOString().slice(0,10),payer:"Felles"};S.editId=null;S.editType="budget";renderModal();}

function renderModal(){
  const m=document.getElementById("modal"),box=document.getElementById("modal-box");
  if(S.editType==="act"){
    const f=S.form;
    box.innerHTML=`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:17px">
      <div class="serif" style="font-size:20px;color:var(--gold2);font-style:italic">${S.editId?"Rediger aktivitet":"Ny aktivitet"}</div>
      <button onclick="closeModal()" style="background:none;border:none;color:var(--t3);font-size:24px;cursor:pointer;padding:4px;line-height:1" aria-label="Lukk">✕</button>
    </div>
    <div class="fg"><label class="fl">Navn *</label><input class="fi" id="mf-name" value="${esc(f.name||"")}" placeholder="Aktivitetsnavn"></div>
    <div class="frow">
      <div class="fg"><label class="fl">Destinasjon</label><select class="fi" id="mf-dest"><option value="">Velg sted</option>${DESTS.map(d=>`<option value="${d.id}"${f.destination===d.id?" selected":""}>${d.em} ${esc(d.name)}</option>`).join("")}</select></div>
      <div class="fg"><label class="fl">Dato</label><input class="fi" type="date" id="mf-date" value="${esc(f.date||"")}"></div>
    </div>
    <div class="fg"><label class="fl">Status</label>
      <div style="display:flex;gap:6px">${Object.entries(SC).map(([k,v])=>`<button onclick="S.form.status='${k}';renderModal()" style="flex:1;padding:9px 4px;border-radius:9px;cursor:pointer;border:none;font-size:11px;font-weight:700;font-family:var(--font);background:${f.status===k?v.bg:"rgba(255,255,255,.04)"};color:${f.status===k?v.c:"var(--t3)"};outline:${f.status===k?`1px solid ${v.c}`:"none"}">${v.l}</button>`).join("")}</div>
    </div>
    <div class="frow">
      <div class="fg"><label class="fl">Pris CAD</label><input class="fi" type="number" id="mf-cad" value="${esc(f.priceCad||"")}" placeholder="0"></div>
      <div class="fg"><label class="fl">Antatt NOK</label><input class="fi" type="number" id="mf-nok" value="${esc(f.priceNok||"")}" placeholder="0"></div>
    </div>
    <div class="fg"><label class="fl">Bookingreferanse</label><input class="fi" id="mf-ref" value="${esc(f.bookingRef||"")}" placeholder="Bestillingsnummer"></div>
    <div class="fg"><label class="fl">Møtepunkt</label><input class="fi" id="mf-meet" value="${esc(f.meetingPoint||"")}" placeholder="Adresse, kai, inngang..."></div>
    <div class="fg"><label class="fl">Kontakt</label><input class="fi" id="mf-contact" value="${esc(f.contact||"")}" placeholder="Telefon / e-post"></div>
    <div class="fg"><label class="fl">Notater</label><textarea class="fi" id="mf-notes" rows="3" placeholder="Tips, hva som er inkludert...">${esc(f.notes||"")}</textarea></div>
    <button class="btn btn-gold" style="width:100%;padding:14px;font-size:14px;margin-top:4px" onclick="saveActModal()">${S.editId?"Lagre endringer":"Legg til"}</button>`;
  }else{
    const f=S.form;
    box.innerHTML=`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:17px">
      <div class="serif" style="font-size:20px;color:var(--gold2);font-style:italic">Registrer utgift</div>
      <button onclick="closeModal()" style="background:none;border:none;color:var(--t3);font-size:24px;cursor:pointer;padding:4px;line-height:1" aria-label="Lukk">✕</button>
    </div>
    <div class="fg"><label class="fl">Beskrivelse *</label><input class="fi" id="bf-desc" value="${esc(f.desc||"")}" placeholder="Hva kjøpte du?"></div>
    <div class="fg"><label class="fl">Kategori</label><select class="fi" id="bf-cat">${BUDGET_CATS.map(c=>`<option value="${c.id}"${f.cat===c.id?" selected":""}>${c.ic} ${c.name}</option>`).join("")}</select></div>
    <div class="frow">
      <div class="fg"><label class="fl">Beløp CAD</label><input class="fi" type="number" id="bf-cad" value="${esc(f.amtCad||"")}" placeholder="0" oninput="autoConvertBudget()"></div>
      <div class="fg"><label class="fl">Beløp NOK</label><input class="fi" type="number" id="bf-nok" value="${esc(f.amtNok||"")}" placeholder="0" oninput="autoConvertBudget2()"></div>
    </div>
    <div class="fg"><label class="fl">Dato</label><input class="fi" type="date" id="bf-date" value="${esc(f.date||new Date().toISOString().slice(0,10))}"></div>
    <div class="fg"><label class="fl">Betalt av</label>
      <div style="display:flex;gap:6px">${["Felles","Robert","Margita"].map(p=>`<button onclick="S.form.payer='${p}';renderModal()" style="flex:1;padding:9px 4px;border-radius:9px;cursor:pointer;border:none;font-size:12px;font-weight:700;font-family:var(--font);background:${(f.payer||"Felles")===p?"var(--gold)":"rgba(255,255,255,.04)"};color:${(f.payer||"Felles")===p?"#080f1a":"var(--t2)"}">${p}</button>`).join("")}</div>
      <div style="font-size:10.5px;color:var(--t3);margin-top:6px;line-height:1.5">Felles = delt 50/50 (f.eks. felleskonto). Robert/Margita = personlig kort, splittes ved oppgjør.</div>
    </div>
    <button class="btn btn-gold" style="width:100%;padding:14px;font-size:14px;margin-top:4px" onclick="saveBudgetModal()">Legg til utgift</button>`;
  }
  m.classList.add("open");
}

function autoConvertBudget(){const cad=parseFloat(document.getElementById("bf-cad")?.value)||0;const n=document.getElementById("bf-nok");if(n&&cad)n.value=cadToNok(cad).toFixed(0);}
function autoConvertBudget2(){const nok=parseFloat(document.getElementById("bf-nok")?.value)||0;const c=document.getElementById("bf-cad");if(c&&nok)c.value=(nok/(liveRates?.["CAD-NOK"]||7.65)).toFixed(2);}

function saveActModal(){
  const name=document.getElementById("mf-name")?.value?.trim();
  if(!name){document.getElementById("mf-name")?.focus();return;}
  const act={id:S.editId||Date.now()+"",name,destination:document.getElementById("mf-dest")?.value||"",date:document.getElementById("mf-date")?.value||"",status:S.form.status||"idea",priceCad:document.getElementById("mf-cad")?.value||"",priceNok:document.getElementById("mf-nok")?.value||"",bookingRef:document.getElementById("mf-ref")?.value||"",meetingPoint:document.getElementById("mf-meet")?.value||"",contact:document.getElementById("mf-contact")?.value||"",notes:document.getElementById("mf-notes")?.value||""};
  S.acts=S.editId?S.acts.map(a=>a.id===S.editId?act:a):[...S.acts,act];
  saveActs();closeModal();setTab("reisen","mine");
}

function saveBudgetModal(){
  const desc=document.getElementById("bf-desc")?.value?.trim();
  if(!desc){document.getElementById("bf-desc")?.focus();return;}
  const amtCad=parseFloat(document.getElementById("bf-cad")?.value)||0;
  const amtNok=parseFloat(document.getElementById("bf-nok")?.value)||(cadToNok(amtCad));
  S.budgetEntries=[...S.budgetEntries,{id:Date.now()+"",desc,cat:document.getElementById("bf-cat")?.value||"annet",amtCad,amtNok,date:document.getElementById("bf-date")?.value||"",payer:S.form.payer||"Felles"}];
  saveBudget();closeModal();renderPage();
}

function editBudgetTarget(){
  const cur=S.budgetTarget;
  const box=document.getElementById("modal-box");
  document.getElementById("modal").classList.add("open");
  box.innerHTML=`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:17px">
    <div class="serif" style="font-size:20px;color:var(--gold2);font-style:italic">Endre budsjettramme</div>
    <button onclick="closeModal()" style="background:none;border:none;color:var(--t3);font-size:24px;cursor:pointer;padding:4px;line-height:1" aria-label="Lukk">✕</button>
  </div>
  <div class="fg"><label class="fl">Budsjettramme (CAD) for ekstra utgifter</label><input class="fi" type="number" id="bt-val" value="${cur}" min="0" step="100"></div>
  <div style="font-size:12px;color:var(--t2);margin-bottom:14px">≈ ${cadToNok(cur).toFixed(0)} NOK · kun ekstra utgifter utover det som er betalt hjemme</div>
  <button class="btn btn-gold" style="width:100%;padding:14px;font-size:14px" onclick="saveBudgetTarget()">Lagre</button>`;
}

function saveBudgetTarget(){
  const v=parseFloat(document.getElementById("bt-val")?.value)||6000;
  S.budgetTarget=v;try{localStorage.setItem("ca26btarget",v);}catch{}
  closeModal();renderPage();
}

function closeModal(){document.getElementById("modal").classList.remove("open");}

/* ═══════════════════════ EVENT HANDLERS ═══════════════════════ */
function toggleDay(i){S.openDay=S.openDay===i?null:i;haptic('light');renderPage();}
function toggleAcc(id){S.openAcc=S.openAcc===id?null:id;renderPage();}
function toggleClimate(){S.climateOpen=S.climateOpen===false;renderPage();}
function toggleChk(id){S.chk[id]=!S.chk[id];saveChk();renderPage();}
function togglePackChk(id){S.packChk[id]=!S.packChk[id];savePackChk();renderPage();}
function resetPacking(){if(confirm("Nullstill hele pakkelisten?"))S.packChk={};savePackChk();renderPage();}
function toggleExp(id){
  const el=document.getElementById(id),lbl=document.getElementById(id+"_lbl");
  if(el){const show=el.style.display==="none";el.style.display=show?"block":"none";if(lbl)lbl.textContent=show?"▲ Skjul":"▼ Vis detaljer";}
}
function deleteAct(id){if(confirm("Slett aktivitet?"))S.acts=S.acts.filter(a=>a.id!==id);saveActs();renderNav();renderPage();}
function deleteBudgetEntry(id){S.budgetEntries=S.budgetEntries.filter(e=>e.id!==id);saveBudget();renderPage();}

/* ═══════════════════════ OFFLINE KARTFLISER (#1) ═══════════════════════
   VIKTIG: feltjournal-kartet (MapLibre) tegner cartocdn voyager-raster, ikke
   OSM. Tidligere lastet vi ned OSM-fliser som kartet aldri ber om — så «offline-
   kartet» var blankt på cruiset. Her laster vi ned de FAKTISKE kildene kartet
   bruker (voyager + labels), med grov oversikt over hele korridoren og tette
   høyzoom-bokser rundt hver havn/by der man faktisk navigerer til fots. */

// Kildene MapLibre-stilen ber om (uten subdomene — SW normaliserer til «a.»).
const OFFLINE_TILE_SRCS = [
  "https://a.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png",
  "https://a.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}.png",
];

// Grov korridor-oversikt (lavt zoom, hele ruten).
const TILE_REGIONS = [
  { latMin:48.0, latMax:60.5, lngMin:-137, lngMax:-113, z:[5,6,7] },
];

// Tette høyzoom-bokser (±~0.25°) rundt stedene man går rundt på til fots.
const TILE_TOWNS = [
  { lat:49.289, lng:-123.112 }, // Vancouver
  { lat:58.129, lng:-135.458 }, // Icy Strait Point
  { lat:59.458, lng:-135.314 }, // Skagway
  { lat:58.301, lng:-134.419 }, // Juneau
  { lat:55.341, lng:-131.647 }, // Ketchikan
  { lat:50.674, lng:-120.327 }, // Kamloops
  { lat:52.873, lng:-118.081 }, // Jasper
  { lat:51.426, lng:-116.180 }, // Lake Louise / Moraine
  { lat:51.178, lng:-115.570 }, // Banff
  { lat:51.045, lng:-114.072 }, // Calgary
];
const TOWN_PAD = 0.28;           // graders radius rundt hvert sted
const TOWN_ZOOMS = [9,10,11];    // detaljnivå for gå-tur-navigasjon

function buildRouteTileUrls(){
  const set = new Set();
  const addBox = (latMin,latMax,lngMin,lngMax,zooms) => {
    for(const z of zooms){
      const xMin=lng2tile(lngMin,z),xMax=lng2tile(lngMax,z);
      const yMin=lat2tile(latMax,z),yMax=lat2tile(latMin,z);
      for(let x=xMin;x<=xMax;x++) for(let y=yMin;y<=yMax;y++)
        for(const tpl of OFFLINE_TILE_SRCS)
          set.add(tpl.replace("{z}",z).replace("{x}",x).replace("{y}",y));
    }
  };
  for(const r of TILE_REGIONS) addBox(r.latMin,r.latMax,r.lngMin,r.lngMax,r.z);
  for(const t of TILE_TOWNS) addBox(t.lat-TOWN_PAD,t.lat+TOWN_PAD,t.lng-TOWN_PAD,t.lng+TOWN_PAD,TOWN_ZOOMS);
  return [...set];
}

function cacheTilesForRoute(){
  if(!("serviceWorker" in navigator)||!navigator.serviceWorker.controller){
    showToast("Service Worker ikke klar — prøv igjen");return;
  }
  const btn=document.getElementById("cache-tiles-btn");
  const status=document.getElementById("cache-tiles-status");
  const urls=buildRouteTileUrls();
  const estMb=(urls.length*22/1024).toFixed(0); // ~22 kB/flis i snitt
  if(btn){btn.disabled=true;btn.textContent="⏳ Laster ned...";}
  if(status)status.textContent=`Laster ned ${urls.length} fliser (~${estMb} MB)…`;
  navigator.serviceWorker.controller.postMessage({type:"CACHE_TILES",urls});
}
function lng2tile(lng,z){return Math.floor((lng+180)/360*Math.pow(2,z));}
function lat2tile(lat,z){return Math.floor((1-Math.log(Math.tan(lat*Math.PI/180)+1/Math.cos(lat*Math.PI/180))/Math.PI)/2*Math.pow(2,z));}

if("serviceWorker" in navigator){
  navigator.serviceWorker.addEventListener("message",e=>{
    if(e.data?.type==="TILES_CACHED"){
      const btn=document.getElementById("cache-tiles-btn");
      const status=document.getElementById("cache-tiles-status");
      if(btn){btn.disabled=false;btn.textContent="💾 Last ned kart offline";}
      if(status)status.textContent=`✅ ${e.data.cached}/${e.data.total} fliser lagret`;
      try{ if(e.data.cached>0) localStorage.setItem("ca26_offline_maps",String(Date.now())); }catch{}
      showToast(`🗺️ ${e.data.cached} kartfliser lagret offline!`);
      if(S.tab==="idag")renderPage();
    }
  });
}

/* ═══════════════════════ OFFLINE-BEREDSKAP (#3) ═══════════════════════ */
// Ett trykk: last ned kart for hele ruten + vær + reisevakt. Dokumenter
// legges i offline-koffert manuelt (kryptert). Viser en beredskapsmåler.
function prepareAllOffline(){
  cacheTilesForRoute();                                  // kart-fliser for ruten
  try{ precacheTrip(0, DAYS.length-1, "Hele turen"); }catch{}  // vær
  try{ reloadAlerts(); }catch{}                          // reisevakt (og cacher siste svar)
  try{ localStorage.setItem("ca26_offline_prep", String(Date.now())); }catch{}
  showToast("📥 Forbereder offline — kart, vær og varsler lastes ned…");
}
function renderOfflineReadiness(){
  const os=getOfflineState();
  const has=k=>{try{return !!localStorage.getItem(k);}catch{return false;}};
  const swReady=!!(navigator.serviceWorker&&navigator.serviceWorker.controller);
  const mapsReady=os.daysReady>0||has("ca26_offline_maps");
  const wxAlertsReady=has("ca26_alerts_v1")||!!os.lastPrecache;
  const checks=[
    ["📱","Appen (virker uten nett)",swReady],
    ["🗺️","Kart for hele ruten",mapsReady],
    ["🌦️","Vær &amp; Reisevakt",wxAlertsReady],
  ];
  const done=checks.filter(c=>c[2]).length;
  const pct=Math.round(100*done/checks.length);
  const store=os.storageUsed?(os.storageUsed<1048576?Math.round(os.storageUsed/1024)+" kB":(os.storageUsed/1048576).toFixed(1)+" MB"):"";
  const allReady=done===checks.length;
  return `<div class="card" style="margin-bottom:12px">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
      <div style="font-size:12px;font-weight:800;color:var(--gold);letter-spacing:.3px">📴 Offline-beredskap <span style="font-weight:500;color:var(--t3)">· for strekk uten dekning</span></div>
      <span style="font-size:13px;font-weight:800;color:${allReady?"var(--green)":"var(--gold)"}">${pct}%</span>
    </div>
    <div class="prog" style="margin-bottom:10px"><div class="prog-fill" style="width:${pct}%;background:${allReady?"var(--green)":"var(--gold)"}"></div></div>
    ${checks.map(c=>`<div style="display:flex;align-items:center;gap:9px;padding:4px 0;font-size:12.5px;color:var(--t1)">
      <span>${c[0]}</span><span style="flex:1">${c[1]}</span>
      <span style="font-weight:800;color:${c[2]?"var(--green)":"var(--t3)"}">${c[2]?"✓":"○"}</span>
    </div>`).join("")}
    <div style="display:flex;align-items:center;gap:9px;padding:4px 0;font-size:12.5px;color:var(--t2)">
      <span>🔐</span><span style="flex:1">Dokumenter i offline-koffert</span>
      <button onclick="setTab('klar','dok')" style="background:none;border:none;color:var(--sky);font-size:11px;font-weight:700;cursor:pointer">Åpne →</button>
    </div>
    <button onclick="prepareAllOffline()" class="btn btn-gold btn-sm" style="width:100%;margin-top:10px">📥 Gjør alt klart offline</button>
    <div style="font-size:10px;color:var(--t3);margin-top:7px">${allReady?"✅ Klar for Icefields Parkway og andre strekk uten dekning.":"Gjør dette på wifi hjemme før avreise."}${store?` · ${store} lagret`:""}</div>
  </div>`;
}

/* ═══════════════════════ BUDSJETT-PROJEKSJON ═══════════════════════ */
function renderBudgetProjection(entries,totalCad){
  if(entries.length===0)return"";
  const now=new Date();
  const tripDay=getTripDay();
  // Calculate days with spending
  let daysElapsed=1;
  if(tripDay>=0){
    daysElapsed=tripDay+1;
  } else if(entries.length>0){
    const firstDate=entries.reduce((m,e)=>e.date&&e.date<m?e.date:m,entries[0].date||"");
    const lastDate=entries.reduce((m,e)=>e.date&&e.date>m?e.date:m,entries[0].date||"");
    if(firstDate&&lastDate){
      const d1=new Date(firstDate),d2=new Date(lastDate);
      daysElapsed=Math.max(1,Math.round((d2-d1)/86400000)+1);
    }
  }
  const dailyAvg=totalCad/daysElapsed;
  const tripDays=18;
  const dailyBudget=S.budgetTarget/tripDays;
  const projected=dailyAvg*tripDays;
  const projPct=Math.min(150,Math.round(projected/S.budgetTarget*100));
  const overBudget=projected>S.budgetTarget;
  const projColor=projPct>100?"var(--red)":projPct>80?"var(--amber)":"var(--green)";

  return`<div class="card" style="margin-bottom:14px;border:1px solid ${overBudget?"rgba(248,113,113,.3)":"rgba(52,211,153,.3)"}">
    <div style="font-size:9.5px;color:var(--t3);font-weight:800;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px">📊 Daglig forbruk & projeksjon</div>
    <div style="display:flex;gap:12px;margin-bottom:12px">
      <div style="flex:1;padding:10px;background:var(--bg2);border-radius:var(--r3);text-align:center">
        <div style="font-size:10px;color:var(--t3);margin-bottom:3px">Daglig snitt</div>
        <div style="font-size:18px;font-weight:800;color:${projColor}">${dailyAvg.toFixed(0)}</div>
        <div style="font-size:10px;color:var(--t3)">CAD/dag</div>
      </div>
      <div style="flex:1;padding:10px;background:var(--bg2);border-radius:var(--r3);text-align:center">
        <div style="font-size:10px;color:var(--t3);margin-bottom:3px">Daglig budsjett</div>
        <div style="font-size:18px;font-weight:800;color:var(--t1)">${dailyBudget.toFixed(0)}</div>
        <div style="font-size:10px;color:var(--t3)">CAD/dag</div>
      </div>
    </div>
    <div style="margin-bottom:6px;display:flex;justify-content:space-between;align-items:center">
      <span style="font-size:11px;color:var(--t2)">Projisert totalt (18 dager)</span>
      <span style="font-size:13px;font-weight:700;color:${projColor}">${projected.toFixed(0)} CAD</span>
    </div>
    <div class="prog"><div class="prog-fill" style="width:${Math.min(100,projPct)}%;background:${projColor}"></div></div>
    <div style="font-size:10.5px;color:${projColor};margin-top:5px;font-weight:600">${overBudget?`⚠️ ${(projected-S.budgetTarget).toFixed(0)} CAD over budsjett i dette tempoet`:`✅ ${(S.budgetTarget-projected).toFixed(0)} CAD under budsjett — godt tempo!`}</div>
    ${liveRates?.["CAD-NOK"]?`<div style="font-size:10px;color:var(--t3);margin-top:4px">Kurs: 1 CAD = ${liveRates["CAD-NOK"].toFixed(2)} NOK (live)</div>`:""}
  </div>`;
}

/* ═══════════════════════ DEL DAGSPLAN ═══════════════════════ */
function shareDayPlan(i){
  const day=DAYS[i];if(!day)return;
  const lines=[`${day.em} ${day.title} — ${day.wd} ${day.d}`,""];
  day.items.forEach(it=>{lines.push(`${it.t}: ${it.v}${it.s?" ("+it.s+")":""}`);});
  if(day.hotel){lines.push("");lines.push(`🏨 ${day.hotel}`);if(day.hadr)lines.push(`📍 ${day.hadr}`);}
  const text=lines.join("\n");
  if(navigator.share){navigator.share({title:day.title,text}).catch(()=>{});}
  else{navigator.clipboard?.writeText(text).then(()=>showToast("Kopiert til utklippstavle!")).catch(()=>{});}
}

/* ═══════════════════════ SPLASH ═══════════════════════ */
const DEPARTURE = new Date("2026-07-17T13:50:00+02:00");
const RETURN    = new Date("2026-08-03T15:25:00+02:00");

function enterApp(){
  const sp=document.getElementById("splash");
  if(sp){sp.classList.add("hidden");setTimeout(()=>sp.style.display="none",520);}
  try{sessionStorage.setItem("ca26entered","1");}catch{}
}
function initSplash(){
  // enterApp er definert i inline script over – ingenting å gjøre her
}

/* ═══════════════════════ TEMA ═══════════════════════ */
/* 3-veis: feltjournal (default) → mørk → lys → feltjournal ... */
const THEME_CYCLE=["feltjournal","dark","light"];
function applyTheme(theme){
  document.body.classList.remove("light","feltjournal");
  if(theme==="light")document.body.classList.add("light");
  else if(theme==="feltjournal")document.body.classList.add("feltjournal");
  try{localStorage.setItem("ca26theme",theme);}catch{}
  updateThemeBtn(theme);
  if(S.tab==="kart"&&typeof leafletMap!=="undefined"&&leafletMap){
    setTimeout(()=>{leafletMap.invalidateSize();},50);
  }
}
function toggleTheme(){
  const cur=getCurrentTheme();
  const next=THEME_CYCLE[(THEME_CYCLE.indexOf(cur)+1)%THEME_CYCLE.length];
  applyTheme(next);
}
function getCurrentTheme(){
  if(document.body.classList.contains("feltjournal"))return "feltjournal";
  if(document.body.classList.contains("light"))return "light";
  return "dark";
}
function updateThemeBtn(theme){
  const map={feltjournal:["🌙 Mørkt","🌙"],dark:["☀️ Lyst","☀️"],light:["📓 Journal","📓"]};
  const [full,short]=map[theme]||map.feltjournal;
  const b1=document.getElementById("theme-btn");
  const b2=document.getElementById("theme-btn-m");
  if(b1)b1.textContent=full;
  if(b2)b2.textContent=short;
}
function loadTheme(){
  let t="feltjournal";
  try{const stored=localStorage.getItem("ca26theme");if(stored)t=stored;}catch{}
  applyTheme(t);
}

/* ═══════════════════════ NEDTELLING (app header) ═══════════════════════ */
function updateCountdown(){
  const now=new Date();
  const mob=document.getElementById("mobile-countdown");
  const top=document.getElementById("topbar-countdown");

  let html="";
  if(now < DEPARTURE){
    const diff=DEPARTURE-now;
    const days=Math.floor(diff/86400000);
    const hrs=Math.floor((diff%86400000)/3600000);
    const mins=Math.floor((diff%3600000)/60000);
    if(days>0){
      html=`<div style="font-size:9px;color:var(--t3);font-weight:700;text-transform:uppercase;letter-spacing:.5px">Avreise om</div>
            <div style="font-size:14px;font-weight:800;color:var(--gold);line-height:1.2">${days}d ${hrs}t</div>`;
    } else {
      html=`<div style="font-size:9px;color:var(--gold);font-weight:800;text-transform:uppercase;letter-spacing:.5px">✈️ I DAG!</div>
            <div style="font-size:13px;font-weight:800;color:var(--gold2)">${hrs}t ${mins}m</div>`;
    }
  } else if(now <= RETURN){
    const day=Math.floor((now-DEPARTURE)/86400000)+1;
    html=`<div style="font-size:9px;color:var(--green);font-weight:800;text-transform:uppercase;letter-spacing:.5px">🍁 På tur!</div>
          <div style="font-size:13px;font-weight:800;color:var(--green)">Dag ${day}/18</div>`;
  } else {
    html=`<div style="font-size:10px;color:var(--t3);font-weight:600">3. aug ✅</div>`;
  }
  if(mob)mob.innerHTML=html;
  if(top)top.innerHTML=html;
}

setInterval(updateCountdown, 15000);

/* ═══════════════════════ PUSH-VARSLER ═══════════════════════ */
function enableNotifications(){
  if(!("Notification" in window))return showToast("Nettleseren støtter ikke varsler");
  Notification.requestPermission().then(p=>{
    if(p==="granted"){
      S.notifEnabled=true;
      try{localStorage.setItem("ca26notif","1");}catch{}
      showToast("🔔 Morgenvarsler aktivert!");
      const banner=document.getElementById("notif-banner");
      if(banner)banner.style.display="none";
    } else {
      showToast("Varsler ble avslått i nettleseren");
    }
  });
}
function disableNotifications(){
  S.notifEnabled=false;
  try{localStorage.setItem("ca26notif","0");}catch{}
  const banner=document.getElementById("notif-banner");
  if(banner)banner.style.display="none";
  showToast("Varsler deaktivert");
}
function checkAndNotify(){
  if(!S.notifEnabled||Notification.permission!=="granted")return;
  const now=new Date();
  const tripDay=getTripDay();
  if(tripDay<0)return;
  const today=now.toISOString().slice(0,10);
  const hour=now.getHours();
  // Kveldsvarsel (N12): kl. 21–22, egen guard, nudger til kveldsrefleksjon.
  if(hour>=21&&hour<23){
    let last="";try{last=localStorage.getItem("ca26reflectnotif")||"";}catch{}
    let done="";try{done=localStorage.getItem("ca26reflectdone")||"";}catch{}
    if(last!==today&&done!==today){
      try{localStorage.setItem("ca26reflectnotif",today);}catch{}
      const d=DAYS[tripDay];
      try{
        new Notification("🌙 Hvordan var dagen?",{body:`Skriv kveldsrefleksjonen for ${d?d.title:"dagen"} — Claude kan lage en kladd.`,icon:"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='80' x='10'>🌙</text></svg>",tag:"ca26-evening"});
      }catch{}
    }
    return;
  }
  if(S.notifLastDate===today)return;
  if(hour<7||hour>9)return;
  S.notifLastDate=today;
  try{localStorage.setItem("ca26notiflast",today);}catch{}
  const day=DAYS[tripDay];
  if(!day)return;
  const firstItem=day.items[0];
  let body=`${day.wd} ${day.d}`;
  if(firstItem)body+=` · ${firstItem.t}: ${firstItem.v}`;
  if(day.hotel)body+=`\n🏨 ${day.hotel}`;
  try{
    new Notification(`${day.em} ${day.title}`,{body,icon:"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='80' x='10'>🍁</text></svg>",tag:"ca26-daily"});
  }catch{}
}
setInterval(checkAndNotify,60000);
setTimeout(checkAndNotify,3000);

function renderNotifBanner(){
  if(S.notifEnabled||!("Notification" in window))return"";
  const now=new Date();
  if(now>RETURN)return"";
  return`<div id="notif-banner" style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 14px;margin-bottom:10px;background:rgba(56,189,248,.08);border:1px solid rgba(56,189,248,.2);border-radius:var(--r2)">
    <div style="font-size:12px;color:var(--t1)">🔔 Vil du ha morgenvarsler med dagens program?</div>
    <div style="display:flex;gap:6px;flex-shrink:0">
      <button onclick="enableNotifications()" style="padding:5px 10px;background:var(--sky);color:#fff;border:none;border-radius:var(--r3);font-size:11px;font-weight:700;cursor:pointer;font-family:var(--font)">Ja</button>
      <button onclick="this.closest('#notif-banner').style.display='none'" style="padding:5px 10px;background:var(--bg3);color:var(--t3);border:none;border-radius:var(--r3);font-size:11px;font-weight:600;cursor:pointer;font-family:var(--font)">Nei</button>
    </div>
  </div>`;
}

/* ═══════════════════════ NØDFRASER ═══════════════════════ */
const FRASER=[
  {cat:"🏥 Medisinsk nød",items:[
    {no:"Jeg trenger en lege",en:"I need a doctor",fr:"J'ai besoin d'un médecin"},
    {no:"Ring ambulanse!",en:"Call an ambulance!",fr:"Appelez une ambulance!"},
    {no:"Sykehus – hvor er det?",en:"Where is the nearest hospital?",fr:"Où est l'hôpital le plus proche?"},
    {no:"Jeg er allergisk mot...",en:"I am allergic to...",fr:"Je suis allergique à..."},
    {no:"Jeg trenger reseptbelagt medisin",en:"I need prescription medication",fr:"J'ai besoin de médicaments sur ordonnance"},
    {no:"Jeg har mistet bevisstheten",en:"They have lost consciousness",fr:"Ils ont perdu connaissance"},
    {no:"Det er en hjertesykdom",en:"There is a heart condition",fr:"Il y a une maladie cardiaque"},
  ]},
  {cat:"🚗 Bilhjelp",items:[
    {no:"Bilen har brutt sammen",en:"The car has broken down",fr:"La voiture est en panne"},
    {no:"Vi har punktert",en:"We have a flat tire",fr:"Nous avons un pneu crevé"},
    {no:"Jeg er låst ute av bilen",en:"I am locked out of the car",fr:"Je suis enfermé hors de la voiture"},
    {no:"Vi trenger redningsbil",en:"We need a tow truck",fr:"Nous avons besoin d'une dépanneuse"},
    {no:"Det var en ulykke",en:"There has been an accident",fr:"Il y a eu un accident"},
    {no:"Kontakt AVIS: +1 604-606-2868",en:"Contact AVIS: +1 604-606-2868",fr:"Contactez AVIS: +1 604-606-2868"},
  ]},
  {cat:"🚢 Cruise",items:[
    {no:"Jeg har mistet kortet mitt om bord",en:"I have lost my onboard card",fr:"J'ai perdu ma carte de bord"},
    {no:"Når går skipet?",en:"When does the ship depart?",fr:"Quand le navire part-il?"},
    {no:"Jeg er sjøsyk",en:"I am seasick",fr:"J'ai le mal de mer"},
    {no:"Lugaren min er feil",en:"My cabin is incorrect",fr:"Ma cabine est incorrecte"},
    {no:"Det er et problem med mat-allergien min",en:"There is a problem with my food allergy",fr:"Il y a un problème avec mon allergie alimentaire"},
  ]},
  {cat:"✈️ Flyplass",items:[
    {no:"Jeg har mistet passet mitt",en:"I have lost my passport",fr:"J'ai perdu mon passeport"},
    {no:"Bagasjen min er forsvunnet",en:"My luggage is missing",fr:"Mon bagage a disparu"},
    {no:"Flyet er forsinket – jeg trenger ombooking",en:"My flight is delayed – I need rebooking",fr:"Mon vol est retardé – j'ai besoin d'un rebook"},
    {no:"Hvor er bagasjeutlevering?",en:"Where is baggage claim?",fr:"Où est la livraison des bagages?"},
  ]},
  {cat:"🏨 Hotell",items:[
    {no:"Rommet er ikke klart",en:"The room is not ready",fr:"La chambre n'est pas prête"},
    {no:"Noe er galt på rommet",en:"Something is wrong in the room",fr:"Il y a un problème dans la chambre"},
    {no:"Kan vi få sen utsjekk?",en:"Can we have a late check-out?",fr:"Pouvons-nous avoir un départ tardif?"},
    {no:"Kan jeg få en ekstra nøkkel?",en:"Can I have an extra key?",fr:"Puis-je avoir une clé supplémentaire?"},
  ]},
  {cat:"🦌 Nasjonalpark / Natur",items:[
    {no:"Hold avstand fra bjørnen!",en:"Keep away from the bear!",fr:"Restez à l'écart de l'ours!"},
    {no:"Vi er fortapt i skogen",en:"We are lost in the forest",fr:"Nous sommes perdus dans la forêt"},
    {no:"Vi trenger fjellredning",en:"We need mountain rescue",fr:"Nous avons besoin d'un secours en montagne"},
    {no:"Det er et skadet dyr på veien",en:"There is an injured animal on the road",fr:"Il y a un animal blessé sur la route"},
    {no:"Parks Canada nødnummer: 1-888-773-8888",en:"Parks Canada emergency: 1-888-773-8888",fr:"Urgences Parcs Canada: 1-888-773-8888"},
  ]},
  {cat:"💳 Praktisk",items:[
    {no:"Kortet mitt virker ikke",en:"My card is not working",fr:"Ma carte ne fonctionne pas"},
    {no:"Kan jeg betale med kredittkort?",en:"Can I pay by credit card?",fr:"Puis-je payer par carte de crédit?"},
    {no:"Jeg trenger kvittering",en:"I need a receipt",fr:"J'ai besoin d'un reçu"},
    {no:"Hva er WiFi-passordet?",en:"What is the WiFi password?",fr:"Quel est le mot de passe WiFi?"},
    {no:"Kan du snakke saktere?",en:"Can you speak more slowly?",fr:"Pouvez-vous parler plus lentement?"},
    {no:"Jeg forstår ikke",en:"I don't understand",fr:"Je ne comprends pas"},
  ]},
];

function renderFraser(){
  const lang=S.fraserLang||"en";
  let html='<div class="page-title">🗣️ Nødfraser</div>';
  html+='<div class="page-sub">Trykk på en frase for å kopiere – fungerer offline</div>';
  html+='<div style="display:flex;gap:7px;margin-bottom:18px">';
  [{id:"en",lb:"🇨🇦 Engelsk"},{id:"fr",lb:"🇫🇷 Fransk"}].forEach(function(l){
    const bg=lang===l.id?"var(--gold)":"var(--bg3)";
    const col=lang===l.id?"#080f1a":"var(--t2)";
    html+='<button onclick="S.fraserLang=\''+l.id+'\';renderPage()" style="flex:1;padding:9px 4px;border-radius:var(--r2);border:none;cursor:pointer;font-size:13px;font-weight:700;font-family:var(--font);transition:all .15s;background:'+bg+';color:'+col+'">'+l.lb+'</button>';
  });
  html+='</div>';
  FRASER.forEach(function(group){
    html+='<div style="margin-bottom:18px">';
    html+='<div class="sec-lbl">'+esc(group.cat)+'</div>';
    group.items.forEach(function(f){
      const phrase=esc(f[lang]||"");
      const phraseRaw=(f[lang]||"").replace(/'/g,"\\'");
      html+='<div onclick="copyFrase(\''+phraseRaw+'\')" style="background:var(--bg2);border:1px solid var(--border2);border-radius:var(--r2);padding:11px 13px;margin-bottom:6px;cursor:pointer;transition:all .15s">';
      html+='<div style="font-size:11px;color:var(--t3);margin-bottom:3px">'+esc(f.no)+'</div>';
      html+='<div style="font-size:14px;font-weight:600;color:var(--text)">'+phrase+'</div>';
      html+='</div>';
    });
    html+='</div>';
  });
  html+='<div id="fraser-toast" style="display:none;position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:var(--green);color:#080f1a;padding:9px 18px;border-radius:20px;font-size:13px;font-weight:700;z-index:300;pointer-events:none">✓ Kopiert!</div>';
  return html;
}

function copyFrase(txt){
  if(navigator.clipboard){navigator.clipboard.writeText(txt).catch(()=>{});}
  const t=document.getElementById("fraser-toast");
  if(t){t.style.display="block";clearTimeout(window._ft);window._ft=setTimeout(()=>t.style.display="none",1800);}
}

/* ═══════════════════════ GALLERI ═══════════════════════ */
function renderGalleri(){
  const allPhotos=[];
  S.diary.forEach(e=>{
    (e.photos||[]).forEach(url=>{
      allPhotos.push({url,author:e.author||"Ukjent",title:e.title||"",dayIdx:e.dayIdx,ts:e.ts});
    });
  });
  allPhotos.sort((a,b)=>(b.ts||0)-(a.ts||0));
  return`
  <div class="page-title">📸 Bildegalleri</div>
  <div class="page-sub">${allPhotos.length} bilder fra reisedagboken</div>
  ${allPhotos.length===0?`
  <div style="text-align:center;padding:50px 20px">
    <div style="font-size:52px;margin-bottom:14px">📷</div>
    <div style="font-size:15px;color:var(--t2);line-height:1.7;max-width:300px;margin:0 auto">Bilder dukker opp her etter hvert som de legges til i dagboken.</div>
    <button class="btn btn-gold" style="margin-top:20px" onclick="setTab('dagbok')">📖 Gå til dagboken</button>
  </div>`:`
  <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:6px">
    ${allPhotos.map((p,i)=>`<div style="position:relative;cursor:pointer" onclick="openLightbox('${p.url}')">
      <img src="${p.url}" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:var(--r3);display:block" loading="lazy">
      <div style="position:absolute;bottom:0;left:0;right:0;padding:4px 6px;background:linear-gradient(transparent,rgba(0,0,0,.6));border-radius:0 0 var(--r3) var(--r3)">
        <div style="font-size:10px;color:#fff;font-weight:600">${esc(p.author)}</div>
      </div>
    </div>`).join("")}
  </div>`}`;
}

/* ═══════════════════════ VÆRPROGNOSE ═══════════════════════ */
const WEATHER_ICONS={0:"☀️",1:"🌤️",2:"⛅",3:"☁️",45:"🌫️",48:"🌫️",51:"🌦️",53:"🌧️",55:"🌧️",61:"🌧️",63:"🌧️",65:"🌧️",71:"🌨️",73:"🌨️",75:"🌨️",80:"🌦️",81:"🌧️",82:"🌧️",95:"⛈️",96:"⛈️",99:"⛈️"};
const WEATHER_LOCS=[
  {name:"Vancouver",lat:49.28,lng:-123.12},
  {name:"Inside Passage",lat:57.05,lng:-135.33},
  {name:"Juneau",lat:58.30,lng:-134.42},
  {name:"Kamloops",lat:50.67,lng:-120.33},
  {name:"Jasper",lat:52.87,lng:-118.08},
  {name:"Banff",lat:51.18,lng:-115.57},
  {name:"Calgary",lat:51.05,lng:-114.07}
];
let weatherCache={};
async function loadWeather(loc){
  const key=loc.name;
  if(weatherCache[key]&&Date.now()-weatherCache[key].ts<3600000)return weatherCache[key].data;
  try{
    const r=await fetch(`/api/weather?lat=${loc.lat}&lng=${loc.lng}`);
    const data=await r.json();
    weatherCache[key]={data,ts:Date.now()};
    return data;
  }catch{return null;}
}
function renderWeatherWidget(){
  const locIdx=S.weatherLoc||0;
  const loc=WEATHER_LOCS[locIdx];
  return`
  <div style="margin-bottom:16px">
    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
      <div style="font-size:14px;font-weight:700;color:var(--text)">🌤️ Værprognose</div>
      <select onchange="S.weatherLoc=+this.value;loadAndShowWeather()" style="background:var(--bg3);border:1px solid var(--border);border-radius:var(--r3);padding:4px 8px;font-size:12px;color:var(--text);font-family:var(--font)">
        ${WEATHER_LOCS.map((l,i)=>`<option value="${i}" ${i===locIdx?"selected":""}>${l.name}</option>`).join("")}
      </select>
    </div>
    <div id="weather-grid" style="display:grid;grid-template-columns:repeat(7,1fr);gap:4px;text-align:center">
      <div style="grid-column:1/-1;font-size:12px;color:var(--t3)">Laster...</div>
    </div>
  </div>`;
}
async function loadAndShowWeather(){
  const loc=WEATHER_LOCS[S.weatherLoc||0];
  const data=await loadWeather(loc);
  const el=document.getElementById("weather-grid");
  if(!el||!data?.daily)return;
  const d=data.daily;
  el.innerHTML=d.time.map((t,i)=>{
    const day=new Date(t).toLocaleDateString("no",{weekday:"short"});
    const ic=WEATHER_ICONS[d.weathercode[i]]||"🌡️";
    return`<div style="background:var(--bg3);border-radius:var(--r3);padding:6px 2px">
      <div style="font-size:10px;color:var(--t3);font-weight:600">${day}</div>
      <div style="font-size:20px;margin:3px 0">${ic}</div>
      <div style="font-size:12px;font-weight:700;color:var(--text)">${Math.round(d.temperature_2m_max[i])}°</div>
      <div style="font-size:10px;color:var(--t3)">${Math.round(d.temperature_2m_min[i])}°</div>
      ${d.precipitation_sum[i]>0?`<div style="font-size:9px;color:var(--sky)">${d.precipitation_sum[i].toFixed(1)}mm</div>`:""}
    </div>`;
  }).join("");
}

/* ═══════════════════════ DELE-FUNKSJON ═══════════════════════ */
// #9 — Familiedeling. To målgrupper:
//  • «Bli med i appen»  → hele opplevelsen (kan installeres som PWA)
//  • «Følg oss»          → /folg, ingen installasjon, send hjerter hjemmefra
// Ekte, skannbar QR genereres med qr.js (offline-dyktig canvas-encoder).
let _shareTarget = 'app';
function shareUrlFor(target){
  return target === 'follow'
    ? 'https://usa26.kolakowski.no/folg'
    : 'https://usa26.kolakowski.no';
}
function shareTextFor(target){
  return target === 'follow'
    ? 'Følg Robert, Margita & Nicholas på Canada- og Alaska-turen — siste bilde, hvor de er nå, og send dem et hjerte:'
    : 'Bli med i reiseappen vår for Canada & Alaska 2026 — dagsplan, kart, dagbok og live posisjon:';
}
function showShareModal(){
  const modal=document.createElement("div");
  modal.id="share-modal";
  modal.style.cssText="position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px";
  modal.onclick=e=>{if(e.target===modal)modal.remove();};
  modal.innerHTML=`<div style="background:var(--card);border-radius:var(--r);padding:24px;max-width:360px;width:100%;text-align:center;border:1px solid var(--border)">
    <div style="font-size:22px;margin-bottom:6px">🍁</div>
    <div style="font-size:16px;font-weight:700;color:var(--text);margin-bottom:12px">Del med familien</div>
    <div style="display:flex;gap:6px;background:var(--bg3);border-radius:999px;padding:4px;margin-bottom:14px">
      <button id="sh-tab-app" onclick="setShareTarget('app')" class="sh-seg">📱 Bli med i appen</button>
      <button id="sh-tab-follow" onclick="setShareTarget('follow')" class="sh-seg">💛 Følg oss</button>
    </div>
    <div id="sh-desc" style="font-size:12px;color:var(--t2);line-height:1.5;margin-bottom:12px"></div>
    <div id="sh-qr-wrap" style="display:flex;justify-content:center;margin-bottom:12px"></div>
    <div id="sh-url" style="background:var(--bg3);border-radius:var(--r2);padding:10px;font-size:12.5px;color:var(--text);font-family:monospace;margin-bottom:12px;word-break:break-all"></div>
    <div style="display:flex;gap:8px;margin-bottom:8px">
      ${navigator.share?`<button id="sh-native" onclick="nativeShare()" style="flex:1;padding:12px;border-radius:var(--r2);border:none;background:var(--gold);color:#1a1208;font-size:14px;font-weight:700;cursor:pointer;font-family:var(--font)">↗ Del…</button>`:''}
      <button id="sh-copy" onclick="copyShareUrl(this)" style="flex:1;padding:12px;border-radius:var(--r2);border:1px solid var(--border);background:var(--bg3);color:var(--text);font-size:14px;font-weight:600;cursor:pointer;font-family:var(--font)">📋 Kopier</button>
    </div>
    <div style="font-size:10px;color:var(--t3);margin-top:2px">Skann QR-koden med mobilkameraet</div>
    <button onclick="this.closest('#share-modal').remove()" style="margin-top:12px;background:none;border:none;color:var(--t3);font-size:13px;cursor:pointer;font-family:var(--font)">Lukk</button>
  </div>`;
  document.body.appendChild(modal);
  _shareTarget='app';
  renderShareTarget();
}
function setShareTarget(t){ _shareTarget=t; renderShareTarget(); haptic('light'); }
function renderShareTarget(){
  const url=shareUrlFor(_shareTarget);
  const desc=document.getElementById('sh-desc');
  const urlEl=document.getElementById('sh-url');
  const qrWrap=document.getElementById('sh-qr-wrap');
  if(desc) desc.textContent=shareTextFor(_shareTarget);
  if(urlEl) urlEl.textContent=url;
  document.getElementById('sh-tab-app')?.classList.toggle('on',_shareTarget==='app');
  document.getElementById('sh-tab-follow')?.classList.toggle('on',_shareTarget==='follow');
  if(qrWrap){ qrWrap.innerHTML=''; const cv=makeQR(url,180); if(cv){cv.style.borderRadius='8px';qrWrap.appendChild(cv);} }
}
function copyShareUrl(btn){
  navigator.clipboard?.writeText(shareUrlFor(_shareTarget));
  const prev=btn.textContent; btn.textContent='✅ Kopiert!';
  setTimeout(()=>btn.textContent=prev,2000);
}
async function nativeShare(){
  try{ await navigator.share({title:'Canada & Alaska 2026',text:shareTextFor(_shareTarget),url:shareUrlFor(_shareTarget)}); }catch{}
}

/* ═══════════════════════ PDF REISEPLAN-EKSPORT ═══════════════════════ */
function exportPlanPDF(){
  const w=window.open("","_blank");
  const days=typeof DAYS!=="undefined"?DAYS:[];
  let html=`<html><head><meta charset="UTF-8"><title>Reiseplan Canada & Alaska 2026</title>
  <style>body{font-family:Georgia,serif;max-width:800px;margin:0 auto;padding:24px;color:#1a1208;font-size:13px;line-height:1.7}
  h1{font-size:24px;color:#8a6d2e;border-bottom:2px solid #c9913a;padding-bottom:8px}
  h2{font-size:16px;color:#5a4828;margin-top:20px;border-left:3px solid #c9913a;padding-left:10px}
  .item{padding:4px 0;border-bottom:1px solid #eee}.time{font-weight:700;color:#8a6d2e;min-width:60px;display:inline-block}
  .hotel{background:#faf5eb;border:1px solid #e8d9b8;border-radius:6px;padding:8px 12px;margin-top:8px;font-size:12px}
  .print-btn{background:#c9913a;color:#fff;border:none;padding:12px 24px;font-size:14px;border-radius:8px;cursor:pointer;font-weight:600}
  @media print{.print-btn{display:none}}</style></head><body>
  <h1>🍁 Canada & Alaska 2026</h1>
  <p>Robert, Margita & Nicholas · 17. juli – 3. august · 18 dager</p>
  <button class="print-btn" onclick="window.print()">🖨️ Lagre som PDF</button><hr>`;
  days.forEach((d,i)=>{
    html+=`<h2>${d.em} Dag ${i+1}: ${d.title}</h2><p style="color:#888;font-size:12px">${d.wd} ${d.d}</p>`;
    (d.items||[]).forEach(it=>{
      html+=`<div class="item"><span class="time">${it.t}</span> <strong>${it.v}</strong> ${it.s?`<span style="color:#666"> — ${it.s}</span>`:""}</div>`;
    });
    if(d.hotel)html+=`<div class="hotel">🏨 ${d.hotel}</div>`;
  });
  html+=`<hr><p style="color:#888;font-size:11px;text-align:center">Generert fra usa26.kolakowski.no · ${new Date().toLocaleDateString("no")}</p></body></html>`;
  w.document.write(html);w.document.close();
}

// Utskriftsvennlig pakkeliste — alle kategorier og punkter med avkrysningsbokser,
// uten vær-oversikten. Åpner nytt vindu → «Lagre som PDF» / skriv ut på papir.
function exportPackPDF(){
  const w=window.open("","_blank");
  const groups=typeof PACKING!=="undefined"?PACKING:[];
  const total=groups.reduce((s,g)=>s+g.items.length,0);
  let html=`<html><head><meta charset="UTF-8"><title>Pakkeliste Canada & Alaska 2026</title>
  <style>body{font-family:Georgia,serif;max-width:800px;margin:0 auto;padding:24px;color:#1a1208;font-size:13px;line-height:1.6}
  h1{font-size:24px;color:#8a6d2e;border-bottom:2px solid #c9913a;padding-bottom:8px;margin-bottom:4px}
  .sub{color:#888;font-size:12px;margin:0 0 4px}
  h2{font-size:15px;color:#5a4828;margin:22px 0 8px;border-left:3px solid #c9913a;padding-left:10px;break-after:avoid}
  .grp{break-inside:avoid;margin-bottom:6px}
  ul{list-style:none;margin:0;padding:0;columns:2;column-gap:28px}
  li{padding:3px 0;break-inside:avoid;display:flex;align-items:flex-start;gap:8px}
  .box{flex-shrink:0;width:13px;height:13px;border:1.5px solid #8a6d2e;border-radius:3px;margin-top:2px}
  .print-btn{background:#c9913a;color:#fff;border:none;padding:12px 24px;font-size:14px;border-radius:8px;cursor:pointer;font-weight:600;margin:8px 0 4px}
  @media print{.print-btn{display:none}ul{columns:2}}
  @media(max-width:640px){ul{columns:1}}</style></head><body>
  <h1>🧳 Pakkeliste — Canada & Alaska 2026</h1>
  <p class="sub">Robert, Margita &amp; Nicholas · 17. juli – 3. august · ${total} ting å pakke</p>
  <button class="print-btn" onclick="window.print()">🖨️ Lagre som PDF / skriv ut</button><hr>`;
  groups.forEach(g=>{
    html+=`<div class="grp"><h2>${esc(g.cat)}</h2><ul>`;
    g.items.forEach(it=>{
      html+=`<li><span class="box"></span><span>${esc(it.t)}</span></li>`;
    });
    html+=`</ul></div>`;
  });
  html+=`<hr><p style="color:#888;font-size:11px;text-align:center">Generert fra usa26.kolakowski.no · ${new Date().toLocaleDateString("no")}</p></body></html>`;
  w.document.write(html);w.document.close();
}

/* ═══════════════════════ REISEKART ═══════════════════════ */
const MAP_STOPS = [
  // Fly
  {id:"osl",   name:"Oslo Gardermoen",       lat:60.193,  lng:11.100,  type:"fly",   c:"#60a5fa", em:"✈️",  d:"17. jul – avreise"},
  // Vancouver
  {id:"yvr",   name:"Vancouver",             lat:49.246,  lng:-123.116,type:"city",  c:"#34d399", em:"🌊",  d:"17–19. juli"},
  // Cruise stops
  {id:"cr_emb",name:"Embarkering Vancouver", lat:49.289,  lng:-123.112,type:"cruise",c:"#22d3ee", em:"🚢",  d:"19. jul kl 16:00"},
  {id:"icy",   name:"Icy Strait Point",      lat:58.129,  lng:-135.458,type:"alaska",c:"#4ade80", em:"🐋",  d:"21. juli"},
  {id:"skw",   name:"Skagway",               lat:59.458,  lng:-135.314,type:"alaska",c:"#a78bfa", em:"🚂",  d:"22. juli"},
  {id:"jun",   name:"Juneau",                lat:58.301,  lng:-134.419,type:"alaska",c:"#22d3ee", em:"🧊",  d:"23. juli"},
  {id:"ktn",   name:"Ketchikan",             lat:55.341,  lng:-131.647,type:"alaska",c:"#fbbf24", em:"🐟",  d:"24. juli"},
  {id:"cr_deb",name:"Debarkering Vancouver", lat:49.289,  lng:-123.112,type:"cruise",c:"#22d3ee", em:"🛳️", d:"26. jul kl 06:00"},
  // Road trip
  {id:"kam",   name:"Kamloops",              lat:50.674,  lng:-120.327,type:"car",   c:"#f87171", em:"🍷",  d:"26–27. juli"},
  {id:"jas",   name:"Jasper",                lat:52.873,  lng:-118.082,type:"mountain",c:"#4ade80",em:"🦌", d:"27–29. juli"},
  {id:"ban",   name:"Banff",                 lat:51.178,  lng:-115.570,type:"mountain",c:"#38bdf8",em:"🏔️",d:"29–31. juli"},
  {id:"yyc",   name:"Calgary",               lat:51.045,  lng:-114.057,type:"city",  c:"#fbbf24", em:"🌆",  d:"31. jul – 2. aug"},
  // Home
  {id:"yyc_dep",name:"Calgary – hjemreise", lat:51.131,  lng:-113.995,type:"fly",   c:"#60a5fa", em:"✈️",  d:"2. aug kl 12:40"},
];

// Separate route segments with different styles
const MAP_ROUTES = [
  // Fly OSL→YVR (approximate great circle)
  {pts:[[60.193,11.100],[58.0,20.0],[55.0,30.0],[50.0,10.0],[48.0,-10.0],[52.0,-30.0],[55.0,-60.0],[53.0,-90.0],[50.0,-110.0],[49.246,-123.116]],
   style:{color:"#60a5fa",weight:2,dashArray:"6 4",opacity:.7}},
  // Cruise route (coastal Alaska)
  {pts:[[49.289,-123.112],[52.0,-128.0],[54.0,-130.0],[56.0,-132.0],[58.129,-135.458],[59.458,-135.314],[58.301,-134.419],[55.341,-131.647],[49.289,-123.112]],
   style:{color:"#22d3ee",weight:2.5,dashArray:"8 4",opacity:.85}},
  // Road trip
  {pts:[[49.289,-123.112],[50.674,-120.327],[52.873,-118.082],[51.178,-115.570],[51.045,-114.057]],
   style:{color:"#fbbf24",weight:3,opacity:.9}},
  // Fly home YYC→OSL (approximate)
  {pts:[[51.131,-113.995],[50.0,-100.0],[52.0,-80.0],[56.0,-60.0],[60.0,-30.0],[62.0,0.0],[60.193,11.100]],
   style:{color:"#60a5fa",weight:2,dashArray:"6 4",opacity:.7}},
];

let leafletMap=null;
let mapLayers={routes:[],markers:[]};
let mapTileLayer=null;
let mapGpsMarker=null;
const MAP_FILTERS=[
  {id:"all",label:"Alle",types:null},
  {id:"fly",label:"✈️ Fly",types:["fly"]},
  {id:"cruise",label:"🚢 Cruise",types:["cruise","alaska"]},
  {id:"car",label:"🚗 Biltur",types:["car","mountain","city"]},
];
const MAP_TILES={
  dark:{url:"https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",sub:"abcd",label:"🌙 Mørkt"},
  light:{url:"https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",sub:"abcd",label:"☀️ Lyst"},
  terrain:{url:"https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",sub:"abc",label:"⛰️ Terreng"},
  satellite:{url:"https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",sub:null,label:"🛰️ Satellitt"},
};
if(!S.mapFilter)S.mapFilter="all";
if(!S.mapTile)S.mapTile=document.body.classList.contains("light")?"light":"dark";

// Distance helper (haversine km)
function haversine(a,b){
  const R=6371,dLat=(b[0]-a[0])*Math.PI/180,dLng=(b[1]-a[1])*Math.PI/180;
  const x=Math.sin(dLat/2)**2+Math.cos(a[0]*Math.PI/180)*Math.cos(b[0]*Math.PI/180)*Math.sin(dLng/2)**2;
  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}

// Find which day of the trip we're on (or -1 if not on trip)
function getTripDay(){
  const dep=new Date("2026-07-17T13:50:00+02:00"),ret=new Date("2026-08-03T15:25:00+02:00"),now=new Date();
  if(now<dep||now>ret)return -1;
  return Math.floor((now-dep)/86400000);
}

// Map stop → hotel & activities lookup
function getStopDetails(s){
  const hotel=HOTEL_INFO.find(h=>{
    const n=s.name.toLowerCase();
    return h.n.toLowerCase().includes(n)||h.d.includes(s.d.split("–")[0]?.trim().slice(0,6));
  });
  // Find matching day guide
  const dayIdx=DAYS?.findIndex(d=>d.title?.toLowerCase().includes(s.name.toLowerCase().split(" ")[0]));
  const guide=dayIdx>=0&&DAY_GUIDE?DAY_GUIDE[dayIdx]:null;
  return{hotel,guide,dayIdx};
}

function renderKart(){
  const tripDay=getTripDay();
  const mainStops=MAP_STOPS.filter(s=>!s.id.startsWith("cr_")&&s.id!=="yyc_dep"&&s.id!=="osl");
  // Distances for road trip segment
  const roadStops=MAP_STOPS.filter(s=>["yvr","kam","jas","ban","yyc"].includes(s.id));

  if(!S.mapStyle) S.mapStyle = document.body.classList.contains("feltjournal") ? "editorial" : "detaljert";
  const isEditorial = S.mapStyle === "editorial";

  return`<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;gap:8px;flex-wrap:wrap">
    <div class="page-title" style="margin-bottom:0">🗺️ Reisekart</div>
    <div class="page-sub" style="margin:0">18 dager · Vancouver → Alaska → Rocky Mountains → Calgary</div>
  </div>
  ${tripDay>=0?`<div style="background:rgba(52,211,153,.1);border:1px solid rgba(52,211,153,.3);border-radius:var(--r2);padding:8px 12px;margin-bottom:10px;font-size:13px;color:var(--green);font-weight:600">🟢 Dag ${tripDay+1} av 18 — dere er på tur!</div>`:""}

  <!-- Kart med flytende verktøyrad (synlig også i fullskjerm) -->
  <div class="map-wrap" style="height:calc(60vh);min-height:340px;max-height:560px;position:relative">
    <div id="leaflet-map" style="height:100%;width:100%;background:var(--bg3)"></div>
    <div id="fj-map" style="display:none;height:100%;width:100%;background:var(--fj-paper)"></div>

    <!-- Verktøyrad øverst: filter + handlinger -->
    <div class="map-toolbar">
      <div class="map-toolbar-filters">
        ${MAP_FILTERS.map(f=>`<button class="map-tb-btn map-filter-btn${S.mapFilter===f.id?" active":""}" onclick="setMapFilter('${f.id}')">${f.label}</button>`).join("")}
      </div>
      <div class="map-toolbar-actions">
        <button class="map-tb-btn" onclick="toggleMapStyle()" id="map-style-btn" aria-label="Bytt karttype" title="${isEditorial?"Editorial papir-stil":"Detaljert kart"}">${isEditorial?"📓 Editorial":"🗺 Detaljert"}</button>
        <button class="map-tb-btn" onclick="toggleGps()" id="gps-btn" aria-label="Min posisjon">📍</button>
        <button class="map-tb-btn" onclick="toggleMapFullscreen()" id="map-fs-btn" aria-label="Fullskjerm">⛶</button>
      </div>
    </div>

    <!-- Leaflet tile-velger nederst-høyre (kun synlig i detaljert-modus) -->
    <div class="map-tile-picker" id="map-tile-picker">
      ${Object.keys(MAP_TILES).map(k=>`<button data-tile-btn="${k}" onclick="setMapTile('${k}')" class="map-tile-btn${S.mapTile===k?" active":""}">${MAP_TILES[k].label}</button>`).join("")}
    </div>
  </div>

  <!-- Avstander biltur -->
  <div style="display:flex;gap:4px;margin-top:10px;overflow-x:auto;padding-bottom:4px;scrollbar-width:none">
    ${roadStops.map((s,i)=>{
      if(i===0)return`<div style="font-size:11px;font-weight:700;color:var(--text);white-space:nowrap;padding:4px 8px;background:var(--bg2);border-radius:var(--r3)">${s.em} ${s.name.split(" ")[0]}</div>`;
      const prev=roadStops[i-1];
      const km=Math.round(haversine([prev.lat,prev.lng],[s.lat,s.lng]));
      return`<div style="display:flex;align-items:center;gap:4px;white-space:nowrap">
        <div style="font-size:10px;color:var(--t3);padding:0 4px">→ ${km} km</div>
        <div style="font-size:11px;font-weight:700;color:var(--text);padding:4px 8px;background:var(--bg2);border-radius:var(--r3)">${s.em} ${s.name.split(" ")[0]}</div>
      </div>`;
    }).join("")}
  </div>

  <!-- Offline kartlasting -->
  <div style="margin-top:10px;display:flex;gap:8px;align-items:center;flex-wrap:wrap">
    <button onclick="cacheTilesForRoute()" id="cache-tiles-btn" style="display:inline-flex;align-items:center;gap:5px;padding:8px 14px;background:var(--bg3);border:1px solid var(--border);border-radius:var(--r3);color:var(--t1);font-size:12px;font-weight:600;cursor:pointer;font-family:var(--font)">💾 Last ned kart offline</button>
    <span id="cache-tiles-status" style="font-size:11px;color:var(--t3)"></span>
  </div>

  <!-- Stoppeliste -->
  <div class="map-legend">
    ${mainStops.map(s=>{
      const isActive=tripDay>=0&&s.d.includes(DAYS[tripDay]?.d?.split(". ")[0]);
      return`<div class="legend-item${isActive?" active-stop":""}" onclick="flyToStop('${s.id}')">
        <div class="leg-dot" style="background:${s.c}"></div>
        <div style="min-width:0">
          <div style="font-size:12.5px;font-weight:700;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${s.em} ${esc(s.name)}${isActive?" 📍":""}</div>
          <div style="font-size:10.5px;color:var(--t3)">${esc(s.d)}</div>
        </div>
      </div>`;
    }).join("")}
  </div>`;
}

// #10 — lazy-loader for kartbiblioteker. Injiserer CSS+JS én gang og
// resolver når globalene (L, maplibregl) er klare. SELVHOSTET i /vendor/
// (ikke unpkg) — tredjeparts-CDN blokkeres av Edge «Tracking prevention».
// Ingen SRI/crossorigin trengs same-origin.
let _mapLibsPromise=null;
function ensureMapLibs(){
  if(_mapLibsPromise) return _mapLibsPromise;
  if(typeof L!=="undefined" && typeof maplibregl!=="undefined"){
    return (_mapLibsPromise=Promise.resolve());
  }
  const loadCss=(href,integrity)=>{ if(document.querySelector(`link[href="${href}"]`))return;
    const l=document.createElement("link");l.rel="stylesheet";l.href=href;
    if(integrity){l.integrity=integrity;l.crossOrigin="anonymous";}document.head.appendChild(l); };
  const loadJs=(src,integrity)=>new Promise((res,rej)=>{
    const ex=document.querySelector(`script[src="${src}"]`);
    if(ex){ ex.addEventListener("load",()=>res()); if(ex.dataset.loaded)res(); return; }
    const s=document.createElement("script");s.src=src;s.async=true;
    if(integrity){s.integrity=integrity;s.crossOrigin="anonymous";}
    s.onload=()=>{s.dataset.loaded="1";res();};s.onerror=()=>rej(new Error("load "+src));
    document.head.appendChild(s);
  });
  loadCss("/vendor/leaflet.css");
  loadCss("/vendor/maplibre-gl.css");
  _mapLibsPromise=Promise.all([
    loadJs("/vendor/leaflet.js"),
    loadJs("/vendor/maplibre-gl.js"),
  ]).catch(e=>{console.warn("Kartbibliotek-lasting feilet",e);});
  return _mapLibsPromise;
}

function bindKart(){
  // #10 — last karbibliotekene (MapLibre ~800 kB + Leaflet) først NÅR kartet
  // faktisk åpnes, ikke på hver førstelast. Sparer ~1 MB JS for alle som ikke
  // er innom kartfanen.
  const mapWrap=document.getElementById("leaflet-map");
  if(mapWrap){ mapWrap.style.position="relative"; if(!document.getElementById("map-loading")){
    mapWrap.insertAdjacentHTML("afterbegin",`<div id="map-loading" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:var(--t3);font-size:13px;z-index:5">🗺️ Laster kart…</div>`);
  }}
  ensureMapLibs().then(()=>{
    document.getElementById("map-loading")?.remove();
  requestAnimationFrame(()=>{
    if(!S.mapStyle) S.mapStyle = document.body.classList.contains("feltjournal") ? "editorial" : "detaljert";
    const useEditorial = S.mapStyle === "editorial";
    const leafEl=document.getElementById("leaflet-map");
    const fjEl=document.getElementById("fj-map");
    if(!leafEl||!fjEl)return;

    if(useEditorial){
      // Skjul Leaflet, vis MapLibre
      leafEl.style.display="none";
      fjEl.style.display="block";
      if(leafletMap){leafletMap.remove();leafletMap=null;}
      const tripDay=getTripDay();
      renderFeltjournalMap("fj-map", MAP_STOPS, tripDay);
      // Skjul Leaflet tile-velgeren — den er bare relevant for detaljert-modus
      const picker = document.getElementById("map-tile-picker");
      if(picker) picker.style.display = "none";
      return;
    }

    // Klassisk Leaflet for detaljert-modus
    leafEl.style.display="block";
    fjEl.style.display="none";
    const picker = document.getElementById("map-tile-picker");
    if(picker) picker.style.display = "";
    destroyFeltjournalMap();
    if(leafletMap){leafletMap.remove();leafletMap=null;}
    mapLayers={routes:[],markers:[]};

    leafletMap=L.map("leaflet-map",{zoomControl:true,attributionControl:false}).setView([54,-115],4);

    const tileKey=S.mapTile||(document.body.classList.contains("light")?"light":"dark");
    const t=MAP_TILES[tileKey];
    const opts={maxZoom:18};
    if(t.sub)opts.subdomains=t.sub;
    mapTileLayer=L.tileLayer(t.url,opts).addTo(leafletMap);
    if(tileKey==="dark")leafEl.classList.add("map-dark-boost");

    drawRoutesAndMarkers();
  });
  });
}

function drawRoutesAndMarkers(){
  if(!leafletMap)return;
  // Clear existing
  mapLayers.routes.forEach(l=>leafletMap.removeLayer(l));
  mapLayers.markers.forEach(l=>leafletMap.removeLayer(l));
  mapLayers={routes:[],markers:[]};

  const filter=S.mapFilter||"all";
  const filterDef=MAP_FILTERS.find(f=>f.id===filter);
  const types=filterDef?.types;

  // Routes
  const routeTypeMap=[["fly"],["cruise","alaska"],["car","mountain","city"],["fly"]];
  MAP_ROUTES.forEach((r,i)=>{
    const rTypes=routeTypeMap[i]||[];
    if(types&&!rTypes.some(t=>types.includes(t)))return;
    const line=L.polyline(r.pts,r.style).addTo(leafletMap);
    mapLayers.routes.push(line);
  });

  // Markers
  const isDark=!document.body.classList.contains("light");
  const borderCol=isDark?"#080f1a":"#fff";
  MAP_STOPS.forEach(s=>{
    if(types&&!types.includes(s.type))return;
    const iconHtml=`<div style="width:30px;height:30px;background:${s.c};border:2px solid ${borderCol};border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;box-shadow:0 2px 10px rgba(0,0,0,.4)">${s.em}</div>`;
    const icon=L.divIcon({html:iconHtml,iconSize:[30,30],iconAnchor:[15,15],className:""});

    // Rich popup
    const det=getStopDetails(s);
    let popup=`<div style="font-family:-apple-system,sans-serif;min-width:180px;max-width:240px">
      <div style="font-size:15px;font-weight:700;margin-bottom:4px">${s.em} ${s.name}</div>
      <div style="font-size:12px;color:#666;margin-bottom:6px">📅 ${s.d}</div>`;
    if(det.hotel)popup+=`<div style="font-size:11px;margin-bottom:4px"><b>🏨 ${det.hotel.n}</b><br>${det.hotel.r}</div>`;
    if(det.guide?.acts)popup+=`<div style="font-size:11px;color:#444;margin-bottom:2px">✨ ${det.guide.acts.length} aktiviteter · ${det.guide.eat?.length||0} restauranter</div>`;
    // Distance to next road stop
    const roadIds=["yvr","kam","jas","ban","yyc"];
    const ri=roadIds.indexOf(s.id);
    if(ri>=0&&ri<roadIds.length-1){
      const next=MAP_STOPS.find(x=>x.id===roadIds[ri+1]);
      if(next){
        const km=Math.round(haversine([s.lat,s.lng],[next.lat,next.lng]));
        popup+=`<div style="font-size:11px;color:#888;margin-top:4px">🚗 ${km} km til ${next.name}</div>`;
      }
    }
    popup+=`</div>`;

    const marker=L.marker([s.lat,s.lng],{icon}).addTo(leafletMap).bindPopup(popup,{maxWidth:250});
    mapLayers.markers.push(marker);
  });

  // Fit bounds to visible markers
  if(mapLayers.markers.length>1){
    const group=L.featureGroup(mapLayers.markers);
    leafletMap.fitBounds(group.getBounds().pad(0.1));
  }
}

function setMapFilter(id){
  S.mapFilter=id;
  document.querySelectorAll(".map-filter-btn").forEach(btn=>{
    btn.classList.toggle("active",btn.textContent.includes(MAP_FILTERS.find(f=>f.id===id)?.label));
  });
  if(document.body.classList.contains("feltjournal")){
    setMapFilterFj(id);
  } else {
    drawRoutesAndMarkers();
  }
}

function setMapTile(key){
  S.mapTile=key;
  if(leafletMap){
    if(mapTileLayer)leafletMap.removeLayer(mapTileLayer);
    const t=MAP_TILES[key];
    const opts={maxZoom:18};
    if(t.sub)opts.subdomains=t.sub;
    mapTileLayer=L.tileLayer(t.url,opts).addTo(leafletMap);
    // Dark boost only for dark tiles
    const mapEl=document.getElementById("leaflet-map");
    if(mapEl){mapEl.classList.toggle("map-dark-boost",key==="dark");}
    // Update button states
    document.querySelectorAll("[data-tile-btn]").forEach(btn=>{
      const k=btn.getAttribute("data-tile-btn");
      btn.style.background=k===key?"var(--gold)":"var(--card)";
      btn.style.color=k===key?"#080f1a":"var(--text)";
      btn.style.borderColor=k===key?"var(--gold)":"var(--border)";
    });
  }
}

function flyToStop(id){
  const s=MAP_STOPS.find(x=>x.id===id);
  if(s&&leafletMap){
    leafletMap.flyTo([s.lat,s.lng],8,{duration:1.2});
    // Open popup
    mapLayers.markers.forEach(m=>{
      if(Math.abs(m.getLatLng().lat-s.lat)<0.01)m.openPopup();
    });
  }
}

// GPS position
let gpsWatchId=null;
function toggleGps(){
  // F05 — feltjournal-kartet håndterer GPS selv
  if(document.body.classList.contains("feltjournal")){
    const active=toggleGpsOnMap();
    const btn=document.getElementById("gps-btn");
    if(btn) btn.textContent=active?"📍 Aktiv":"📍 Min posisjon";
    return;
  }
  if(gpsWatchId!==null){
    navigator.geolocation.clearWatch(gpsWatchId);
    gpsWatchId=null;
    if(mapGpsMarker&&leafletMap){leafletMap.removeLayer(mapGpsMarker);mapGpsMarker=null;}
    const btn=document.getElementById("gps-btn");
    if(btn){btn.textContent="📍 Min posisjon";btn.style.background="var(--bg3)";}
    return;
  }
  if(!navigator.geolocation)return;
  const btn=document.getElementById("gps-btn");
  if(btn){btn.textContent="📍 Aktiv";btn.style.background="rgba(52,211,153,.15)";}
  gpsWatchId=navigator.geolocation.watchPosition(pos=>{
    const {latitude:lat,longitude:lng}=pos.coords;
    if(!leafletMap)return;
    if(!mapGpsMarker){
      const gpsIcon=L.divIcon({
        html:'<div style="width:16px;height:16px;background:#1a73e8;border:3px solid #fff;border-radius:50%;box-shadow:0 0 12px rgba(26,115,232,.6)"></div>',
        iconSize:[16,16],iconAnchor:[8,8],className:""
      });
      mapGpsMarker=L.marker([lat,lng],{icon:gpsIcon,zIndexOffset:1000}).addTo(leafletMap);
    } else {
      mapGpsMarker.setLatLng([lat,lng]);
    }
  },null,{enableHighAccuracy:true,maximumAge:10000});
}

// Animated route drawing
function animateRoutes(){
  if(!leafletMap)return;
  mapLayers.routes.forEach(line=>{
    const latlngs=line.getLatLngs();
    const tempLine=L.polyline([],{...line.options,opacity:line.options.opacity||0.8}).addTo(leafletMap);
    line.setStyle({opacity:0});
    let i=0;
    const step=()=>{
      if(i>=latlngs.length)return;
      tempLine.addLatLng(latlngs[i]);
      i++;
      requestAnimationFrame(step);
    };
    step();
  });
}

/* ═══════════════════════ EKSPORTER DAGBOK SOM PDF ═══════════════════════ */
function exportDiaryPDF(foreword){
  const entries=[...S.diary].sort((a,b)=>(a.ts||0)-(b.ts||0));
  if(entries.length===0){showToast("Ingen dagbokinnlegg å eksportere ennå.");return;}
  const win=window.open("","_blank");
  if(!win){showToast("Tillat popup-vinduer for å eksportere PDF.");return;}

  const css=[
    "*{box-sizing:border-box;margin:0;padding:0;}",
    "body{font-family:Georgia,serif;background:#fff;color:#1a1a1a;max-width:680px;margin:0 auto;padding:32px 24px;}",
    "h1{font-size:28px;font-weight:700;text-align:center;margin-bottom:4px;}",
    ".entry{break-inside:avoid;margin-bottom:36px;padding-bottom:28px;border-bottom:1px solid #e0d5c5;}",
    ".entry-date{font-size:11px;font-family:sans-serif;font-weight:700;text-transform:uppercase;letter-spacing:1.2px;color:#c9913a;margin-bottom:5px;}",
    ".entry-title{font-size:21px;font-weight:700;margin-bottom:6px;}",
    ".entry-meta{display:flex;gap:10px;font-size:11px;color:#888;font-family:sans-serif;margin-bottom:14px;flex-wrap:wrap;}",
    ".entry-meta span{background:#f5f0ea;padding:2px 8px;border-radius:10px;}",
    ".photos{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:14px;}",
    ".photos img{width:100%;aspect-ratio:1;object-fit:cover;border-radius:6px;}",
    ".entry-text{font-size:14px;line-height:1.8;white-space:pre-wrap;color:#2a2a2a;}",
    ".comments-section{margin-top:14px;padding-top:12px;border-top:1px solid #f0e8dc;}",
    ".comments-title{font-size:10px;font-family:sans-serif;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:#888;margin-bottom:8px;}",
    ".comment{margin-bottom:8px;padding:8px 10px;background:#faf7f2;border-left:3px solid #e0d0b0;border-radius:0 6px 6px 0;}",
    ".comment-author{font-size:11px;font-weight:700;font-family:sans-serif;color:#c9913a;}",
    ".comment-text{font-size:13px;margin-top:2px;line-height:1.5;}",
    ".reactions-row{display:flex;gap:8px;flex-wrap:wrap;margin-top:10px;}",
    ".reaction-pill{font-size:13px;padding:3px 10px;background:#f5f0ea;border-radius:20px;font-family:sans-serif;}",
    ".cover{text-align:center;padding:60px 20px 40px;border-bottom:2px solid #e0d5c5;margin-bottom:40px;}",
    ".cover-em{font-size:64px;margin-bottom:16px;}",
    ".cover h1{font-size:36px;margin-bottom:8px;}",
    ".foreword{margin:0 auto 36px;max-width:560px;break-inside:avoid;}",
    ".foreword-title{font-size:11px;font-family:sans-serif;font-weight:800;text-transform:uppercase;letter-spacing:2px;color:#c9913a;text-align:center;margin-bottom:14px;}",
    ".foreword-text{font-size:15.5px;line-height:1.9;color:#2a2a2a;font-style:italic;text-align:justify;}",
    ".foreword-text::first-letter{font-size:46px;font-weight:700;float:left;line-height:1;margin:2px 8px 0 0;color:#c9913a;font-style:normal;}",
    ".toc{margin-bottom:36px;padding:20px;background:#faf7f2;border-radius:8px;}",
    ".toc-title{font-size:12px;font-family:sans-serif;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:#888;margin-bottom:12px;}",
    ".toc-item{font-size:13px;line-height:1.9;}",
    ".no-print,.toc-dot{color:#c9913a;}",
    "@media print{.no-print{display:none!important;}body{padding:12px;}.entry{break-inside:avoid;}}"
  ].join("\n");

  function xe(s){return String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;");}
  function fmtDate(ts,opts){return ts?new Date(ts).toLocaleDateString("no-NO",opts):"";}

  const tocItems=entries.map(function(e){
    const day=e.dayIdx!=null?DAYS[e.dayIdx]:null;
    return "<div class='toc-item'><span style='color:#c9913a'>●</span> "+xe(e.title||"Uten tittel")+(day?" — "+day.d:"")+"</div>";
  }).join("");

  const entryBlocks=entries.map(function(e){
    const day=e.dayIdx!=null?DAYS[e.dayIdx]:null;
    const comments=S.comments[e.id]||[];
    const rxs=S.reactions[e.id]||{};
    const rxHtml=Object.entries(rxs).filter(function(kv){return kv[1].length>0;}).map(function(kv){return "<span class='reaction-pill'>"+kv[0]+" "+kv[1].length+"</span>";}).join("");
    // Sikkerhet: e.photos kommer fra anon-skrivbar Supabase. Slipp bare gjennom
    // http(s)-URLer (safeUrl) og attributt-escape dem, ellers kan en injisert
    // «' onerror='…'» kjøre JS i appens origin (stored XSS).
    const photos=(e.photos||[]).map(function(p){const u=safeUrl(p);return u?"<img src='"+xe(u)+"' crossorigin='anonymous'>":"";}).join("");

    let html="<div class='entry'>";
    if(day) html+="<div class='entry-date'>"+day.d+" · "+xe(day.title)+"</div>";
    html+="<div class='entry-title'>"+xe(e.title||"Uten tittel")+"</div>";
    html+="<div class='entry-meta'>";
    if(e.author) html+="<span>✍️ "+xe(e.author)+"</span>";
    if(e.mood)   html+="<span>"+xe(e.mood)+"</span>";
    if(e.ts)     html+="<span>"+fmtDate(e.ts,{day:"numeric",month:"long",year:"numeric"})+"</span>";
    html+="</div>";
    if(photos) html+="<div class='photos'>"+photos+"</div>";
    if(e.text) html+="<div class='entry-text'>"+xe(e.text)+"</div>";
    if(rxHtml) html+="<div class='reactions-row'>"+rxHtml+"</div>";
    if(comments.length>0){
      html+="<div class='comments-section'><div class='comments-title'>💬 "+comments.length+" kommentar"+(comments.length!==1?"er":"")+"</div>";
      comments.forEach(function(c){
        html+="<div class='comment'>";
        html+="<div class='comment-author'>"+xe(c.author||"Anonym")+" · "+fmtDate(c.ts,{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})+"</div>";
        html+="<div class='comment-text'>"+xe(c.text)+"</div>";
        html+="</div>";
      });
      html+="</div>";
    }
    html+="</div>";
    return html;
  }).join("");

  const totalPhotos=entries.reduce(function(s,e){return s+(e.photos||[]).length;},0);
  const totalComments=Object.values(S.comments).reduce(function(s,a){return s+a.length;},0);
  const exportDate=new Date().toLocaleDateString("no-NO",{day:"numeric",month:"long",year:"numeric"});

  const html=[
    "<!DOCTYPE html><html lang='no'><head><meta charset='UTF-8'>",
    "<title>Canada &amp; Alaska 2026 - Reisedagbok</title>",
    "<style>"+css+"</style></head><body>",
    "<div class='no-print' style='position:fixed;top:0;left:0;right:0;background:#c9913a;color:#fff;padding:12px 20px;display:flex;justify-content:space-between;align-items:center;font-family:sans-serif;z-index:100'>",
    "<span style='font-weight:700'>Reisedagbok - Canada &amp; Alaska 2026</span>",
    "<button onclick='window.print()' style='background:#fff;color:#c9913a;border:none;border-radius:8px;padding:8px 18px;font-weight:700;cursor:pointer;font-size:14px'>Lagre som PDF</button>",
    "</div><div style='height:52px'></div>",
    "<div class='cover'><div class='cover-em'>🍁</div>",
    "<h1>Canada &amp; Alaska 2026</h1>",
    "<div style='font-size:15px;color:#666;margin-bottom:4px'>Robert, Margita &amp; Nicholas · 17. juli – 3. august 2026</div>",
    "<div style='font-size:13px;color:#999;margin-top:8px;font-family:sans-serif'>"+entries.length+" innlegg · "+totalPhotos+" bilder · "+totalComments+" kommentarer</div>",
    "</div>",
    foreword?"<div class='foreword'><div class='foreword-title'>Forord</div><div class='foreword-text'>"+xe(foreword)+"</div></div>":"",
    "<div class='toc'><div class='toc-title'>Innhold</div>"+tocItems+"</div>",
    entryBlocks,
    "<div style='text-align:center;padding:40px 20px;color:#aaa;font-size:12px;font-family:sans-serif'>",
    "Eksportert "+exportDate+"</div>",
    "</body></html>"
  ].join("");

  win.document.write(html);
  win.document.close();
}

// Reisebok-generator (#20): ber Claude skrive et forord ut fra alle
// dagbok-innlegg, deretter åpner den ferdige PDF-en med forordet foran.
// Faller pent tilbake til vanlig PDF uten forord (offline / for få innlegg).
async function makeReisebok(){
  const entries=[...S.diary].sort((a,b)=>(a.ts||0)-(b.ts||0));
  if(entries.length===0){showToast("Ingen dagbokinnlegg å lage reisebok av ennå.");return;}
  if(entries.length<2||!navigator.onLine){ exportDiaryPDF(); return; }
  const btn=document.getElementById("reisebok-btn");
  const prev=btn?btn.textContent:"";
  if(btn){btn.disabled=true;btn.textContent="✨ Skriver forord…";}
  haptic("medium");
  let foreword=null;
  try{ foreword=await generateForeword(entries); }catch{}
  if(btn){btn.disabled=false;btn.textContent=prev||"📖 Reisebok";}
  if(foreword)haptic("success");
  exportDiaryPDF(foreword||undefined);
}

// Auto-sync when saving — registered via state.js save hook
setSaveHook(type=>{
  if(!S.syncEnabled) return;
  if(type==="acts"||type==="budget"||type==="pack") syncAllToCloud();
});

/* ═══════════════════════ INIT ═══════════════════════ */
loadStorage();
loadTheme();
initSplash();
renderNav();
renderPage();
updateCountdown();
// Supabase-avhengig oppstart utsettes til neste tick. main.js og cloud.js
// importerer hverandre sirkulært; leses cloud-eksporter (SB_READY m.fl.)
// synkront her, kan de ligge i temporal dead zone og kaste — noe som ville
// avbrutt resten av modulen (inkl. Object.assign(window,…) nederst) og gjort
// ALLE onclick-handlere udefinerte («ingenting fungerer»). Ved å utsette til
// etter at modulgrafen er ferdig evaluert, er bindingene garantert klare.
setTimeout(()=>{
  try{
    if(SB_READY && navigator.onLine) startRealtime();
    if(SB_READY) docsInit();
    if(SB_READY && S.syncEnabled && navigator.onLine){loadSharedState();startSharedRealtime();}
  }catch(e){ console.warn("Supabase-oppstart feilet",e); }
},0);

// Sync-kø: oppdater pending-badge når køen endres
function updateSyncBadge(n){
  const el=document.getElementById("sync-pending");
  if(!el) return;
  if(n>0){ el.textContent=`⏳ ${n} venter`; el.style.display=""; }
  else { el.style.display="none"; el.textContent=""; }
}
onSyncChange(updateSyncBadge);
updateSyncBadge(pendingCount());

// F07: Service worker + offline-status (erstatter den gamle direkte registreringen)
initOffline();

// Re-render hjem-vy når offline-status endrer seg, så strip'en oppdateres
onOfflineChange(() => {
  if (S.tab === "idag" && (!S.sub || S.sub === "oversikt")) renderPage();
});

// Kart-stil-toggle: editorial (MapLibre papir) vs detaljert (Leaflet)
window.toggleMapStyle = function(){
  S.mapStyle = (S.mapStyle === "editorial") ? "detaljert" : "editorial";
  // Når brukeren i feltjournal går til detaljert, default til lys/sand-tile
  // for visuell konsistens med papir-stilen ellers i appen.
  if(S.mapStyle === "detaljert" && document.body.classList.contains("feltjournal")){
    S.mapTile = "light";
  }
  if(S.tab === "reisen" && S.sub === "kart") renderPage();
};

// Fullskjerm-toggle på kart-fanen — flytt map-wrap til body for å unngå
// stacking-context-fellen fra .page (som har transform via fade-up).
let _mapWrapOrigParent = null;
let _mapWrapOrigNextSib = null;
window.toggleMapFullscreen = function(){
  const wrap = document.querySelector('.map-wrap');
  if(!wrap) return;
  const isFs = !wrap.classList.contains('map-fullscreen');
  const btn = document.getElementById('map-fs-btn');

  if(isFs){
    // Husk hvor wrap var
    _mapWrapOrigParent = wrap.parentElement;
    _mapWrapOrigNextSib = wrap.nextSibling;
    document.body.appendChild(wrap);
    wrap.classList.add('map-fullscreen');
    document.body.classList.add('map-fullscreen-on');
    if(btn) btn.innerHTML = '⛶ Lukk';
  } else {
    wrap.classList.remove('map-fullscreen');
    document.body.classList.remove('map-fullscreen-on');
    if(_mapWrapOrigParent){
      if(_mapWrapOrigNextSib && _mapWrapOrigNextSib.parentElement === _mapWrapOrigParent){
        _mapWrapOrigParent.insertBefore(wrap, _mapWrapOrigNextSib);
      } else {
        _mapWrapOrigParent.appendChild(wrap);
      }
    }
    if(btn) btn.innerHTML = '⛶';
  }
  // Re-bind etter at CSS er anvendt + 1 frame så container har riktig størrelse.
  // B1-fiks: MapLibre's projeksjon henger etter når .map-wrap reparentes til body
  // (mister stacking-context fra .page sin transform). Kall .resize() to ganger
  // — først rett etter klassebyttet, så etter at layout har stabilisert seg.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if(typeof leafletMap !== 'undefined' && leafletMap) leafletMap.invalidateSize();
      resizeMapFj();
      if(typeof bindKart === 'function') bindKart();
      // Andre resize: noen mobile nettlesere trenger en runde til etter
      // at safe-area-insets og toolbar-høyder er beregnet.
      setTimeout(() => resizeMapFj(), 220);
    });
  });
};

// «Pakk for neste etappe»: precache de neste 3–7 dagene
window.precacheNextLeg = async function(){
  const tripDay = getTripDay();
  const from = tripDay < 0 ? 0 : tripDay;
  const to = Math.min(DAYS.length - 1, from + 6);
  await precacheTrip(from, to, "Neste etappe");
  refreshStatus();
};

// F02: hent hjerte-status ved oppstart og hvert 5. minutt
refreshHearts().then(() => { if(S.tab==="idag") renderPage(); }).catch(()=>{});
setInterval(() => {
  refreshHearts().then(() => { if(S.tab==="idag") renderPage(); }).catch(()=>{});
}, 5 * 60 * 1000);

// Eksponer manuell sync for følg-med-modus (kan trigges fra Mer-drawer senere)
window.syncPublicFollow = syncPublicFollow;

// «Hva er nytt»-modul
window.openChangelog = openChangelog;
window.closeChangelog = closeChangelog;

// Injiser Nytt-pille i topbar/mobile-hdr ved oppstart
function mountNewsPill(){
  if(unseenCount() === 0) return;
  const pillHtml = renderNewsPill();
  const tb = document.querySelector('.topbar > div:last-child');
  if(tb && !tb.querySelector('.fj-news-pill')){
    tb.insertAdjacentHTML('afterbegin', pillHtml);
  }
  const mh = document.querySelector('.mobile-hdr > div > div:last-child');
  if(mh && !mh.querySelector('.fj-news-pill')){
    mh.insertAdjacentHTML('afterbegin', pillHtml);
  }
}
// Retry et par ganger så vi treffer etter at DOM er klar
if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(mountNewsPill));
} else {
  requestAnimationFrame(mountNewsPill);
}
setTimeout(mountNewsPill, 500);
setTimeout(mountNewsPill, 1500);

// PWA: install-prompt + iOS-hint
initPWA();

// V8: Live location — auto-resume + re-render når peers oppdaterer
maybeResumeLiveSharing();
onPeersChange(() => { if (S.tab === 'idag') renderPage(); });

// Offline banner
function showOfflineBanner(show){
  let banner=document.getElementById("offline-banner");
  if(show&&!banner){
    banner=document.createElement("div");
    banner.id="offline-banner";
    banner.style.cssText="position:fixed;top:0;left:0;right:0;z-index:9998;background:#dc2626;color:#fff;font-size:13px;font-weight:600;text-align:center;padding:8px 16px;font-family:var(--font);transition:transform .3s ease;transform:translateY(0)";
    banner.innerHTML="📡 Ingen internettforbindelse — lagret innhold vises offline";
    document.body.appendChild(banner);
  } else if(!show&&banner){
    banner.style.transform="translateY(-100%)";
    setTimeout(()=>banner?.remove(),300);
  }
}
if(!navigator.onLine)showOfflineBanner(true);

window.addEventListener("online",  ()=>{
  showOfflineBanner(false);
  if(S.tab==="ai"||S.tab==="dagbok")renderPage();
  if(SB_READY)startRealtime();
});
window.addEventListener("offline", ()=>{
  showOfflineBanner(true);
  if(S.tab==="ai"||S.tab==="dagbok")renderPage();
});
window.addEventListener("keydown",e=>{if(e.key==="Escape"){closeModal();closeMer();closeSearch();}});
setTimeout(()=>{
  if(S.tab==="klar"&&S.sub==="valuta")calcCurrency();
  if(S.tab==="klar"&&S.sub==="drivstoff")calcFuel();
  updateCountdown();
},50);

// Expose functions referenced by inline HTML handlers (onclick, oninput, etc.)
// Required because this script is loaded as type="module" — module-scoped
// declarations are not global by default.
/* ── Diktering for dagbok (V6) ── */
let _dictation = null;
let _dictationBaseText = '';
function toggleDictation(){
  const ta = document.getElementById('de-text');
  const btn = document.getElementById('de-mic-btn');
  const status = document.getElementById('de-mic-status');
  if (!ta) return;
  if (_dictation){
    // Stopp
    btn?.classList.remove('mic-on');
    if (status) status.textContent = 'Behandler lyd…';
    _dictation.stop().then(({text, blob}) => {
      if (status) status.textContent = blob ? `Lagret ${(blob.size/1024).toFixed(0)} kB lyd` : '';
      _dictation = null;
      // Lagre lyd-blob til state for evt. opplasting
      if (blob && S.diaryEdit) S.diaryEdit._audioBlob = blob;
      haptic('success');
      setTimeout(() => { if (status) status.textContent = ''; }, 4000);
    });
    return;
  }
  // Start
  _dictationBaseText = ta.value;
  haptic('medium');
  btn?.classList.add('mic-on');
  if (status) status.textContent = '🔴 Lytter… trykk igjen for å stoppe';
  _dictation = startDictation({
    lang: 'nb-NO',
    onTranscript: (text, isFinal) => {
      const sep = _dictationBaseText && !_dictationBaseText.endsWith('\n') && !_dictationBaseText.endsWith(' ') ? ' ' : '';
      ta.value = _dictationBaseText + sep + text;
      ta.scrollTop = ta.scrollHeight;
    },
    onError: (err) => {
      if (status) status.textContent = '⚠️ ' + err;
      btn?.classList.remove('mic-on');
      _dictation = null;
      haptic('error');
    }
  });
}

/* ── #7 Post-dag AI-refleksjon ── */
async function aiReflect(){
  const sel = document.getElementById('de-day');
  let dayIdx = sel && sel.value !== '' ? parseInt(sel.value) : getTripDay();
  if (!(dayIdx >= 0)) { showToast('Velg hvilken dag innlegget gjelder først'); return; }
  const btn = document.getElementById('de-ai-btn');
  const ta = document.getElementById('de-text');
  if (!ta) return;
  if (!navigator.onLine) { showToast('AI-kladd krever nett'); return; }
  const lbl = btn?.querySelector('.mic-lbl');
  const prevLbl = lbl?.textContent;
  if (lbl) lbl.textContent = 'Skriver…';
  if (btn) btn.disabled = true;
  haptic('medium');
  try {
    const text = await draftReflection(dayIdx);
    if (text) {
      ta.value = ta.value.trim() ? ta.value.trim() + '\n\n' + text : text;
      ta.dispatchEvent(new Event('input'));
      haptic('success');
      showToast('✨ Kladd satt inn — rediger fritt');
    } else {
      showToast('Kunne ikke hente kladd akkurat nå');
    }
  } finally {
    if (lbl) lbl.textContent = prevLbl || 'AI-kladd';
    if (btn) btn.disabled = false;
  }
}

Object.assign(window, {
  setTab, setSub, toggleTheme, toggleAcc, toggleClimate, toggleDay, toggleChk, togglePackChk,
  toggleDictation, toggleFamilyShare, aiReflect,
  toggleGps, toggleReaction, toggleDiaryOpen,
  openAddModal, openBudgetModal, openLightbox, openSearch, closeModal, closeMer, closeSearch,
  openGalleryLb, galLbNav, closeGalleryLb, lbNav,
  saveActModal, saveBudgetModal, saveBudgetTarget, saveDiaryEdit,
  editAct, editBudgetTarget, deleteAct, deleteBudgetEntry, deleteComment,
  newDiaryEntry, writeDiaryForDay, refreshDiary, addDiaryPhotos, removeDiaryPhoto, setDiaryMood,
  postComment, exportDiaryPDF, exportPlanPDF, exportPackPDF, makeReisebok, eveningReflect, shareDiaryEntry,
  docsSignIn, docsSignUp, docsSignOut, docsSetAuthMode, docsUpload, docsView, docsDelete, aiIndexAll,
  vaultUpload, vaultOpen, vaultRemove, vaultUnlock, vaultSavePin,
  vaultStartPin, vaultLock, vaultRemovePin, vaultCancelPin,
  sendChat, sendQuick, chatKey, destAiSend, destAiQuick, copyFrase,
  setMapFilter, setMapTile, flyToStop, cacheTilesForRoute,
  enableFamilySync, disableFamilySync, syncAllToCloud,
  enableNotifications, requestLocationTip,
  calcCurrency, calcFuel, autoConvertBudget, autoConvertBudget2, updateCarousel,
  carouselNav, resetPacking, shareDayPlan, showShareModal, doSearch, toggleTop,
  setShareTarget, copyShareUrl, nativeShare,
  downloadICS, addFromSuggestion, showDiagnostics, clearDiagnostics,
  calcTip, callNumber,
  // Eksponert for inline onclick som muterer state direkte (S.destIdx=…;renderPage())
  S, renderPage,
  openQuickAsk, closeQuickAsk, toggleQuickAsk,
  reloadAlerts, checkFlight, prepareAllOffline,
  // Vær-fanen: stedsvelger (onchange) + manuell oppdatering av time-tabellen
  loadAndShowWeather, refreshWeatherMatrix,
});

bindQuickAskHotkey();

// Boot-smoke + data-integritet (kun i dev — fjernes helt i produksjonsbygg).
// Fanger (a) at sirkulær import har drept window-handlerne, og (b) inkonsistens
// i innholdsmodellen. Begge feiler stille i prod, så vi vil vite det i dev.
if (import.meta.env?.DEV) {
  const critical = ['setTab','toggleDay','toggleChk','toggleTop','renderPage'];
  const missing = critical.filter(k => typeof window[k] !== 'function');
  if (missing.length) console.error('[boot-smoke] Manglende window-handlere:', missing);
  else console.info('[boot-smoke] OK — kritiske handlere er koblet på window');
  import('./data-check.js').then(m => {
    const p = m.checkDataIntegrity();
    if (p.length) { console.error(`[data-check] ${p.length} problem(er):`); p.forEach(x => console.error('  · ' + x)); }
    else console.info('[data-check] OK — innholdsmodellen er konsistent');
  });
}
